/* TITAN AI診断 本体スクリプト
   本体 section が Shopify の 256KB テンプレート制限に達したため外部アセット化 (2026-07-24)
   Liquid依存は section 側が #gs-boot に埋める JSON (window.__GS_BOOT) 経由で受け取る
   - sid     : セクション固有ID (セレクタ用)
   - verb    : '相談' or '診断' (consult設定による文言切替)
   - imgBase : ゲーム画像のasset base URL
   - catalog : Shopify実商品カタログ */
(function(){
  var CFG = (window.__GS_BOOT || {});
(function(){
  function addRipple(btn, e) {
    var rect = btn.getBoundingClientRect();
    var ripple = document.createElement('span');
    ripple.className = 'wz-ripple';
    var size = Math.max(rect.width, rect.height);
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - rect.left - size/2) + 'px';
    ripple.style.top = (e.clientY - rect.top - size/2) + 'px';
    btn.appendChild(ripple);
    setTimeout(function(){ ripple.remove(); }, 500);
  }
  document.querySelectorAll('.wz-btn-cta, .wz-btn-next, .wz-rbtn').forEach(function(btn){
    btn.addEventListener('click', function(e){ addRipple(btn, e); });
  });

  document.getElementById('WzApp').addEventListener('click', function(e){
    var btn = e.target.closest('.wz-rbtn');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.wz-rcard');
    if (card) { card.classList.add('wz-launching'); addRipple(btn, e); }
    var href = btn.getAttribute('href');
    setTimeout(function(){ if (href) window.location.href = href; }, 350);
  });
  document.getElementById('WzApp').addEventListener('error', function(e){
    var img = e.target;
    if (!img || !img.classList) return;
    var isCaseThumb = img.classList.contains('gs-rank__case-thumb');
    var isProductImage = img.classList.contains('gs-rank__img');
    if (!isCaseThumb && !isProductImage) return;
    var fallback = img.getAttribute('data-fallback-src') || '';
    if (fallback && img.getAttribute('src') !== fallback) {
      img.removeAttribute('data-fallback-src');
      img.src = fallback;
      return;
    }
    if (isCaseThumb) img.replaceWith(caseThumbPlaceholder());
    else {
      var productPlaceholder = document.createElement('div');
      productPlaceholder.className = 'gs-rank__img gs-rank__img--none';
      productPlaceholder.setAttribute('aria-hidden', 'true');
      productPlaceholder.textContent = 'TITAN';
      img.replaceWith(productPlaceholder);
    }
  }, true);
  window.addEventListener('pageshow', function(){
    document.querySelectorAll('.wz-launching').forEach(function(el){ el.classList.remove('wz-launching'); });
  });

  (function(){
    var m = document.getElementById('wzMascot');
    if (!m) return;
    var srcDef = m.dataset.srcDefault, srcAlt = m.dataset.srcAlt;
    var busy = false;
    var preload = new Image(); preload.src = srcAlt;
    function swapTo(src, duration) {
      if (busy) return; busy = true; m.src = src;
      if (duration) { setTimeout(function(){ m.src = srcDef; busy = false; }, duration); }
      else { busy = false; }
    }
    m.addEventListener('click', function(){ swapTo(srcAlt, 2000); });
    m.addEventListener('mouseenter', function(){ if (!busy) m.src = srcAlt; });
    m.addEventListener('mouseleave', function(){ if (!busy) m.src = srcDef; });
    setInterval(function(){ swapTo(srcAlt, 5000); }, 60000);
  })();

  var API = 'https://pc-ai-relay.vercel.app/api/chat';
  var SESSION_KEY = 'wz_session_id';
  var GUARD_KEY = 'wz_guard_v1';
  var BLOCK_KEY = 'wz_blocked_v1';
  var RATE_MS = 3000;
  var SPAM_WINDOW = 60 * 1000;
  var _SALT = 'T1t4nG#2025xQ';
  function _djb2(s){var h=5381;for(var i=0;i<s.length;i++){h=((h<<5)+h+s.charCodeAt(i))>>>0;}return h.toString(36);}
  function _sign(){var t=Math.floor(Date.now()/1000);return{_t:t,_k:_djb2(_SALT+':'+t)};}
  var SPAM_LIMIT = 8;
  var BLOCK_TTL = 24 * 60 * 60 * 1000;
  var DIAG_HOUR_KEY = 'wz_diag_hour_v1';
  var DIAG_HOUR_LIMIT = 10;
  var DIAG_HOUR_WINDOW = 60 * 60 * 1000;
  var GS_PRODUCT_CATALOG = CFG.catalog || [];

  function checkDiagLimit() {
    try {
      var raw = localStorage.getItem(DIAG_HOUR_KEY);
      var data = raw ? JSON.parse(raw) : { ts: [] };
      var now = Date.now();
      data.ts = (data.ts || []).filter(function(t){ return now - t < DIAG_HOUR_WINDOW; });
      if (data.ts.length >= DIAG_HOUR_LIMIT) return false;
      data.ts.push(now);
      localStorage.setItem(DIAG_HOUR_KEY, JSON.stringify(data));
      return true;
    } catch(e) { return true; }
  }
  function getDiagRemaining() {
    try {
      var raw = localStorage.getItem(DIAG_HOUR_KEY);
      var data = raw ? JSON.parse(raw) : { ts: [] };
      var now = Date.now();
      data.ts = (data.ts || []).filter(function(t){ return now - t < DIAG_HOUR_WINDOW; });
      return Math.max(0, DIAG_HOUR_LIMIT - data.ts.length);
    } catch(e) { return DIAG_HOUR_LIMIT; }
  }

  var sessionId = localStorage.getItem(SESSION_KEY);
  if (!sessionId) { sessionId = 'wz_' + Math.random().toString(36).slice(2) + Date.now(); localStorage.setItem(SESSION_KEY, sessionId); }

  function isBlocked() {
    var raw = localStorage.getItem(BLOCK_KEY);
    if (!raw) return false;
    try { var o = JSON.parse(raw); if (Date.now() - (o.ts || 0) >= BLOCK_TTL) { localStorage.removeItem(BLOCK_KEY); return false; } return true; }
    catch(e) { localStorage.removeItem(BLOCK_KEY); return false; }
  }
  function setBlocked() { localStorage.setItem(BLOCK_KEY, JSON.stringify({ts: Date.now()})); }
  function getGuard() { try { return JSON.parse(localStorage.getItem(GUARD_KEY) || '{"events":[]}'); } catch(e) { return {events:[]}; } }
  function checkAndRecordSpam() {
    var now = Date.now(), g = getGuard();
    g.events = (g.events || []).filter(function(t){ return now - t < SPAM_WINDOW; });
    g.events.push(now);
    localStorage.setItem(GUARD_KEY, JSON.stringify(g));
    if (g.events.length > SPAM_LIMIT) { setBlocked(); return true; }
    return false;
  }

  var lastCallTime = 0, calling = false;

  var GAME_IMG_BASE = CFG.imgBase;
  var GAMES = [
    {k:'valorant',n:'VALORANT',short:'VALORANT',img:'game-valorant.png',genre:'fps'},
    {k:'apex',n:'Apex Legends',short:'APEX LEGENDS',img:'game-apex.png',genre:'fps'},
    {k:'fortnite',n:'Fortnite',short:'フォートナイト',img:'game-fortnite.png',genre:'fps'},
    {k:'gtav',n:'GTA V',short:'GTA V',img:'game-gta5.png',genre:'open'},
    {k:'minecraft',n:'Minecraft',short:'マインクラフト',img:'game-minecraft.png',genre:'sandbox'},
    {k:'genshin',n:'原神',short:'原神',img:'game-genshin.png',genre:'mmo'},
    {k:'mhwilds',n:'モンスターハンターワイルズ',short:'MH WILDS',img:'game-mhwilds.png',genre:'action'},
    {k:'sf6',n:'ストリートファイター6',short:'STREET FIGHTER 6',img:'game-sf6.png',genre:'fight'},
    {k:'cyberpunk',n:'Cyberpunk 2077',short:'CYBERPUNK 2077',img:'game-cyberpunk-2077.png',genre:'open'},
    {k:'lol',n:'リーグ・オブ・レジェンド',short:'LoL',img:'game-lol.png',genre:'moba'},
    {k:'bf6',n:'バトルフィールド6',short:'BATTLEFIELD 6',img:'game-bf6.png',genre:'fps'},
    {k:'ark',n:'ARK',short:'ARK',img:'game-ark.png',genre:'sandbox'},
    {k:'wuwa',n:'鳴潮',short:'鳴潮',img:'game-wuwa.png',genre:'mmo'},
    {k:'tarkov',n:'Escape from Tarkov',short:'ESCAPE FROM TARKOV',img:'game-tarkov.png',genre:'fps'},
    {k:'nte',n:'Neverness to Everness',short:'NTE',img:'game-nte.png',genre:'mmo'},
    {k:'zzz',n:'ゼンレスゾーンゼロ',short:'ZZZ',img:'game-zzz.png',genre:'action'},
    {k:'forza6',n:'Forza Horizon 6',short:'FORZA HORIZON 6',img:'game-forza-horizon-6-v3.jpg',genre:'racing'},
    {k:'meccha_chameleon',n:'めっちゃカメレオン',short:'めっちゃカメレオン',img:'game-meccha-chameleon-v3.jpg',genre:'party'},
    {k:'beast_reincarnation',n:'Beast of Reincarnation',short:'BEAST OF REINCARNATION',img:'game-beast-of-reincarnation-v3.jpg',genre:'action'},
    {k:'marvel_tokon',n:'MARVEL TŌKON: Fighting Souls',short:'MARVEL TŌKON',img:'game-marvel-tokon-v3.jpg',genre:'fight'}
  ];

  /* Time Spy基準。解像度・配信の下限と比較し、最も重い条件を採用する */
  var GAME_MIN_SCORES = {
    valorant: {FHD:6000, WQHD:6000, '4K':7000},
    apex: {FHD:8800, WQHD:10500, '4K':13900},
    fortnite: {FHD:8800, WQHD:10500, '4K':13900},
    gtav: {FHD:6278, WQHD:8800, '4K':10500},
    minecraft: {FHD:6278, WQHD:8800, '4K':10500},
    genshin: {FHD:6278, WQHD:8800, '4K':10500},
    mhwilds: {FHD:13900, WQHD:17500, '4K':22500},
    sf6: {FHD:8800, WQHD:10500, '4K':13900},
    cyberpunk: {FHD:13900, WQHD:17500, '4K':27700},
    lol: {FHD:6000, WQHD:6000, '4K':7000},
    bf6: {FHD:13900, WQHD:17500, '4K':22500},
    ark: {FHD:13900, WQHD:17500, '4K':22500},
    wuwa: {FHD:10259, WQHD:13900, '4K':17500},
    tarkov: {FHD:10259, WQHD:13900, '4K':17500},
    nte: {FHD:13900, WQHD:17500, '4K':22500},
    zzz: {FHD:7000, WQHD:8800, '4K':10500},
    forza6: {FHD:11690, WQHD:15650, '4K':22500},
    meccha_chameleon: {FHD:6000, WQHD:6000, '4K':7000},
    beast_reincarnation: {FHD:11690, WQHD:15650, '4K':22500},
    marvel_tokon: {FHD:8800, WQHD:10500, '4K':13900},
    'Cyberpunk 2077': {FHD:13900, WQHD:17500, '4K':27700},
    'モンスターハンターワイルズ': {FHD:13900, WQHD:17500, '4K':22500},
    'Forza Horizon 6': {FHD:11690, WQHD:15650, '4K':22500},
    'めっちゃカメレオン': {FHD:6000, WQHD:6000, '4K':7000},
    'Beast of Reincarnation': {FHD:11690, WQHD:15650, '4K':22500},
    'MARVEL TŌKON: Fighting Souls': {FHD:8800, WQHD:10500, '4K':13900},
    'Black Myth: Wukong': {FHD:15200, WQHD:22500, '4K':27700},
    'FF7 リバース': {FHD:13900, WQHD:17500, '4K':22500}
  };

  /* AI-010: 自由入力サジェスト辞書 (表記揺れ吸収・GAMES外の人気タイトル) */
  var GAME_SUGGEST = [
    {n:'Cyberpunk 2077', a:['cyberpunk','サイバーパンク','cyber','cp2077','サイパン']},
    {n:'Apex Legends', a:['apex','エーペックス','apexlegends']},
    {n:'VALORANT', a:['valorant','ヴァロラント','ヴァロ','バロ']},
    {n:'Fortnite', a:['fortnite','フォートナイト','フォトナ']},
    {n:'Minecraft', a:['minecraft','マインクラフト','マイクラ']},
    {n:'原神', a:['genshin','原神','genshinimpact','げんしん']},
    {n:'崩壊：スターレイル', a:['starrail','スターレイル','崩壊','honkai','スタレ']},
    {n:'ゼンレスゾーンゼロ', a:['zenless','zzz','ゼンレス','ゾーンゼロ']},
    {n:'Forza Horizon 6', a:['forza','forza6','fh6','フォルツァ','フォルツァホライゾン6']},
    {n:'めっちゃカメレオン', a:['meccha','mecchachameleon','めっちゃカメレオン','メッチャカメレオン','カメレオン']},
    {n:'Beast of Reincarnation', a:['beast','beastofreincarnation','ビーストオブリンカネーション','ビースト','輪廻の獣']},
    {n:'MARVEL TŌKON: Fighting Souls', a:['marveltokon','marvel tokon','tokon','tōkon','マーベルトーコン','トーコン','fighting souls']},
    {n:'鳴潮', a:['wuwa','wutheringwaves','鳴潮','なるしお','めいちょう']},
    {n:'FF14', a:['ff14','ffxiv','ファイナルファンタジー14','エオルゼア','ff 14']},
    {n:'FF7 リバース', a:['ff7','ff7rebirth','ff7r','rebirth','ファイナルファンタジー7']},
    {n:'モンスターハンターワイルズ', a:['mhwilds','mhwl','wilds','モンハンワイルズ','モンハン']},
    {n:'モンスターハンターライズ', a:['mhrise','rise','モンハンライズ']},
    {n:'モンスターハンターワールド', a:['mhw','world','モンハンワールド','モンスターハンターワールド','worldiceborne','iceborne']},
    {n:'ELDEN RING', a:['eldenring','elden','エルデンリング','エルデン']},
    {n:'Dark Souls III', a:['darksouls','ダクソ','ds3','dark souls']},
    {n:'SEKIRO', a:['sekiro','隻狼','せきろ']},
    {n:'Black Myth: Wukong', a:['wukong','blackmyth','黒神話','悟空']},
    {n:'GTA V', a:['gta','gtav','gta5','grandtheftauto','グランドセフトオート']},
    {n:'GTA VI', a:['gta6','gtavi','gta 6']},
    {n:'Red Dead Redemption 2', a:['rdr2','reddead','レッドデッド','rdr']},
    {n:'ストリートファイター6', a:['sf6','streetfighter6','ストファイ','street fighter']},
    {n:'鉄拳8', a:['tekken','tekken8','鉄拳']},
    {n:'スマブラSP', a:['smash','smashbros','スマブラ','sb']},
    {n:'Roblox', a:['roblox','ロブロックス']},
    {n:'Among Us', a:['amongus','アモアス','アモングアス']},
    {n:'Counter-Strike 2', a:['cs2','counterstrike','カウンターストライク','cs']},
    {n:'Call of Duty: Modern Warfare III', a:['cod','codmw','callofduty','コール オブ デューティ','mw3','warzone']},
    {n:'Overwatch 2', a:['overwatch','ow2','オーバーウォッチ']},
    {n:'Rainbow Six Siege', a:['r6','r6s','rainbowsix','レインボーシックス','シージ']},
    {n:'Battlefield 2042', a:['bf','battlefield','バトルフィールド','bf2042','bf6']},
    {n:'PUBG', a:['pubg','plーびー','pubgmobile']},
    {n:'Diablo IV', a:['diablo','diablo4','ディアブロ']},
    {n:'Lost Ark', a:['lostark','ロストアーク']},
    {n:'Path of Exile 2', a:['poe','poe2','pathofexile','パスオブエグザイル']},
    {n:'World of Warcraft', a:['wow','warcraft','worldofwarcraft','ワウ']},
    {n:'League of Legends', a:['lol','leagueoflegends','リーグオブレジェンド']},
    {n:'Dota 2', a:['dota','dota2','ドータ']},
    {n:'Marvel Rivals', a:['rivals','marvelrivals','マーベルライバルズ']},
    {n:'Helldivers 2', a:['helldivers','helldivers2','ヘルダイバー','ヘルダイバーズ']},
    {n:'BALATRO', a:['balatro','バラトロ']},
    {n:'Stardew Valley', a:['stardew','stardewvalley','スターデュー']},
    {n:'Hogwarts Legacy', a:['hogwarts','hogwartslegacy','ホグワーツ']},
    {n:'Starfield', a:['starfield','スターフィールド']},
    {n:'Baldurs Gate 3', a:['bg3','baldursgate','バルダーズゲート']},
    {n:'Resident Evil 4 Remake', a:['re4','residentevil','バイオハザード','re4remake']},
    {n:'Diablo Immortal', a:['immortal','ディアブロイモータル']},
    {n:'ウマ娘 プリティーダービー', a:['ウマ娘','umamusume','umamusumeprettyderby']},
    {n:'Wuthering Waves', a:['wuwa','wutheringwaves','鳴潮']},
    {n:'Phasmophobia', a:['phasmo','phasmophobia','ファズモ']},
    {n:'Palworld', a:['palworld','パルワールド','パル']}
  ];

  var TOTAL = 4; /* 質問は4ステップ (S1〜S4)。S5は確認画面なので別表示 */
  var LABELS = {
    /* comfort */
    fhd_smooth:'フルHDで滑らかに', wqhd_quality:'WQHDで高画質', '4k':'4Kで高画質', vr:'VRで遊ぶ', unsure:'おすすめに任せる',
    /* 2026-08-17: casual が未定義で「GTA V を casual で遊ぶ」と生キーが露出していた */
    casual:'ゲームは軽めで十分',
    /* usage */
    gaming_only:'ゲーム', streaming:'ゲーム配信', creation:'動画編集', ai_use:'生成AI・ローカルAI', work_study:'仕事・学業',
    /* budget */
    '0':'予算おまかせ','150000':'10〜15万','200000':'15〜20万','250000':'20〜25万','300000':'25〜30万','999999':'30万以上',
    /* buyMode */
    'new':'新品のみ', 'cheap':'安さ優先',
    /* 旧 → 互換 (シェアテキスト等で参照) */
    FHD:'フルHD', WQHD:'WQHD', '4K':'4K',
    competitive:'高fps優先', fps:'快適fps', quality:'高画質', balance:'バランス',
    no:'しない', sometimes:'たまに', yes:'がっつり', any:'どちらでもOK'
  };

  /* 新state */
  var sel = {games:[], comfort:null, usage:null, usages:[], usageDetails:{}, budget:null, budgetMin:'0', budgetAnswered:false, buyMode:'new',
    /* 見た目の希望(任意): rgb = yes|no|null, size = big|small|null */
    look:{rgb:null, size:null}};

  /* 予算スライダー定数 (max端 = 上限なし) */
  var BUDGET_MIN = 100000, BUDGET_MAX = 450000, BUDGET_STEP = 10000;

  /* 予算表示の共通フォーマッタ: LABELS固定マップに依存しない */
  function formatBudget(v){
    var s = String(v == null ? '' : v);
    if (s === '' ) return '未設定';
    if (s === '0' || s === '999999' || s === 'unlimited') return '予算上限なし';
    var n = parseInt(s, 10);
    if (!isFinite(n)) return '未設定';
    if (n >= BUDGET_MAX) return '予算上限なし';
    return (n / 10000) + '万円以下';
  }

  /* 旧wz_prev / 旧離散値からの正規化 */
  function normalizeBudget(raw){
    var s = String(raw == null ? '' : raw);
    if (s === '0' || s === '999999' || s === 'unlimited') return { budget:'0', answered:true };
    var n = parseInt(s, 10);
    if (!isFinite(n)) return { budget:null, answered:false };
    if (n >= BUDGET_MAX) return { budget:'0', answered:true };
    if (n < BUDGET_MIN) n = BUDGET_MIN;
    return { budget:String(n), answered:true };
  }

  /* 新state → 旧形式互換のレガシービュー (preImpossible/プロンプト で使う) */
  function legacy() {
    var resMap = {fhd_smooth:'FHD', wqhd_quality:'WQHD', '4k':'4K', vr:'WQHD', unsure:'FHD'};
    var priMap = {fhd_smooth:'fps', wqhd_quality:'quality', '4k':'quality', vr:'quality', unsure:'balance'};
    var strMap = {gaming_only:'no', streaming:'yes', creation:'sometimes', ai_use:'no', work_study:'no'};
    var condMap = {new:'new', cheap:'new'};
    /* usagesから代表値抽出 (優先度: ai_use > streaming > creation > work_study > gaming_only) */
    var usagesList = (sel.usages && sel.usages.length) ? sel.usages : (sel.usage ? [sel.usage] : []);
    var priority = ['ai_use','streaming','creation','work_study','gaming_only'];
    var repUsage = null;
    for (var pi = 0; pi < priority.length; pi++){
      if (usagesList.indexOf(priority[pi]) >= 0){ repUsage = priority[pi]; break; }
    }
    return {
      games: sel.games,
      res: resMap[sel.comfort] || 'FHD',
      pri: priMap[sel.comfort] || 'balance',
      str: usagesList.indexOf('streaming') >= 0
        ? 'yes'
        : (usagesList.indexOf('creation') >= 0 ? 'sometimes' : 'no'),
      usages: usagesList,
      usageDetailUsage: activeUsageDetailType(usagesList),
      usageDetailValue: sel.usageDetails && sel.usageDetails[activeUsageDetailType(usagesList)] || null,
      usageDetailLabel: selectedUsageDetailLabel(usagesList),
      bud: (!sel.budget || sel.budget === '0' || sel.budget === 0) ? 'unlimited' : sel.budget,
      cond: condMap[sel.buyMode] || 'any'
    };
  }
  var cur = 0;
  var __budCeil = Infinity;
  /* 直近の診断で使った必要GPUスコア(Time Spy)。結果カードの性能余裕バーに使う */
  var __minS = 0;
  var root = document.getElementById('WzApp');
  if (!root) return;

  var $ = function(id){ return document.getElementById(id); };
  var steps = root.querySelectorAll('.wz-s');
  var bar = $('wzBar'), counter = $('wzCount');

  var USAGE_DETAIL_COPY = {
    ai_use: {
      question: '使いたいAIモデルやソフトはありますか？',
      label: '希望するAI・ソフト',
      example: 'Stable Diffusion、ComfyUI、Ollama、動かしたいモデル名'
    },
    streaming: {
      question: '配信したいゲームや、配信画質の希望はありますか？',
      label: '配信内容',
      example: 'OBSでVALORANTをフルHD・60fps配信、YouTube'
    },
    creation: {
      question: '編集する動画の解像度や、使用ソフトはありますか？',
      label: '編集内容',
      example: 'Premiere Proで4K編集、TikTok動画中心'
    },
    work_study: {
      question: 'よく使うソフトや、同時に行う作業はありますか？',
      label: '使用ソフト・作業内容',
      example: 'Chromeを多く開く、Excel、CAD'
    },
    gaming_only: {
      question: 'ほかに遊び方の希望はありますか？',
      label: 'ゲームの詳細',
      example: 'MODを使う、録画もする、静音重視'
    }
  };

  var USAGE_DETAIL_CONFIG = {
    ai_use: {
      question: 'AIで何をしたいですか？',
      help: '使うソフトが決まっていなくても大丈夫です。近いものを1つ選んでください。',
      options: [
        ['ai_image_try', '画像生成を試してみたい'],
        ['ai_image_pro', '高解像度・大量の画像を生成したい'],
        ['ai_video_train', '動画生成や追加学習もしたい'],
        ['ai_local_llm', '文章AIを自分のPCで動かしたい'],
        ['ai_unsure', 'まだ決めていない・おまかせ']
      ]
    },
    creation: {
      question: 'どんな動画を編集しますか？',
      help: '扱う動画に最も近いものを1つ選んでください。',
      options: [
        ['edit_fhd_short', 'フルHDの短い動画を編集する'],
        ['edit_daily_4k', 'YouTube向けにフルHD〜4Kを日常的に編集する'],
        ['edit_heavy_4k', '4K以上・長尺・エフェクト多め'],
        ['edit_unsure', 'まだ決めていない・おまかせ']
      ]
    },
    streaming: {
      question: '配信スタイルに近いものはどれですか？',
      help: '配信と同時に行う作業を基準に選んでください。',
      options: [
        ['stream_fhd_game', 'ゲームをしながらフルHDで配信'],
        ['stream_advanced', '高画質・複数カメラ・凝った画面で配信'],
        ['stream_talk', '雑談・顔出し中心'],
        ['stream_unsure', 'まだ決めていない・おまかせ']
      ]
    },
    work_study: {
      question: 'PCでよく使う作業はどれですか？',
      help: '最も負荷が高そうな作業を1つ選んでください。',
      options: [
        ['work_office', 'Office・ブラウザ・オンライン会議'],
        ['work_multitask', '会議をしながら複数の作業'],
        ['work_heavy', 'CAD・3D・イラスト・開発'],
        ['work_light', '特に重い作業はしない']
      ]
    }
  };

  function activeUsageDetailType(usages){
    usages = Array.isArray(usages) ? usages : [];
    var priority = ['ai_use', 'creation', 'streaming', 'work_study'];
    for (var i = 0; i < priority.length; i++){
      if (usages.indexOf(priority[i]) >= 0) return priority[i];
    }
    return null;
  }

  function selectedUsageDetailLabel(usages){
    var usage = activeUsageDetailType(usages);
    var value = usage && sel.usageDetails ? sel.usageDetails[usage] : null;
    var config = usage && USAGE_DETAIL_CONFIG[usage];
    if (!value || !config) return '';
    var option = config.options.find(function(item){ return item[0] === value; });
    return option ? (LABELS[usage] + ': ' + option[1]) : '';
  }

  function updateUsageDetailChoices(){
    var block = $('gsUsageDetail');
    var question = $('gsUsageDetailQuestion');
    var help = $('gsUsageDetailHelp');
    var options = $('gsUsageDetailOptions');
    if (!block || !question || !help || !options) return;

    var usages = (sel.usages && sel.usages.length) ? sel.usages.slice() : (sel.usage ? [sel.usage] : []);
    var usage = activeUsageDetailType(usages);
    var config = usage && USAGE_DETAIL_CONFIG[usage];
    if (!config){
      block.hidden = true;
      options.innerHTML = '';
      return;
    }

    block.hidden = false;
    block.dataset.usage = usage;
    question.textContent = config.question;
    help.textContent = config.help;
    var selected = sel.usageDetails && sel.usageDetails[usage];
    options.innerHTML = config.options.map(function(item){
      var isOn = item[0] === selected;
      return '<button type="button" class="gs-usage-detail__opt' + (isOn ? ' is-on' : '') + '" data-usage-detail="' + item[0] + '" aria-pressed="' + (isOn ? 'true' : 'false') + '">' + esc(item[1]) + '</button>';
    }).join('');
  }

  function updateUsageDetailPrompt(){
    var station = root.querySelector('.gs-station[data-station="budget"]');
    var request = $('wzRequest');
    if (!station || !request) return;

    var usages = (sel.usages && sel.usages.length) ? sel.usages.slice() : (sel.usage ? [sel.usage] : []);
    var question = station.querySelector('.gs-station__q');
    var help = station.querySelector('.gs-station__help');
    var label = station.querySelector('label[for="wzRequest"]');
    var questionText = '予算や見た目など、希望条件はありますか？';
    var helpText = '指定した条件を候補選びに反映します。未指定でも診断できます。';
    var labelText = 'その他の希望';
    var placeholder = '例：静音重視、メモリ32GB、白いケース';

    if (usages.length === 1 && USAGE_DETAIL_COPY[usages[0]]) {
      var copy = USAGE_DETAIL_COPY[usages[0]];
      questionText = copy.question;
      helpText = '分かる範囲で入力すると、必要な性能をより正確に提案できます。未指定でも診断できます。';
      labelText = copy.label;
      placeholder = '例：' + copy.example;
    } else if (usages.length > 1) {
      questionText = '使いたいソフトや、作業内容を教えてください。';
      helpText = '用途ごとの使い方を分かる範囲で入力すると、必要な性能をより正確に提案できます。';
      labelText = '用途の詳細';
      var examples = usages.map(function(usage){
        return USAGE_DETAIL_COPY[usage] ? USAGE_DETAIL_COPY[usage].example : '';
      }).filter(Boolean).slice(0, 2);
      if (examples.length) placeholder = '例：' + examples.join('／');
    }

    questionText = '用途に合わせて、希望条件を教えてください。';
    helpText = '用途の詳しさ、予算、見た目を候補選びに反映します。未指定でも診断できます。';

    if (question) question.textContent = questionText;
    if (help) help.textContent = helpText;
    if (label) {
      var textNode = Array.prototype.find.call(label.childNodes, function(node){ return node.nodeType === 3; });
      if (textNode) textNode.nodeValue = labelText + ' ';
    }
    request.placeholder = placeholder;
    updateUsageDetailChoices();
  }

  function gameName(k) { var g = GAMES.find(function(x){return x.k===k;}); return g ? g.n : k; }

  function setPitIntroLoading(isLoading){
    [
      ['.gs-pit__intro-tag', '診断中'],
      ['.gs-pit__intro-title', '候補を比較しています'],
      ['.gs-pit__intro-guide', '回答内容から、本命と比較候補を選んでいます。']
    ].forEach(function(item){
      var el = root.querySelector(item[0]);
      if (!el) return;
      if (isLoading){
        if (!el.dataset.gsIdleText) el.dataset.gsIdleText = el.textContent;
        el.textContent = item[1];
      } else if (el.dataset.gsIdleText){
        el.textContent = el.dataset.gsIdleText;
        delete el.dataset.gsIdleText;
      }
    });
  }

  /* ロード演出の表示制御 */
  function showLoader(){
    var loader = document.getElementById('gsLoader');
    if (!loader) return;
    loader.hidden = false;
    loader.removeAttribute('hidden');
    loader.classList.remove('is-hidden');
    loader.setAttribute('aria-hidden', 'false');
    /* AI待ち中は入力ウィザードを隠す(質問と進捗が二重に見えるため) */
    var pitEl = document.getElementById('gsPit');
    if (pitEl) pitEl.classList.add('is-loading');
    setPitIntroLoading(true);
    runPitLoader();
    /* ボード自体をローディング状態に + 表示 */
    var board = root.querySelector('.gs-board');
    if (board){
      board.classList.add('is-loading');
      board.style.display = '';
    }
    /* CTA を変身 */
    var cta = document.getElementById('wzDiagnose');
    if (cta){
      cta.disabled = true;
      var m = cta.querySelector('.gs-pit__cta-main');
      var s = cta.querySelector('.gs-pit__cta-sub');
      if (m){ cta.dataset.origMain = m.textContent; m.textContent = '診断中…'; }
      if (s){ cta.dataset.origSub = s.textContent; s.textContent = '上の進捗をご覧ください'; }
    }
  }
  function hideLoader(){
    var loader = document.getElementById('gsLoader');
    if (!loader) return;
    loader.hidden = true;
    loader.setAttribute('hidden', '');
    loader.classList.add('is-hidden');
    loader.setAttribute('aria-hidden', 'true');
    var pitEl2 = document.getElementById('gsPit');
    if (pitEl2) pitEl2.classList.remove('is-loading');
    setPitIntroLoading(false);
    resetPitLoader();
    var board = root.querySelector('.gs-board');
    if (board){
      board.classList.remove('is-loading');
      if (board.classList.contains('gs-board--loaderonly')) board.style.display = 'none';
    }
    /* CTA 文字を元に戻す */
    var cta = document.getElementById('wzDiagnose');
    if (cta && cta.dataset.origMain){
      var m = cta.querySelector('.gs-pit__cta-main');
      var s = cta.querySelector('.gs-pit__cta-sub');
      if (m) m.textContent = cta.dataset.origMain;
      if (s) s.textContent = cta.dataset.origSub;
      delete cta.dataset.origMain;
      delete cta.dataset.origSub;
    }
  }

  /* PIT LANE: 1画面ダッシュボード型なので go(n) は最小限。
     - n=6: PIT本体を隠してロード演出を出す
     - n=7: ロードを隠して結果S7を表示
     - n=0/1〜5: PIT本体を表示状態に戻す (再診断のリセット) */
  function go(n) {
    cur = n;
    var pit = document.getElementById('gsPit');
    var loader = document.getElementById('gsLoader');
    var results = root.querySelector('[data-s="7"]');
    if (pit){ pit.style.display = (n === 7) ? 'none' : ''; }
    if (loader){
      if (n === 6) showLoader();
      else hideLoader();
    }
    /* 結果ステップ active クラスでアニメーション */
    if (results){
      results.classList.remove('active','wz-slide-back');
      if (n === 7) results.classList.add('active');
    }
    /* ステップインジケーター更新: 01=入力(0〜5)、02=AI解析(6)、03=結果(7) */
    (function(){
      var s1=$('gsStep1'), s2=$('gsStep2'), s3=$('gsStep3');
      [s1,s2,s3].forEach(function(s){ if (s) s.classList.remove('is-active','is-done'); });
      if (n <= 5){ if (s1) s1.classList.add('is-active'); }
      else if (n === 6){ if (s1) s1.classList.add('is-done'); if (s2) s2.classList.add('is-active'); }
      else if (n === 7){ if (s1) s1.classList.add('is-done'); if (s2) s2.classList.add('is-done'); if (s3) s3.classList.add('is-active'); }
    })();
    /* スクロール調整:
       - n=6 (ロード) は PIT LANE ボード (loader含む) を画面中央付近に出す
       - n=7 (結果) は結果セクションを画面に入れる */
    if (n === 6) {
      var board3 = root.querySelector('.gs-board');
      if (board3){
        var rectB = board3.getBoundingClientRect();
        var inViewB = rectB.top >= 0 && rectB.top <= window.innerHeight * 0.3;
        if (!inViewB){
          window.scrollTo({top: rectB.top + window.scrollY - 60, behavior:'smooth'});
        }
      }
    } else if (n === 7 && results) {
      var rect = results.getBoundingClientRect();
      var inView = rect.top >= 0 && rect.top <= window.innerHeight * 0.5;
      if (!inView){
        window.scrollTo({top: rect.top + window.scrollY - 24, behavior:'smooth'});
      }
      requestAnimationFrame(function(){
        var resultTitle = $('wzResultTitle');
        if (resultTitle) resultTitle.focus({ preventScroll: true });
      });
    }
  }

  /* 表示中の%と同じしきい値で、確認項目を active → locked に進める。 */
  function resetPitLoader(){
    root.querySelectorAll('.gs-loader__lamp').forEach(function(el){
      el.classList.remove('is-active','is-locked');
      var st = el.querySelector('.gs-loader__state'); if (st) st.textContent = '…';
    });
  }
  function syncPitLoaderToPct(pct, complete){
    var locksAt = [30, 55, 80];
    root.querySelectorAll('.gs-loader__lamp').forEach(function(el, idx){
      var locked = complete || (idx < locksAt.length && pct >= locksAt[idx]);
      var active = !locked && (idx === 0 || pct >= locksAt[idx - 1]);
      el.classList.toggle('is-locked', locked);
      el.classList.toggle('is-active', active);
      var st = el.querySelector('.gs-loader__state');
      if (st) st.textContent = locked ? '確認済み' : (active ? '確認中' : '…');
    });
  }
  function runPitLoader(){
    resetPitLoader();
    syncPitLoaderToPct(0, false);
  }

  function finishPitLoader(){
    syncPitLoaderToPct(100, true);
  }

  /* 旧 wzStart 互換 (前回診断モーダル等で使用)。PIT版では1画面なので何もしない */
  var startBtn = $('wzStart'); if (startBtn) startBtn.addEventListener('click', function(){ /* noop */ });

  /* Windowsフレームは撤去済みのため close ハンドラ不要 */

  var gGrid = $('wzGames');
  /* ゲームアートタイル生成: 16:9 ダーク背景 + tone色グラデ + 中央タイトル
     モバイル初期表示は上位4タイトル、それ以降は data-extra="1" で hidden (AI-012) */
  var GAME_INITIAL_MOBILE = 4;
  gGrid.innerHTML = GAMES.map(function(g, idx){
    var genre = g.genre || 'other';
    var label = g.short || g.n;
    var extra = idx >= GAME_INITIAL_MOBILE ? ' data-extra="1"' : '';
    var imgUrl = g.img ? (GAME_IMG_BASE + g.img) : '';
    var loading = idx < GAME_INITIAL_MOBILE ? 'eager' : 'lazy';
    return '<button class="wz-tile gs-tile gs-art gs-art--photo" data-gk="'+g.k+'" data-genre="'+genre+'"'+extra+' type="button" aria-label="'+label+'" aria-pressed="false">'
      + (imgUrl ? '<img class="gs-art__img" src="'+imgUrl+'" alt="" loading="'+loading+'" decoding="async" width="640" height="360">' : '<span class="gs-art__bg" aria-hidden="true"></span>')
      + '<span class="gs-art__shade" aria-hidden="true"></span>'
      + '<span class="gs-art__label gs-art__label--sr">'+label+'</span>'
      + '<span class="gs-art__check" aria-hidden="true"></span>'
      + '</button>';
  }).join('');
  /* モバイル時の「もっと見る」展開トグル */
  (function(){
    var moreBtn = document.getElementById('gsGameExpand');
    if (!moreBtn) return;
    var expanded = false;
    moreBtn.addEventListener('click', function(){
      expanded = !expanded;
      gGrid.classList.toggle('is-expanded', expanded);
      moreBtn.textContent = expanded ? 'ゲーム一覧を閉じる' : 'ゲームをもっと見る（残り'+(GAMES.length - GAME_INITIAL_MOBILE)+'件）';
      moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
    moreBtn.textContent = 'ゲームをもっと見る（残り'+(GAMES.length - GAME_INITIAL_MOBILE)+'件）';
  })();

  function syncGames() {
    gGrid.querySelectorAll('.wz-tile').forEach(function(t){
      var selected = sel.games.indexOf(t.dataset.gk) >= 0;
      t.classList.toggle('on', selected);
      t.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    var custom = sel.games.filter(function(k){ return !GAMES.some(function(g){return g.k===k;}); });
    $('wzGameChips').innerHTML = custom.map(function(k){ return '<span class="wz-chip gs-chip">'+esc(k)+'<button type="button" class="wz-chip-x gs-chip-x" data-rm="'+esc(k)+'" aria-label="'+esc(k)+'を選択から削除">×</button></span>'; }).join('');
    /* PIT LANE: 旧 wzN1 disabled は不要。新ステート関数を呼ぶ */
    if (typeof updateStationStates === 'function') updateStationStates();
    if (typeof updateLiveMeter === 'function') updateLiveMeter();
    if (typeof updateCtaState === 'function') updateCtaState();
    /* 互換: 旧 wzN1 が存在すれば disabled 制御 */
    var n1 = $('wzN1'); if (n1) n1.disabled = sel.games.length === 0;
  }

  function syncChoiceControls(){
    root.querySelectorAll('.gs-opt-list[data-field]').forEach(function(grid){
      var field = grid.dataset.field;
      grid.querySelectorAll('.gs-opt, .wz-opt').forEach(function(opt){
        var selected = field === 'usage'
          ? sel.usages.indexOf(opt.dataset.v) >= 0
          : sel[field] === opt.dataset.v;
        opt.classList.toggle('on', selected);
        opt.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    });
    root.querySelectorAll('.gs-look__opt').forEach(function(btn){
      var group = btn.getAttribute('data-look-group');
      var selected = !!group && sel.look[group] === btn.getAttribute('data-look-val');
      btn.classList.toggle('is-on', selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  gGrid.addEventListener('click', function(e){
    var t = e.target.closest('[data-gk]'); if (!t) return;
    var k = t.dataset.gk, i = sel.games.indexOf(k);
    if (i >= 0) sel.games.splice(i, 1); else { sel.games.push(k); t.classList.add('wz-just-selected'); setTimeout(function(){ t.classList.remove('wz-just-selected'); }, 250); }
    syncGames();
  });
  $('wzGameChips').addEventListener('click', function(e){ var rm = e.target.dataset.rm; if (!rm) return; var i = sel.games.indexOf(rm); if (i >= 0) sel.games.splice(i, 1); syncGames(); });
  $('wzGameAdd').addEventListener('click', function(){
    var inp = $('wzGameInput'), v = inp.value.trim();
    if (v && sel.games.indexOf(v) < 0) { sel.games.push(v); inp.value = ''; hideSuggest(); syncGames(); }
  });
  $('wzGameInput').addEventListener('keydown', function(e){
    if (e.key === 'Enter') { e.preventDefault(); $('wzGameAdd').click(); }
    else if (e.key === 'Escape') { hideSuggest(); }
  });
  /* AI-010: 入力ライブサジェスト */
  (function(){
    var inp = $('wzGameInput');
    var list = document.getElementById('gsSuggestList');
    if (!inp || !list) return;
    function norm(s){ return String(s||'').toLowerCase().replace(/\s+/g,'').replace(/[ー－—\-]/g,''); }
    function search(q){
      var nq = norm(q); if (!nq) return [];
      var hits = [];
      for (var i = 0; i < GAME_SUGGEST.length && hits.length < 6; i++){
        var g = GAME_SUGGEST[i];
        var keys = [g.n].concat(g.a || []).map(norm);
        var matched = false;
        for (var j = 0; j < keys.length; j++){
          if (keys[j].indexOf(nq) >= 0){ matched = true; break; }
        }
        if (matched) hits.push(g.n);
      }
      return hits;
    }
    function render(items){
      if (!items.length){ hideSuggest(); return; }
      list.innerHTML = items.map(function(n){
        return '<li class="gs-suggest-item" role="option" tabindex="0">'+n.replace(/</g,'&lt;')+'</li>';
      }).join('');
      list.hidden = false;
    }
    function hideSuggest(){ list.hidden = true; list.innerHTML = ''; }
    window.__gsHideSuggest = hideSuggest;
    inp.addEventListener('input', function(){
      var v = this.value.trim();
      if (v.length === 0){ hideSuggest(); return; }
      render(search(v));
    });
    list.addEventListener('click', function(e){
      var li = e.target.closest('.gs-suggest-item'); if (!li) return;
      inp.value = li.textContent;
      hideSuggest();
      inp.focus();
    });
    inp.addEventListener('blur', function(){
      setTimeout(hideSuggest, 150);
    });
  })();
  function hideSuggest(){ if (window.__gsHideSuggest) window.__gsHideSuggest(); }
  $('wzN1').addEventListener('click', function(){ go(2); });

  (function(){
    var hints = {};
    root.querySelectorAll('.wz-nav').forEach(function(nav){
      var btn = nav.querySelector('.wz-btn-next');
      if (!btn) return;
      var h = document.createElement('div'); h.className = 'wz-nav-hint'; h.textContent = '選択すると次へ進めます';
      nav.appendChild(h); hints[btn.id] = h;
    });
    function updateHints(){ Object.keys(hints).forEach(function(id){ var btn = $(id); if (btn) hints[id].classList.toggle('show', btn.disabled); }); }
    new MutationObserver(updateHints).observe(root, {subtree:true, attributes:true, attributeFilter:['disabled']});
    updateHints();
  })();

  $('wzGameMore').addEventListener('click', function(){ $('wzGameOther').style.display = ''; this.style.display = 'none'; $('wzGameInput').focus(); });

  /* PIT LANE: 各ステーションの選択イベント。選択ごとに LIVE METER 更新 + CTA 状態更新
     - data-multi="1" の grid は複数選択トグル。usage は usages[] にも反映 */
  root.querySelectorAll('.gs-opt-list[data-field]').forEach(function(grid){
    var field = grid.dataset.field;
    var isMulti = grid.dataset.multi === '1';
    grid.addEventListener('click', function(e){
      var opt = e.target.closest('.gs-opt, .wz-opt'); if (!opt) return;
      var v = opt.dataset.v;
      if (isMulti){
        /* 複数選択トグル */
        if (field === 'usage'){
          if (!Array.isArray(sel.usages)) sel.usages = [];
          var idx = sel.usages.indexOf(v);
          if (idx >= 0){ sel.usages.splice(idx, 1); opt.classList.remove('on'); opt.setAttribute('aria-pressed', 'false'); }
          else { sel.usages.push(v); opt.classList.add('on'); opt.setAttribute('aria-pressed', 'true'); opt.classList.add('wz-just-selected'); }
          /* 代表値を sel.usage に保持: 優先度 ai_use > streaming > creation > work_study > gaming_only */
          var priority = ['ai_use','streaming','creation','work_study','gaming_only'];
          var picked = null;
          for (var i = 0; i < priority.length; i++){
            if (sel.usages.indexOf(priority[i]) >= 0){ picked = priority[i]; break; }
          }
          sel.usage = picked;
        } else {
          /* 他のmulti fieldは汎用処理 (今はないが拡張用) */
          sel[field] = v;
        }
      } else {
        /* 単一選択 */
        sel[field] = v;
        grid.querySelectorAll('.gs-opt, .wz-opt').forEach(function(o){ o.classList.remove('on'); o.setAttribute('aria-pressed', 'false'); });
        opt.classList.add('on'); opt.setAttribute('aria-pressed', 'true'); opt.classList.add('wz-just-selected');
      }
      setTimeout(function(){ opt.classList.remove('wz-just-selected'); }, 250);
      updateStationStates();
      updateLiveMeter();
      updateCtaState();
      /* AI-015: 選択イベント */
      if (typeof pushGA === 'function') pushGA('ai_diag_select', { field: field, value: v });
    });
  });
  (function(){
    var options = $('gsUsageDetailOptions');
    if (!options) return;
    options.addEventListener('click', function(e){
      var button = e.target.closest ? e.target.closest('.gs-usage-detail__opt') : null;
      var block = $('gsUsageDetail');
      var usage = block && block.dataset.usage;
      var value = button && button.getAttribute('data-usage-detail');
      if (!button || !usage || !value) return;
      if (!sel.usageDetails) sel.usageDetails = {};
      sel.usageDetails[usage] = value;
      options.querySelectorAll('.gs-usage-detail__opt').forEach(function(option){
        var selected = option === button;
        option.classList.toggle('is-on', selected);
        option.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      updateLiveMeter();
      if (typeof pushGA === 'function') pushGA('ai_diag_select', { field:'usage_detail_' + usage, value:value });
    });
  })();
  /* 見た目の希望(任意) 2026-08-17
     同じ値をもう一度押すと解除できる(任意項目なので取り消せる必要がある)。 */
  (function(){
    var wrap = document.querySelector('[data-field-look]');
    if(!wrap) return;
    wrap.addEventListener('click', function(e){
      var btn = e.target.closest ? e.target.closest('.gs-look__opt') : null;
      if(!btn || !wrap.contains(btn)) return;
      var group = btn.getAttribute('data-look-group');
      var val = btn.getAttribute('data-look-val');
      if(!group || !val) return;
      var isOn = btn.classList.contains('is-on');
      wrap.querySelectorAll('.gs-look__opt[data-look-group="' + group + '"]')
        .forEach(function(b){ b.classList.remove('is-on'); b.setAttribute('aria-pressed','false'); });
      if(isOn){
        sel.look[group] = null;               /* 再クリックで解除 */
      } else {
        btn.classList.add('is-on');
        btn.setAttribute('aria-pressed','true');
        sel.look[group] = val;
      }
      if (typeof pushGA === 'function') pushGA('ai_diag_select', { field:'look_' + group, value: sel.look[group] || 'none' });
    });
  })();

  /* 予算スライダー: 下限/上限の2本 (2026-08-17)
     - 動かすまでは budgetAnswered=false = 予算条件なしで診断する
       (初期値が入っていると触っていないのに20万円指定に見えてしまう)
     - 下限は sel.budgetMin に保持。上限を超えないようクランプする */
  (function(){
    var range = $('gsBudgetRange');
    var rangeMin = $('gsBudgetMin');
    var valueEl = $('gsBudgetValue');
    var pair = $('gsBudgetPair');
    if (!range) return;

    /* 選択範囲(下限〜上限)を親の1本バーに塗る */
    function paintTrack(){
      if(!pair) return;
      function pct(v){ return ((v - BUDGET_MIN) / (BUDGET_MAX - BUDGET_MIN)) * 100; }
      var lo = rangeMin ? pct(parseInt(rangeMin.value, 10)) : 0;
      var hi = pct(parseInt(range.value, 10));
      if (lo > hi) { var t = lo; lo = hi; hi = t; }
      pair.style.setProperty('--gs-lo', lo + '%');
      pair.style.setProperty('--gs-hi', hi + '%');
    }

    /* 表示文: 下限/上限の組み合わせで出し分ける */
    function budgetLabel(){
      if (!sel.budgetAnswered) return '指定なし';
      var lo = parseInt(sel.budgetMin, 10) || 0;
      var hiRaw = parseInt(range.value, 10);
      var noHi = hiRaw >= BUDGET_MAX;
      if (lo <= BUDGET_MIN && noHi) return '指定なし';
      if (lo <= BUDGET_MIN) return formatBudget(sel.budget);
      if (noHi) return (lo / 10000) + '万円以上';
      return (lo / 10000) + '万〜' + (hiRaw / 10000) + '万円';
    }

    function syncBudgetUI(){
      paintTrack();
      if (!valueEl) return;
      var unset = !sel.budgetAnswered;
      var txt = budgetLabel();
      valueEl.textContent = txt;
      valueEl.classList.toggle('is-unset', unset);
      range.classList.toggle('is-unset', unset);
      if (rangeMin) rangeMin.classList.toggle('is-unset', unset);
      if (pair) pair.classList.toggle('is-unset', unset);
      range.setAttribute('aria-valuetext', txt);
      if (rangeMin) rangeMin.setAttribute('aria-valuetext', txt);
    }
    window.__gsSyncBudgetUI = syncBudgetUI;

    /* max端は「上限なし」= 内部的に '0' (legacy()が unlimited に変換) */
    function readRange(){
      var n = parseInt(range.value, 10);
      return (n >= BUDGET_MAX) ? '0' : String(n);
    }

    /* 下限が上限を追い越さないようにする(1ステップ分の間隔を確保) */
    function clamp(movedMin){
      if (!rangeMin) return;
      var lo = parseInt(rangeMin.value, 10);
      var hi = parseInt(range.value, 10);
      if (lo <= hi - BUDGET_STEP) return;
      if (movedMin) range.value = Math.min(BUDGET_MAX, lo + BUDGET_STEP);
      else rangeMin.value = Math.max(BUDGET_MIN, hi - BUDGET_STEP);
    }

    function commit(movedMin, fire){
      clamp(movedMin);
      sel.budget = readRange();
      sel.budgetMin = String(rangeMin ? (parseInt(rangeMin.value, 10) || 0) : 0);
      sel.budgetAnswered = true;
      syncBudgetUI();
      updateStationStates();
      if (fire) updateLiveMeter();
      updateCtaState();
      if (fire && typeof pushGA === 'function'){
        pushGA('ai_diag_select', { field:'budget', value: sel.budgetMin + '-' + sel.budget });
      }
    }

    range.addEventListener('input',  function(){ commit(false, false); });
    range.addEventListener('change', function(){ commit(false, true); });
    if (rangeMin){
      rangeMin.addEventListener('input',  function(){ commit(true, false); });
      rangeMin.addEventListener('change', function(){ commit(true, true); });
    }
    syncBudgetUI();
  })();

  /* 旧 wz-btn-back / wz-btn-next は PIT LANE では不要だが、念のためフォールバック */
  root.querySelectorAll('.wz-btn-back[data-go]').forEach(function(btn){
    btn.addEventListener('click', function(){ go(parseInt(this.dataset.go) || 0); });
  });

  /* ステーション充足ステート (左の赤ライン点灯) */
  function selectedUsageList(){
    return (sel.usages && sel.usages.length) ? sel.usages : (sel.usage ? [sel.usage] : []);
  }
  function requiresGameProfile(){
    var usageList = selectedUsageList();
    return usageList.indexOf('gaming_only') >= 0 || usageList.indexOf('streaming') >= 0;
  }
  function updateStationStates(){
    updateUsageDetailPrompt();
    var hasUsage = (sel.usages && sel.usages.length > 0) || !!sel.usage;
    var needsGame = requiresGameProfile();
    var stations = {
      title:  !needsGame || sel.games.length > 0,
      comfort: !needsGame || !!sel.comfort,
      usage:   hasUsage,
      budget:  sel.budgetAnswered
    };
    Object.keys(stations).forEach(function(k){
      var el = root.querySelector('.gs-station[data-station="'+k+'"]');
      if (el) el.classList.toggle('is-filled', stations[k]);
    });
    if (typeof window.__gsWizRefresh === 'function') window.__gsWizRefresh();
    var seal = root.querySelector('.gs-pit__seal');
    var filledCount = Object.keys(stations).filter(function(k){ return stations[k]; }).length;
    var allReady = filledCount === 4;
    if (seal){
      seal.classList.toggle('is-ready', allReady);
      var label = seal.querySelector('.gs-pit__seal-label');
      if (label) label.textContent = allReady ? '準備OK' : ('入力 ' + filledCount + ' / 4');
    }
  }

  /* LIVE METER: 選択内容から GPU/CPU/RAM/冷却 の必要度を概算してバー反映 */
  function updateLiveMeter(){
    /* バー要素が存在しなければ早期return (ボード簡素化済み) */
    if (!document.getElementById('gsBarFillGpu')) return;
    /* 何も選んでない時はプレースホルダ表示にして「未確定感」を出す */
    var hasAnyInput = sel.games.length > 0 || sel.comfort || sel.usage || sel.budget;
    var board = document.querySelector('#tg-gss-' + CFG.sid + ' .gs-board');
    if (board) board.classList.toggle('is-pristine', !hasAnyInput);
    if (!hasAnyInput){
      ['Gpu','Cpu','Ram','Cool'].forEach(function(p){
        var fill = document.getElementById('gsBarFill'+p);
        var val  = document.getElementById('gsBarVal'+p);
        if (fill) fill.style.width = '0%';
        if (val) val.textContent = '—';
      });
      var statusEl0 = document.getElementById('gsMeterStatus');
      if (statusEl0) statusEl0.textContent = '未選択';
      var sumEl0 = document.getElementById('gsMeterSummary');
      if (sumEl0) sumEl0.innerHTML = '<p class="gs-meter__hint">遊ぶゲームと画質を選ぶとここに目安が出ます</p>';
      return;
    }
    /* 基準値 */
    var gpu = 15, cpu = 15, ram = 15, cool = 15;
    /* ゲーム数 (重みづけ): 1本ごとに+8、4本以上は飽和 */
    var gn = Math.min(sel.games.length, 6);
    gpu += gn * 6;
    cpu += gn * 3;
    /* 重いタイトル名から推測 (簡易) */
    var heavyKeywords = ['cyberpunk','cyber','elden','starfield','mhwilds','wilds','黒神話','mh wilds'];
    var aaaCount = 0;
    sel.games.forEach(function(k){
      var s = String(k).toLowerCase();
      if (heavyKeywords.some(function(h){ return s.indexOf(h) >= 0; })) aaaCount++;
    });
    gpu += aaaCount * 8;
    /* 画質 */
    if (sel.comfort === 'fhd_smooth')   { gpu += 18; cpu += 12; cool += 8; }
    else if (sel.comfort === 'wqhd_quality') { gpu += 32; cpu += 14; cool += 14; }
    else if (sel.comfort === '4k')      { gpu += 50; cpu += 18; cool += 22; ram += 8; }
    else if (sel.comfort === 'vr')      { gpu += 42; cpu += 16; cool += 16; ram += 12; }
    else if (sel.comfort === 'unsure')  { gpu += 22; cpu += 12; cool += 10; }
    else if (sel.comfort === 'casual')  { gpu += 5;  cpu += 8;  cool += 4; }
    /* 用途 (複数可): 軸ごとの最大値を採用し、用途数だけで過剰加算しない */
    var usageList = (sel.usages && sel.usages.length) ? sel.usages : (sel.usage ? [sel.usage] : []);
    var uGpu = 0, uCpu = 0, uRam = 0, uCool = 0;
    usageList.forEach(function(u){
      var detail = sel.usageDetails && sel.usageDetails[u];
      var profile = {gpu:0, cpu:0, ram:0, cool:0};
      if (u === 'streaming') profile = detail === 'stream_talk'
        ? {gpu:0, cpu:10, ram:8, cool:6}
        : detail === 'stream_advanced'
          ? {gpu:14, cpu:28, ram:22, cool:16}
          : {gpu:8, cpu:18, ram:12, cool:10};
      else if (u === 'creation') profile = detail === 'edit_fhd_short'
        ? {gpu:4, cpu:15, ram:10, cool:6}
        : detail === 'edit_heavy_4k'
          ? {gpu:18, cpu:35, ram:32, cool:18}
          : {gpu:8, cpu:25, ram:22, cool:8};
      else if (u === 'ai_use') profile = detail === 'ai_image_try'
        ? {gpu:14, cpu:10, ram:22, cool:10}
        : detail === 'ai_video_train' || detail === 'ai_local_llm'
          ? {gpu:28, cpu:22, ram:32, cool:22}
          : {gpu:18, cpu:12, ram:30, cool:14};
      else if (u === 'work_study') profile = detail === 'work_heavy'
        ? {gpu:8, cpu:22, ram:22, cool:8}
        : detail === 'work_multitask'
          ? {gpu:0, cpu:12, ram:18, cool:0}
          : {gpu:0, cpu:6, ram:8, cool:0};
      uGpu = Math.max(uGpu, profile.gpu);
      uCpu = Math.max(uCpu, profile.cpu);
      uRam = Math.max(uRam, profile.ram);
      uCool = Math.max(uCool, profile.cool);
    });
    /* 用途由来の補正値に上限を設定 */
    uGpu  = Math.min(uGpu, 35);
    uCpu  = Math.min(uCpu, 35);
    uRam  = Math.min(uRam, 32);
    uCool = Math.min(uCool, 22);
    gpu += uGpu; cpu += uCpu; ram += uRam; cool += uCool;
    /* 予算 (キャップ) */
    var bud = parseInt(sel.budget || 0);
    var cap = 100;
    if (bud === 150000) cap = 55;
    else if (bud === 200000) cap = 68;
    else if (bud === 250000) cap = 80;
    else if (bud === 300000) cap = 90;
    else if (bud === 999999) cap = 100;
    gpu = Math.min(gpu, cap);
    cpu = Math.min(cpu, cap);
    ram = Math.min(ram, cap);
    cool = Math.min(cool, cap);
    /* 反映 */
    var setBar = function(prefix, pct, label){
      var fill = document.getElementById('gsBarFill' + prefix);
      var val  = document.getElementById('gsBarVal'  + prefix);
      if (fill) fill.style.width = Math.max(8, Math.round(pct)) + '%';
      if (val) val.textContent = label;
    };
    setBar('Gpu', gpu, gpuLabel(gpu));
    setBar('Cpu', cpu, cpuLabel(cpu));
    setBar('Ram', ram, ramLabel(ram));
    setBar('Cool', cool, coolLabel(cool));
    /* ステータステキスト */
    var statusEl = document.getElementById('gsMeterStatus');
    var allReady = sel.games.length && sel.comfort && sel.usage;
    if (statusEl) statusEl.textContent = allReady ? '準備OK' : '選ぶと動きます';
    /* 要約コメント */
    var sumEl = document.getElementById('gsMeterSummary');
    if (sumEl){
      var lines = [];
      if (sel.games.length && sel.comfort){
        lines.push('<p class="gs-meter__line">想定: ' + (LABELS[sel.comfort] || sel.comfort) + ' で' + sel.games.length + '本のタイトル</p>');
      }
      {
        var extraUsages = (sel.usages && sel.usages.length)
          ? sel.usages.filter(function(u){ return u !== 'gaming_only'; })
          : (sel.usage && sel.usage !== 'gaming_only' ? [sel.usage] : []);
        if (extraUsages.length){
          var extraLabels = extraUsages.map(function(u){ return LABELS[u]||u; }).join(' / ');
          lines.push('<p class="gs-meter__line">付加用途: ' + extraLabels + '</p>');
        }
      }
      if (sel.budgetAnswered){
        lines.push('<p class="gs-meter__line">予算上限: ' + formatBudget(sel.budget) + '</p>');
      }
      if (!lines.length) lines.push('<p class="gs-meter__hint">遊ぶゲームと画質を選ぶとここに目安が出ます</p>');
      sumEl.innerHTML = lines.join('');
    }
  }
  function gpuLabel(p){ if (p>=85) return 'RTX 4070 Ti〜級'; if (p>=70) return 'RTX 4070級'; if (p>=55) return 'RTX 4060 Ti級'; if (p>=40) return 'RTX 4060級'; return 'エントリー'; }
  function cpuLabel(p){ if (p>=80) return 'Ryzen 7 7800X3D'; if (p>=60) return 'Ryzen 7 7700'; if (p>=45) return 'Ryzen 7 5700X'; return 'Ryzen 5 5500'; }
  function ramLabel(p){ if (p>=70) return '32GB'; if (p>=40) return '16GB+'; return '16GB'; }
  function coolLabel(p){ if (p>=70) return '空冷強化〜水冷'; if (p>=45) return '空冷強化'; return '標準空冷'; }

  /* CTA 有効/無効と文言 + 進捗バー */
  function updateCtaState(){
    var btn = $('wzDiagnose'); if (!btn) return;
    var hint = $('gsCtaHint');
    var fill = $('gsCtaProgress');
    var hasUsage = (sel.usages && sel.usages.length > 0) || !!sel.usage;
    var checks = requiresGameProfile()
      ? [hasUsage, sel.games.length > 0, !!sel.comfort]
      : [hasUsage];
    var done = checks.filter(Boolean).length;
    var total = checks.length;
    var remain = total - done;
    var ready = remain === 0;
    btn.disabled = !ready;
    if (fill){
      var pct = Math.round((done / total) * 100);
      fill.style.width = pct + '%';
      fill.classList.toggle('is-full', ready);
    }
    if (hint){
      if (ready) {
        hint.innerHTML = '<span style="color:var(--pit-mag);font-weight:700;">必須項目の選択が完了しました</span>';
      } else {
        hint.innerHTML = '必須項目をあと <span id="gsCtaCount">' + remain + '</span> つ選んでください';
      }
    }
  }

  /* トップの用途カードから渡された値を質問3へ反映する。
     DOMの見た目だけでなくstateも先に更新し、ウィザードの必須判定にも同期する。 */
  (function applyUsageFromQuery(){
    var requestedUsage = null;
    try {
      requestedUsage = new URLSearchParams(location.search).get('usage');
    } catch(e) {
      return;
    }
    var allowedUsages = ['gaming_only', 'streaming', 'creation', 'ai_use', 'work_study'];
    if (allowedUsages.indexOf(requestedUsage) < 0) return;
    sel.usages = [requestedUsage];
    sel.usage = requestedUsage;
    syncChoiceControls();
  })();

  /* ステップウィザード。
     最初に用途を確認し、ゲーム/ゲーム配信ならタイトルと画質を追加で質問する。
     動画編集・生成AI・仕事だけの人をゲーム選択で止めない。 */
  (function(){
    var wiz = document.getElementById('gsWiz');
    if (!wiz) return;
    function buildOrder(){
      return requiresGameProfile()
        ? ['usage', 'title', 'comfort', 'budget']
        : ['usage', 'budget'];
    }
    var ORDER = buildOrder();
    var backBtn = document.getElementById('gsWizBack');
    var nextBtn = document.getElementById('gsWizNext');
    var navEl = document.getElementById('gsWizNav');
    var labelEl = document.getElementById('gsWizLabel');
    var fillEl = document.getElementById('gsWizFill');
    var step = 0;
    function stationFilled(key){
      if (key === 'title') return !requiresGameProfile() || sel.games.length > 0;
      if (key === 'comfort') return !requiresGameProfile() || !!sel.comfort;
      if (key === 'usage') return (sel.usages && sel.usages.length > 0) || !!sel.usage;
      return true; /* budget は任意 */
    }
    function render(scroll){
      ORDER = buildOrder();
      if (step >= ORDER.length) step = ORDER.length - 1;
      wiz.querySelectorAll('.gs-station[data-station]').forEach(function(el){
        var i = ORDER.indexOf(el.dataset.station);
        el.classList.toggle('is-current', i === step);
        var number = el.querySelector('.gs-station__no');
        if (number && i >= 0) number.textContent = String(i + 1).padStart(2, '0');
      });
      if (labelEl) labelEl.textContent = '質問 ' + (step + 1) + ' / ' + ORDER.length;
      if (fillEl) fillEl.style.width = Math.round(((step + 1) / ORDER.length) * 100) + '%';
      if (backBtn) backBtn.disabled = (step === 0);
      if (navEl) navEl.classList.toggle('is-last', step === ORDER.length - 1);
      refreshNext();
      if (scroll){
        var pit = document.getElementById('gsPit');
        if (pit && pit.getBoundingClientRect().top < -10) {
          pit.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        var currentStation = wiz.querySelector('.gs-station.is-current');
        var heading = currentStation && currentStation.querySelector('.gs-station__q');
        if (heading){
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      }
    }
    function refreshNext(){
      if (nextBtn) nextBtn.disabled = !stationFilled(ORDER[step]);
    }
    if (backBtn) backBtn.addEventListener('click', function(){
      if (step > 0) { step--; render(true); }
    });
    if (nextBtn) nextBtn.addEventListener('click', function(){
      if (!stationFilled(ORDER[step])) return;
      if (step < ORDER.length - 1) { step++; render(true); }
    });
    /* 選択変更のたびに次へボタンの活性を更新 (updateStationStatesから呼ばれる) */
    window.__gsWizRefresh = function(){ render(false); };
    /* 再診断・リセット時に先頭ステップへ戻す */
    window.__gsWizGo = function(n){
      step = Math.max(0, Math.min(ORDER.length - 1, n | 0));
      render(true);
    };
    render(false);
  })();

  /* 初期反映 */
  updateStationStates(); updateLiveMeter(); updateCtaState();
  if (typeof updateDiagRemain === 'function') updateDiagRemain();
  /* AI-015: 診断画面表示イベント (1回のみ) */
  try {
    if (!window.__gsDiagStartFired){
      window.__gsDiagStartFired = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ai_diag_start' });
    }
  } catch(e){}

  function buildConfirm() {
    var items = [
      {l:'ゲーム', v:sel.games.map(gameName).join(', '), s:1},
      {l:'目指す快適さ', v:LABELS[sel.comfort]||sel.comfort, s:2},
      {l:'使い方', v:((sel.usages && sel.usages.length) ? sel.usages.map(function(u){return LABELS[u]||u;}).join(' / ') : (LABELS[sel.usage]||sel.usage)), s:3},
      {l:'予算', v:formatBudget(sel.budget), s:4}
    ];
    $('wzConfirm').innerHTML = items.map(function(it){
      return '<button class="wz-conf-item" data-go="'+it.s+'"><span class="wz-conf-label">'+esc(it.l)+'</span><span class="wz-conf-val">'+esc(it.v)+'</span></button>';
    }).join('');
  }
  function updateDiagRemain() {
    var el = $('wzDiagRemain'); if (!el) return;
    var rem = getDiagRemaining();
    if (rem <= 0) {
      el.textContent = '1時間あたりの上限に達しました（しばらくお待ちください）';
      el.className = 'gs-pit__remain wz-low';
    } else if (rem <= 2) {
      el.textContent = 'この端末で1時間に' + DIAG_HOUR_LIMIT + '回まで・残り' + rem + '回';
      el.className = 'gs-pit__remain wz-low';
    } else {
      el.textContent = '1時間に' + DIAG_HOUR_LIMIT + '回まで・残り' + rem + '回';
      el.className = 'gs-pit__remain';
    }
  }
  /* 初期表示 */
  setTimeout(function(){ try { updateDiagRemain(); } catch(e){} }, 0);

  $('wzConfirm').addEventListener('click', function(e){ var item = e.target.closest('[data-go]'); if (!item) return; go(parseInt(item.dataset.go)); });
  new MutationObserver(function(){ var s5 = root.querySelector('[data-s="5"]'); if (s5 && s5.classList.contains('active')) { buildConfirm(); updateDiagRemain(); } }).observe(root.querySelector('[data-s="5"]'), {attributes:true, attributeFilter:['class']});
  $('wzRequest').addEventListener('input', function(){ $('wzReqCount').textContent = this.value.length; });

  var loadTimer = null;
  var loadDelayTimers = [];
  var loadStartTime = 0;
  var loadPhase = 0; /* 0=send, 1=thinking, 2=parse */

  function clearLoadDelayTimers() {
    loadDelayTimers.forEach(function(timer){ clearTimeout(timer); });
    loadDelayTimers = [];
  }

  function setLoadPhase(phase, msg) {
    loadPhase = phase;
    $('wzLoadMsg').textContent = msg;
    var fill = $('wzLoadFill');
    var pcts = [15, 50, 90, 100];
    var pct = pcts[Math.min(phase, 3)];
    fill.style.setProperty('width', pct + '%', 'important');
    var pctEl = $('wzLoadPct');
    if (pctEl) pctEl.textContent = pct + '%';
    syncPitLoaderToPct(pct, false);
    /* height/background は CSS 側に任せる (グラデ表現を活かすため inline 注入しない) */
  }

  var LOAD_MSGS=[[0,'条件を送信中'],[1500,'ゲーム要件を確認中'],[3000,'GPU性能を照合中'],[5000,'CPU/メモリのバランス調整中'],[7000,'予算とのトレードオフ計算中'],[9000,'電源と冷却を最終確認中']];
  function startLoad() {
    clearLoadDelayTimers();
    loadPhase = 0;
    loadStartTime = Date.now();
    var fill = $('wzLoadFill');
    fill.style.setProperty('transition', 'width .5s ease', 'important');
    fill.style.setProperty('width', '0%', 'important');
    var pctEl0 = $('wzLoadPct');
    if (pctEl0) pctEl0.textContent = '0%';
    $('wzLoadElapsed').textContent = '';
    loadDelayTimers.push(setTimeout(function(){ setLoadPhase(0, LOAD_MSGS[0][1]); }, 50));
    if (loadTimer) clearInterval(loadTimer);
    loadTimer = setInterval(function(){
      var el = Date.now() - loadStartTime;
      var sec = Math.floor(el / 1000);
      if (sec >= 3) $('wzLoadElapsed').textContent = sec + '秒経過';
      if (loadPhase < 2) {
        for (var i = LOAD_MSGS.length - 1; i >= 0; i--) {
          if (el >= LOAD_MSGS[i][0]) {
            var m = $('wzLoadMsg');
            if (m.textContent !== LOAD_MSGS[i][1]) m.textContent = LOAD_MSGS[i][1];
            break;
          }
        }
      }
      if (loadPhase === 1) {
        var raw = fill.style.getPropertyValue('width');
        var current = parseFloat(raw) || 50;
        if (current < 85) {
          var next = Math.min(current + 2, 85);
          fill.style.setProperty('width', next + '%', 'important');
          var pctElDyn = $('wzLoadPct');
          if (pctElDyn) pctElDyn.textContent = Math.round(next) + '%';
          syncPitLoaderToPct(next, false);
        }
      }
    }, 500);
  }

  function stopLoad(callback) {
    if (loadTimer) { clearInterval(loadTimer); loadTimer = null; }
    clearLoadDelayTimers();
    finishPitLoader();
    $('wzLoadFill').style.setProperty('width', '100%', 'important');
    var pctElEnd = $('wzLoadPct');
    if (pctElEnd) pctElEnd.textContent = '100%';
    $('wzLoadMsg').textContent = '完了';
    /* 500msのバー遷移を見届けてから結果へ切り替える。 */
    setTimeout(function(){ if (callback) callback(); }, 550);
  }

  /* SNS Share helpers */
  var SHARE_URL = 'https://www.titan-pc.net/pages/%E3%82%B2%E3%83%BC%E3%83%A0%E3%81%8B%E3%82%89%E9%81%B8%E3%81%B6';

  function buildShareText() {
    var lastItems = window.__wzLastItems || [];
    var names = sel.games.map(gameName);
    var gamesText = names.length > 3 ? names.slice(0,3).join('・') + '他' : names.join('・');
    var _L0 = legacy(); var resL = LABELS[_L0.res] || _L0.res;
    var bestGpu = lastItems[0] && lastItems[0].gpu ? String(lastItems[0].gpu).trim() : '';
    var text = '🖥️ TITAN Gaming AI診断の結果\n';
    text += gamesText + ' × ' + resL + ' で診断したら';
    if (bestGpu) text += '「' + bestGpu + '」がおすすめでした！';
    else text += 'おすすめPCが見つかりました！';
    text += '\n\n#TITANGaming #ゲーミングPC診断';
    return text;
  }

  function showToast(msg) {
    var toast = $('wzToast');
    if (!toast) return;
    toast.textContent = msg || 'コピーしました';
    toast.classList.add('wz-toast-show');
    setTimeout(function(){ toast.classList.remove('wz-toast-show'); }, 2500);
  }

  $('wzShareX').addEventListener('click', function(){
    var text = buildShareText();
    var url = 'https://x.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(SHARE_URL);
    window.open(url, '_blank');
  });

  $('wzShareLine').addEventListener('click', function(){
    var text = buildShareText() + '\n' + SHARE_URL;
    var url = 'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(SHARE_URL) + '&text=' + encodeURIComponent(text);
    window.open(url, '_blank');
  });

  $('wzShareCopy').addEventListener('click', function(){
    var text = buildShareText() + '\n' + SHARE_URL;
    var btn = this;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function(){
        btn.classList.add('wz-copied');
        btn.querySelector('span').textContent = 'コピー済み';
        showToast('クリップボードにコピーしました');
        setTimeout(function(){ btn.classList.remove('wz-copied'); btn.querySelector('span').textContent = 'コピー'; }, 3000);
      }).catch(function(){
        fallbackCopy(text, btn);
      });
    } else {
      fallbackCopy(text, btn);
    }
  });

  function fallbackCopy(text, btn) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy');
      btn.classList.add('wz-copied');
      btn.querySelector('span').textContent = 'コピー済み';
      showToast('クリップボードにコピーしました');
      setTimeout(function(){ btn.classList.remove('wz-copied'); btn.querySelector('span').textContent = 'コピー'; }, 3000);
    } catch(e){}
    document.body.removeChild(ta);
  }

  function showShareSection() {
    var sec = $('wzShareSection');
    if (sec) sec.style.display = '';
    setShareOpen(false);
  }
  function hideShareSection() {
    var sec = $('wzShareSection');
    if (sec) sec.style.display = 'none';
    setShareOpen(false);
  }
  function setShareOpen(open) {
    var toggle = $('wzShareToggle');
    var panel = $('wzSharePanel');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  var shareToggle = $('wzShareToggle');
  if (shareToggle) shareToggle.addEventListener('click', function(){
    setShareOpen(this.getAttribute('aria-expanded') !== 'true');
  });

  $('wzDiagnose').addEventListener('click', function(){
    if (calling) return;
    if (isBlocked()) { showFallback('短時間に多数の診断が実行されたため、一時的に利用制限中です。\n時間をおいて再度お試しください。', true); go(7); return; }
    var now = Date.now();
    if (now - lastCallTime < RATE_MS) { showFallback('少し待ってから再度お試しください。', true); go(7); return; }
    if (checkAndRecordSpam()) { showFallback('短時間に多数の診断が実行されたため、一時的に利用制限中です。\n時間をおいて再度お試しください。', true); go(7); return; }
    if (!checkDiagLimit()) { showFallback('1時間あたりの診断回数（' + DIAG_HOUR_LIMIT + '回）に達しました。\nしばらく時間をおいてから再度お試しください。', true); go(7); return; }
    calling = true;
    /* AI-015: 診断実行イベント */
    if (typeof pushGA === 'function') pushGA('ai_diag_submit', {
      games: sel.games.length,
      comfort: sel.comfort || '',
      usages: (sel.usages || []).join('|'),
      budget: sel.budget || '',
      buyMode: sel.buyMode || ''
    });
    var L = legacy();
    var budUnlimited = (L.bud === 'unlimited' || L.bud === '999999');
    var bud = budUnlimited ? Infinity : parseInt(L.bud);
    __budCeil = bud;
    var preImpossible = null;
    if (!budUnlimited){
      if (L.res === '4K' && bud <= 150000) { preImpossible = { reason: '4Kを快適に遊ぶにはRTX4070級以上のGPUが必要で、15万円以内では構成が難しいです。', suggestion: '予算を20万円以上に引き上げるか、目指す快適さを「WQHDで高画質」または「フルHDで滑らかに」に変更してください。' }; }
      else if (L.res === '4K' && L.str === 'yes' && bud <= 200000) { preImpossible = { reason: '4K＋配信にはRTX4070Ti級以上が必要で、20万円以内では難しいです。', suggestion: '予算を25万円以上にするか、目指す快適さをWQHDに下げてください。' }; }
      else if (L.res === 'WQHD' && L.str === 'yes' && bud <= 150000) { preImpossible = { reason: 'WQHD＋配信には十分なGPU性能が必要で、15万円以内では構成が厳しいです。', suggestion: '予算を20万円以上にするか、目指す快適さをフルHDに変更してください。' }; }
    }
    if (preImpossible) { go(6); startLoad(); setTimeout(function(){ stopLoad(function(){ calling = false; showImpossible(preImpossible.reason, preImpossible.suggestion); }); }, 1500); return; }
    go(6); startLoad(); callAI();
  });

  function isAiUnlimitedHeavy(L){
    var usages = L && Array.isArray(L.usages) ? L.usages : [];
    var unlimited = L && (L.bud === '999999' || L.bud === 'unlimited');
    return !!(unlimited && usages.indexOf('ai_use') >= 0 && L.usageDetailValue !== 'ai_image_try');
  }

  function usageDetailRequirement(L){
    if (isAiUnlimitedHeavy(L)) {
      return '生成AIを本格的に使う予算上限なしの構成。RTX 5080、Ryzen 7 9700X、メモリ64GB、SSD2TB以上を基準';
    }
    var requirements = {
      ai_image_try: '画像生成の入門用途。VRAM12GB以上、メモリ32GB、SSD1TB以上',
      ai_image_pro: '高解像度・大量の画像生成。VRAM16GB以上、メモリ32GB、SSD2TB以上',
      ai_video_train: '動画生成・追加学習。VRAM16GB以上、メモリ64GB、SSD2TB以上',
      ai_local_llm: 'ローカル文章AI。VRAM16GB以上、メモリ64GB、SSD2TB以上',
      ai_unsure: '生成AI用途はおまかせ。VRAM16GB以上、メモリ32GB、SSD2TB以上',
      edit_fhd_short: 'フルHDの短尺編集。メモリ16GB、SSD1TB以上',
      edit_daily_4k: 'フルHD〜4Kの日常編集。VRAM12GB以上、メモリ32GB、SSD2TB以上',
      edit_heavy_4k: '4K以上・長尺・エフェクト多め。VRAM16GB以上、メモリ64GB、SSD2TB以上',
      edit_unsure: '動画編集用途はおまかせ。VRAM12GB以上、メモリ32GB、SSD1TB以上',
      stream_fhd_game: 'ゲームをしながらフルHD配信。メモリ32GB、SSD1TB以上',
      stream_advanced: '高画質・複数カメラ配信。VRAM12GB以上、メモリ32GB、SSD2TB以上',
      stream_talk: '雑談・顔出し中心。メモリ16GB、SSD1TB以上',
      stream_unsure: 'ゲーム配信用途はおまかせ。メモリ32GB、SSD1TB以上',
      work_office: 'Office・ブラウザ・オンライン会議。メモリ16GB、SSD1TB以上',
      work_multitask: '会議をしながら複数作業。メモリ32GB、SSD1TB以上',
      work_heavy: 'CAD・3D・イラスト・開発。VRAM8GB以上、メモリ32GB、SSD2TB以上',
      work_light: '軽い仕事・学業用途。メモリ16GB、SSD1TB以上'
    };
    return requirements[L.usageDetailValue] || '';
  }

  /* Shopify実商品から、条件を満たす候補だけを生成する */
  function buildGpuWhitelist(L){
    var minS = 0, minV = 6;
    if (L.res === '4K') {
      minS = (L.str === 'yes') ? 27000 : 22000;
      minV = 12;
    } else if (L.res === 'WQHD') {
      minS = (L.str === 'yes') ? 18000 : 14000;
      minV = 8;
    } else { /* FHD */
      if (L.pri === 'competitive')    minS = 13000;
      else if (L.pri === 'fps')       minS = 11000; /* 144fps想定 */
      else if (L.pri === 'quality')   minS = 10000;
      else                            minS = 7000;  /* casual/unsure/balance */
      if (L.str === 'yes')            minS = Math.max(minS, 12500); /* FHD配信は最低限上振れ */
      minV = 8;
    }
    var usageList = L.usages || [];
    if (usageList.indexOf('ai_use') >= 0) {
      minS = Math.max(minS, 10000);
      minV = Math.max(minV, 12);
    }
    if (L.usageDetailValue === 'ai_image_pro' || L.usageDetailValue === 'ai_local_llm' || L.usageDetailValue === 'ai_unsure') {
      minS = Math.max(minS, 13000);
      minV = Math.max(minV, 16);
    } else if (L.usageDetailValue === 'ai_video_train') {
      minS = Math.max(minS, 18000);
      minV = Math.max(minV, 16);
    } else if (L.usageDetailValue === 'edit_daily_4k' || L.usageDetailValue === 'stream_advanced') {
      minS = Math.max(minS, 14000);
      minV = Math.max(minV, 12);
    } else if (L.usageDetailValue === 'edit_heavy_4k') {
      minS = Math.max(minS, 18000);
      minV = Math.max(minV, 16);
    } else if (L.usageDetailValue === 'stream_fhd_game') {
      minS = Math.max(minS, 12500);
      minV = Math.max(minV, 8);
    } else if (L.usageDetailValue === 'stream_talk') {
      /* 雑談・顔出し中心では、配信というだけで中上位GPUへ固定しない。
         ゲームも選ばれている場合は、この後のゲーム別最低スコアで必要分だけ引き上げる。 */
      minS = 7000;
      minV = 8;
    }
    var engine = window.TitanRecommendationEngine;
    if (!engine) return { list: [], products: [], resultProducts: [], overBudget: [], minS: minS, minV: minV };
    minS = engine.resolveMinimumScore(minS, L.games, GAME_MIN_SCORES, L.res);
    var budgetUnlimited = L.bud === '999999' || L.bud === 'unlimited';
    var budget = budgetUnlimited ? Infinity : parseInt(L.bud, 10);
    var aiUsage = usageList.indexOf('ai_use') >= 0;
    var candidateCatalog = aiUsage ? GS_PRODUCT_CATALOG.filter(function(product){
      return /^RTX/i.test(normalizeGpuName(product && product.key));
    }) : GS_PRODUCT_CATALOG;
    var selected = engine.selectCandidates(candidateCatalog, {
      minScore: minS,
      minVramGb: minV,
      condition: L.cond || 'any',
      budget: budget,
      budgetUnlimited: budgetUnlimited
    });
    var list = selected.candidates.map(function(product){
      return { n: product.key, s: product.gpuScore, v: product.vramGb, gen: product.condition, productId: product.id };
    });
    var resultProducts = selected.candidates.map(function(product){
      return Object.assign({}, product, { budgetDelta: 0 });
    }).concat(selected.overBudget.slice(0, 3).map(function(product){
      return Object.assign({}, product, { budgetDelta: budgetUnlimited ? 0 : Math.max(0, product.price - budget) });
    }));
    return { list: list, products: selected.candidates, resultProducts: resultProducts, overBudget: selected.overBudget, minS: minS, minV: minV };
  }

  function enforceAiUnlimitedHeavyItems(items, candidates, L){
    if (!isAiUnlimitedHeavy(L)) return Array.isArray(items) ? items : [];
    var products = Array.isArray(candidates) ? candidates : [];
    var product = products.find(function(candidate){
      return normalizeGpuName(candidate && candidate.key) === 'RTX5080';
    });
    if (!product) return Array.isArray(items) ? items : [];

    var forced = {
      productId: product.id,
      rank: 'best',
      label: '本命',
      gpu: product.key,
      price: product.price,
      cpu: 'Ryzen 7 9700X',
      mem: '64GB',
      ssd: 'Gen 3 NVMe SSD 2TB',
      total: 0,
      cond: '新品',
      budgetDelta: 0,
      why: '生成AIを本格的に使う前提で、処理性能とメモリ容量に余裕を持たせた構成です。',
      tip: '',
      tags: []
    };
    var comparisons = (Array.isArray(items) ? items : []).filter(function(item){
      return item && item.productId !== product.id;
    }).slice(0, 2).map(function(item, index){
      return Object.assign({}, item, { rank:index === 0 ? 'value' : 'alt' });
    });
    return [forced].concat(comparisons);
  }

  /* AIの文章回答に揺れがあっても、用途別質問で約束した最低構成はコード側で守る。 */
  function usageMinimumConfig(L){
    var configs = {
      ai_image_try:     { mem:32, ssd:1 },
      ai_image_pro:     { mem:32, ssd:2 },
      ai_video_train:   { cpu:'9700X', mem:64, ssd:2 },
      ai_local_llm:     { cpu:'9700X', mem:64, ssd:2 },
      ai_unsure:        { mem:32, ssd:2 },
      edit_fhd_short:   { mem:16, ssd:1 },
      edit_daily_4k:    { cpu:'9700X', mem:32, ssd:2 },
      edit_heavy_4k:    { cpu:'9700X', mem:64, ssd:2 },
      edit_unsure:      { mem:32, ssd:1 },
      stream_fhd_game:  { cpu:'9700X', mem:32, ssd:1 },
      stream_advanced:  { cpu:'9700X', mem:32, ssd:2 },
      stream_talk:      { mem:16, ssd:1 },
      stream_unsure:    { cpu:'9700X', mem:32, ssd:1 },
      work_office:      { mem:16, ssd:1 },
      work_multitask:   { mem:32, ssd:1 },
      work_heavy:       { cpu:'9700X', mem:32, ssd:2 },
      work_light:       { mem:16, ssd:1 }
    };
    if (isAiUnlimitedHeavy(L)) return { cpu:'9700X', mem:64, ssd:2 };
    return configs[L && L.usageDetailValue] || null;
  }

  function optionCapacityGb(value){
    var match = String(value || '').toUpperCase().match(/(\d+(?:\.\d+)?)\s*(TB|GB)/);
    if (!match) return 0;
    var amount = parseFloat(match[1]);
    return match[2] === 'TB' ? amount * 1024 : amount;
  }

  function cpuMeets9700Minimum(value){
    var match = String(value || '').toUpperCase().match(/\b(\d{4})(?:X3D|X|G)?\b/);
    if (!match) return false;
    var model = parseInt(match[1], 10);
    /* Ryzen 9 7900/7950と9xxx世代、ゲーム向け7800X3Dは9700X級として扱う。 */
    return model >= 9000 || model === 7900 || model === 7950 || /7800X3D/.test(String(value).toUpperCase());
  }

  function enforceUsageMinimumItems(items, candidates, L){
    var minimum = usageMinimumConfig(L);
    if (!minimum) return Array.isArray(items) ? items : [];
    var products = Array.isArray(candidates) ? candidates : [];
    return (Array.isArray(items) ? items : []).map(function(item){
      if (!item) return item;
      var product = products.find(function(candidate){ return candidate && candidate.id === item.productId; })
        || findCatalogProductById(item.productId)
        || findCatalogProduct(item.gpu);
      if (!product) return item;
      var addons = product.addons || {};
      var next = Object.assign({}, item);
      if (minimum.cpu && !cpuMeets9700Minimum(next.cpu)) {
        var cpu = resolveOptionValue(addons.cpu, minimum.cpu, 'cpu');
        if (cpu) next.cpu = cpu;
      }
      var memoryGeneration = memoryGenerationForCpu(next.cpu);
      if (minimum.mem && optionCapacityGb(next.mem) < minimum.mem) {
        var mem = resolveOptionValue(addons.mem, minimum.mem + 'GB', 'mem', memoryGeneration);
        if (mem) next.mem = mem;
      }
      if (minimum.ssd && optionCapacityGb(next.ssd) < minimum.ssd * 1024) {
        var ssd = resolveOptionValue(addons.ssd, minimum.ssd + 'TB', 'ssd');
        if (ssd) next.ssd = ssd;
      }
      next.total = 0;
      return next;
    });
  }

  function itemMeetsUsageMinimum(item, L){
    var minimum = usageMinimumConfig(L);
    if (!minimum || !item) return !!item;
    if (minimum.cpu && !cpuMeets9700Minimum(item.cpu)) return false;
    if (minimum.mem && optionCapacityGb(item.mem) < minimum.mem) return false;
    if (minimum.ssd && optionCapacityGb(item.ssd) < minimum.ssd * 1024) return false;
    return true;
  }

  function filterValidConfiguredItems(items, L, budgetCeil){
    return (Array.isArray(items) ? items : []).filter(function(item){
      if (!itemMeetsUsageMinimum(item, L)) return false;
      return !Number.isFinite(budgetCeil) || (item.total > 0 && item.total <= budgetCeil);
    });
  }

  function callAI() {
    var L = legacy();
    var names = L.games.map(gameName);
    var budUnlimited = (L.bud === '999999' || L.bud === 'unlimited');
    var budText = budUnlimited ? 'こだわらない（最適を提案）' : '¥' + parseInt(L.bud,10).toLocaleString() + '以下（税込合計でこの金額を絶対に超えないこと）';
    var wl = buildGpuWhitelist(L);
    __minS = wl.minS || 0;
    if (!wl.products.length) {
      var nearest = wl.overBudget[0];
      stopLoad(function(){
        calling = false;
        showImpossible(
          '選択条件と予算の両方を満たす掲載商品がありませんでした。',
          nearest
            ? nearest.key + 'は' + displayPrice(nearest.price) + 'から掲載中です。予算を上げるか条件を変更してください。'
            : '目指す快適さ・買い方・予算のいずれかを変更してください。'
        );
      });
      return;
    }
    /* 2026-08-16: オプション加算額も AI に渡し、予算内で完結した最終構成を選ばせる。
       加算額は Globo のメタフィールドから自動取得しているため手動更新は不要。 */
    function addonText(product){
      var a = product.addons || {};
      var parts = [];
      function shortOpts(obj){
        if(!obj) return [];
        return Object.keys(obj).map(function(k){ var v = Math.round(obj[k]/1000); return k + '+' + v + 'k'; });
      }
      var cats = [['cpu',a.cpu],['mem',a.mem],['ssd',a.ssd],['cooler',a.cooler],['hdd',a.hdd],['psu',a.psu]];
      for(var i=0;i<cats.length;i++){
        var opts = shortOpts(cats[i][1]);
        if(opts.length) parts.push(cats[i][0] + '[' + opts.join('/') + ']');
      }
      return parts.length ? ' +opt:' + parts.join(' ') : '';
    }
    var whitelistText = wl.products.map(function(product){
      var p = Math.round(product.price/1000) + 'k';
      return product.id + '|' + product.key + '|' + product.title + '|' + p + '|TS' + product.gpuScore + '|VRAM' + product.vramGb + addonText(product);
    }).join('\n');
    function renderCandidateFallback(reason) {
      var fbBudCeil = budUnlimited ? Infinity : parseInt(L.bud, 10);
      var safeProducts = budUnlimited ? wl.resultProducts : wl.resultProducts.filter(function(p){ return p.price <= fbBudCeil; });
      var fallbackItems = window.TitanRecommendationEngine.completeResults([], wl.products, safeProducts);
      fallbackItems = enforceAiUnlimitedHeavyItems(fallbackItems, safeProducts, L);
      fallbackItems = enforceUsageMinimumItems(fallbackItems, safeProducts, L).map(function(item){
        var product = findCatalogProductById(item.productId) || findCatalogProduct(item.gpu);
        return Object.assign({}, item, { total:configuredItemTotal(item, product) });
      });
      fallbackItems = filterValidConfiguredItems(fallbackItems, L, fbBudCeil);
      if (!fallbackItems.length) {
        showImpossible(
          '選んだ用途に必要な構成を、指定予算内の掲載商品では作れませんでした。',
          '予算を上げるか、用途のレベルを一段軽くして再診断してください。'
        );
        return;
      }
      renderResults(fallbackItems, isAiUnlimitedHeavy(L)
        ? '生成AIを本格的に使う前提で、予算より性能と余裕を優先しました。'
        : (reason || '実商品と必要性能を照合した結果です。'));
      go(7);
    }
    var condText, slotInstruction;
    var tipNote = '全フィールド必須(cpu/mem/ssd/total/why)。totalは税込合計数値。+opt:の加算額(k=千円→円換算)を掲載価格に加算。tipは40字以内で水冷/HDD/電源等を価格付き案内可。\n';
    var jsonSchemaNew = '[{"rank":"best","productId":"ID","cpu":"CPU","mem":"メモリGB","ssd":"SSD","total":数値,"why":"50字","tip":"40字"},{"rank":"value",...},{"rank":"alt",...}]';
    condText = '新品のみ';
    slotInstruction = 'value枠はTS÷価格のコスパ重視。alt枠も価格だけで選ばず、近い価格で明確に速い商品があればそちらを選ぶ。\n' + tipNote + jsonSchemaNew;
    if (isAiUnlimitedHeavy(L)) {
      slotInstruction = '生成AI・ローカルAIを本格的に使う予算上限なしの回答です。bestは必ずRTX 5080、Ryzen 7 9700X、メモリ64GB、SSD2TB以上にする。価格を抑えるためにRTX 5070以下、32GB以下、Ryzen 7 7700以下へ下げない。value/altもNVIDIA RTXに限定する。\n' + slotInstruction;
    } else if ((L.usages || []).indexOf('ai_use') >= 0) {
      slotInstruction = '生成AI・ローカルAI用途では3枠すべてNVIDIA RTXから選ぶ。AMD Radeon / RXは選定禁止。RTX 5080以上をvalue枠や価格重視候補として扱わない。\n' + slotInstruction;
    }

    var usageText = (L.usages && L.usages.length)
      ? L.usages.map(function(u){ return LABELS[u] || u; }).join(' / ')
      : (LABELS[sel.usage] || sel.usage || '指定なし');
    var msg = '【自動診断システムからの依頼】ユーザーは必要な質問に回答済みです。追加質問は不要です。\n\n'
      + '■ 遊びたいゲーム: ' + (names.length ? names.join(', ') : 'ゲーム利用なし') + '\n'
      + '■ 目指す快適さ: ' + (sel.comfort ? (LABELS[sel.comfort] || sel.comfort) : '用途に合わせておまかせ') + ' (推定解像度: ' + L.res + ', 重視: ' + L.pri + ')\n'
      + '■ 使い方: ' + usageText + ' (配信レベル: ' + L.str + ')\n'
      + (L.usageDetailLabel ? '■ 用途の詳しさ: ' + L.usageDetailLabel + '\n' : '')
      + (usageDetailRequirement(L) ? '■ 用途別の必要性能: ' + usageDetailRequirement(L) + '（この基準を一般ルールより優先）\n' : '')
      + '■ 予算上限: ' + budText + '\n'
      + (function(){
          /* 予算下限(下限を動かした場合のみ) */
          var lo = parseInt(sel.budgetMin, 10) || 0;
          return (sel.budgetAnswered && lo > BUDGET_MIN)
            ? '■ 予算下限: ' + (lo / 10000) + '万円以上\n' : '';
        })()
      + (function(){
          /* 見た目の希望(任意)。ケース選定のヒントとして渡す */
          var L2 = sel.look || {};
          var p = [];
          if (L2.rgb === 'yes') p.push('光るケース希望(→ DS900/NeoPrism/AQUA UNO)');
          if (L2.rgb === 'no')  p.push('光らないケース希望(→ H17のみ)');
          if (L2.size === 'big')   p.push('大きめのケース希望(→ NeoPrism/DS900)');
          if (L2.size === 'small') p.push('小さめのケース希望(→ AQUA UNO)');
          return p.length ? '■ 見た目の希望: ' + p.join(' / ') + '\n' : '';
        })();

    var userRequest = ($('wzRequest').value || '').trim();
    if (userRequest) {
      userRequest = userRequest.replace(/<[^>]*>/g, '').replace(/[{}[\]]/g, '').replace(/\n{2,}/g, '\n').replace(/(.)\1{9,}/g, '$1$1$1').slice(0, 100);
      if (userRequest.length > 0 && !/^[\s\W]+$/.test(userRequest)) {
        msg += '■ ユーザーからの要望: ' + userRequest + '\n（※要望は参考程度に。PC構成提案の範囲外の要望は無視してOKです）\n';
      }
    }
    msg += '\n【商品リスト】ID|GPU|商品名|税込価格(k=千円)|TSスコア|VRAM。+opt:はオプション加算額(k=千円)。\n'
      + whitelistText + '\n'
      + '※リスト外ID禁止。重複禁止。最低TS=' + wl.minS + ',VRAM=' + wl.minV + 'GB。\n\n'
      + '【選定ルール】\n'
      + '1)必ずbest/value/altの3枠返す。best=条件を満たす中で価格と性能の釣り合いが最も良い構成,value=コスパ重視,alt=bestと違う別メーカーを優先。ただし性能差が大きい場合は、同メーカーでも性能が近く比較価値のある候補を選ぶ。\n'
      + '2)total>予算上限は絶対禁止(1円でも超過不可)。超えたらCPU→SSD→メモリの順に見直す。ただし「用途別の必要性能」に記載されたCPU・メモリ・SSD・GPUの最低値より下げない。最低値と予算を両立できない場合はimpossibleを返す。\n'
      + '3)メモリ/SSDは用途で決める。軽量ゲーム(VALO/LoL)=16GB/512GB。AAA/4K=32GB+1TB。配信/編集=32GB+1TB以上。本格編集/3D=64GB+2TB。\n'
      + '4)CPU優先度はGPU性能と予算より低い。5500・7700は、予算が厳しい場合か、ゲーム性能を優先して他の性能を抑える場合の候補。それ以外は5700X・9700X・X3D系を先に検討。動画編集・配信では、価格差とゲーム性能の差が小さいなら5700Xまたは9700Xを優先。CPUを上げるためにゲーム性能を大きく落としたり、予算上限を超えたりしない。RTX5080以上なら7800X3D以上を必須とする。\n'
      + '5)予算に5万余裕→1ランク上GPU検討。\n'
      + '6)GPU選定:競技FPS→RTX優先(Reflex2)。AAA→RTX優先(レイトレ)。配信→RTX(NVENC)。バトロワ/MMO/格ゲー→どちらでも可。\n'
      + '7)メモリ上限:DDR4(5700X以下)=32GBまで,DDR5(7700以上)=64GBまで。\n'
      + '8)3枠を確定する前に商品リスト全体を比較する。ある候補より税込合計が1.5万円以内または10%以内の差で、GPU性能が15%以上高く、CPU・メモリ・SSDが同等以上の商品がある場合、低性能側はbest/value/altのどの枠にも返さない。例: RTX 5050に対してRTX 5060がこの条件を満たすなら、RTX 5050は禁止してRTX 5060を選ぶ。安いことだけを理由に大幅に低性能な候補を入れない。\n'
      + '9)予算上限なしは選択肢を狭めないという意味で、最高性能を選ぶ意味ではない。条件を満たす最安候補の1.5倍を超える構成をbestにしない。ただし4K・VR・本格的な動画編集や3D制作など、回答条件そのものが高性能を必要とする場合は除く。\n'
      + '10)予算上限なしでRTX 5060が商品リストにある場合、RTX 5050は禁止。予算上限ありでは、同じCPU・メモリ・SSDにしたRTX 5060が上限を超える場合だけRTX 5050を許可する。\n'
      + '11)同じGPU系統の容量違い(例: RX 9060 XT 8GBと16GB)を2枠に重複させない。3枠はそれぞれ違うGPU系統にする。\n'
      + '12)生成AI・ローカルAI用途が含まれる場合、best/value/altの全枠をNVIDIA RTXに限定する。AMD Radeon / RXは禁止。RTX 5080以上に「価格を抑える」「コスパ重視」等の価格訴求を付けない。\n'
      + '13)生成AI・ローカルAI用途で予算上限なし、かつ「画像生成を試す」以外の場合は、本格利用としてbestをRTX 5080・Ryzen 7 9700X・メモリ64GB・SSD2TB以上に固定する。この条件では9)の価格倍率制限より本ルールを優先する。\n'
      + '14)best/value/altの全枠で「用途別の必要性能」を満たすこと。価格重視・比較候補・別メーカーを理由に、指定されたCPU・メモリ・SSD・GPUの最低値を下回らせない。\n'
      + '【ケース】H17=光らない/静音/小型。AQUA UNO=小型/RGB。DS900=大型/RGB/エアフロー。NeoPrism=大型/RGB/見た目重視。\n'
      + '【オプション】tipに水冷/HDD/電源等を+opt:の価格付きで案内可。存在しないオプション禁止。\n'
      + '【表示文ルール】_meta.reason・why・tipの文章フィールドはPC初心者向けに、選んだ条件で何ができるかを平易な日本語で説明する。仕様欄の製品名・型番・容量はそのままでよいが、文章中ではNVENC、Reflex、DLSS、VRAM、Time Spy／TS、DDR4／DDR5、レイトレ、エンコード、AAA、GPU／CPU、RGB、エアフローなどの略語・専門用語を使わず、利用者が得られる体験へ言い換える。構成不可時のreason・suggestionも同じルールに従う。例: 配信向けなら「ゲームをしながら配信しやすい構成です。」。\n'
      + '【出力】JSON配列4要素:[{"_meta":true,"reason":"80字"},best,value,alt]。構成不可なら{"impossible":true,"reason":"...","suggestion":"..."}。\n\n'
      + slotInstruction;

    var settled = false;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = null;
    function claimTerminal(){
      if (settled) return false;
      settled = true;
      if (timeout) clearTimeout(timeout);
      return true;
    }
    timeout = setTimeout(function(){
      if (!claimTerminal()) return;
      if (controller) controller.abort();
      stopLoad(function(){ calling = false; renderCandidateFallback('AI応答が遅いため、実商品データから結果を作成しました。'); });
    }, 25000);

    var sig = _sign();
    /* Phase 1: sent → waiting for response */
    loadDelayTimers.push(setTimeout(function(){ if (loadPhase < 1) setLoadPhase(1, '最適な構成を照合中'); }, 800));

    fetch(API, {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({message:msg, sessionId:sessionId, history:[], model:'gpt-5.6-luna', _t:sig._t, _k:sig._k, source:'diagnosis'}),
      signal: controller ? controller.signal : undefined
    })
    .then(function(r){
      if (settled) throw new Error('Request already settled');
      /* Phase 2: response received → parsing */
      setLoadPhase(2, '結果を整理中...');
      return r.json();
    })
    .then(function(data){
      if (!claimTerminal()) return;
      lastCallTime = Date.now();
      stopLoad(function(){
        calling = false;
        var text = '';
        ['answer','reply','message','text'].forEach(function(k){ if (data && typeof data[k]==='string' && data[k].trim() && !text) text = data[k]; });
        if (!text) { renderCandidateFallback('実商品データから結果を作成しました。'); return; }
        var parsed = parseJSON(text);
        var metaReason = '';
        var rawItems = Array.isArray(parsed) ? parsed.filter(function(it){
          if (it && it._meta) { metaReason = it.reason || ''; return false; }
          return true;
        }) : [];
        var budCeil = budUnlimited ? Infinity : parseInt(L.bud, 10);
        var budgetSafeProducts = budUnlimited ? wl.resultProducts : wl.resultProducts.filter(function(p){ return p.price <= budCeil; });
        var items = window.TitanRecommendationEngine.completeResults(rawItems, wl.products, budgetSafeProducts);
        if (window.TitanRecommendationEngine.upgradeDominatedComparisons) {
          items = window.TitanRecommendationEngine.upgradeDominatedComparisons(items, budgetSafeProducts, { budgetUnlimited: budUnlimited });
        }
        items = enforceAiUnlimitedHeavyItems(items, budgetSafeProducts, L);
        items = enforceUsageMinimumItems(items, budgetSafeProducts, L);
        items = items.map(function(it){
          var product = findCatalogProductById(it.productId) || findCatalogProduct(it.gpu);
          return Object.assign({}, it, { total: configuredItemTotal(it, product) });
        });
        items = filterValidConfiguredItems(items, L, budCeil);
        if (items.length < 3) {
          items = window.TitanRecommendationEngine.completeResults(items, budgetSafeProducts, budgetSafeProducts);
          if (window.TitanRecommendationEngine.upgradeDominatedComparisons) {
            items = window.TitanRecommendationEngine.upgradeDominatedComparisons(items, budgetSafeProducts, { budgetUnlimited: budUnlimited });
          }
          items = enforceAiUnlimitedHeavyItems(items, budgetSafeProducts, L);
          items = enforceUsageMinimumItems(items, budgetSafeProducts, L);
          items = items.map(function(it){
            var product = findCatalogProductById(it.productId) || findCatalogProduct(it.gpu);
            return Object.assign({}, it, { total: configuredItemTotal(it, product) });
          });
          items = filterValidConfiguredItems(items, L, budCeil);
        }
        if (!items.length) { renderCandidateFallback(metaReason || 'AIの回答を実商品データで補正しました。'); return; }
        if (isAiUnlimitedHeavy(L)) metaReason = '生成AIを本格的に使う前提で、予算より性能と余裕を優先しました。';
        renderResults(items, metaReason);
        go(7);
      });
    })
    .catch(function(){
      if (!claimTerminal()) return;
      stopLoad(function(){ calling = false; renderCandidateFallback('通信状況のため、実商品データから結果を作成しました。'); });
    });
  }

  function parseJSON(text) {
    try { var d = JSON.parse(text); if (d && typeof d === 'object') return d; } catch(e){}
    var m = text.match(/\[[\s\S]*?\]/);
    if (m) { try { var d2 = JSON.parse(m[0]); if (Array.isArray(d2)) return d2; } catch(e){} }
    var im = text.match(/\{[\s\S]*?"impossible"[\s\S]*?\}/);
    if (im) { try { var d3 = JSON.parse(im[0]); if (d3.impossible) return d3; } catch(e){} }
    var objs = text.match(/\{[^{}]{20,}\}/g);
    if (objs && objs.length >= 2) { var arr = []; objs.forEach(function(o){ try { arr.push(JSON.parse(o)); } catch(e){} }); if (arr.length >= 2) return arr; }
    return null;
  }

  function showImpossible(reason, suggestion) {
    $('wzReason').textContent = '';
    hideShareSection();
    var _Li = legacy();
    var names = _Li.games.map(gameName).join('・');
    var comfortL = LABELS[sel.comfort]||sel.comfort, budL = formatBudget(sel.budget);
    $('wzResults').innerHTML =
      '<div class="gs-imp">'
      + '<div class="gs-imp__head"><span class="gs-imp__tag">該当なし</span><h3 class="gs-imp__title">この条件では構成が難しいです</h3></div>'
      + '<p class="gs-imp__reason">' + esc(reason) + '</p>'
      + (suggestion ? '<p class="gs-imp__suggest">' + esc(suggestion) + '</p>' : '')
      + '<div class="gs-imp__conds"><span>' + esc(names) + '</span><span>' + esc(comfortL) + '</span><span>' + esc(budL) + '</span></div>'
      + '</div>';
    go(7);
  }

  function normalizeGpuName(value) {
    return String(value || '').toUpperCase().replace(/GEFORCE|NVIDIA/g, '').replace(/[^A-Z0-9]/g, '');
  }

  function gpuFamily(value) {
    return normalizeGpuName(value).replace(/(?:8|16)GB/g, '');
  }

  function gpuVram(value) {
    var match = normalizeGpuName(value).match(/(8|16)GB/);
    return match ? match[1] : '';
  }

  function findCatalogProduct(gpu) {
    var target = gpuFamily(gpu);
    var targetVram = gpuVram(gpu);
    var family = GS_PRODUCT_CATALOG.filter(function(product){
      return product.title && product.url && gpuFamily(product.key) === target;
    });
    if (targetVram) {
      return family.find(function(product){ return gpuVram(product.key) === targetVram; }) || null;
    }
    return family[0] || null;
  }

  function findCatalogProductById(productId) {
    return GS_PRODUCT_CATALOG.find(function(product){
      return product.id === productId && product.title && product.url;
    }) || null;
  }

  function productTitleSpecs(title, fallbackCpu, fallbackMemory) {
    var text = String(title || '');
    var cpus = ['Ryzen 7 9800X3D','Ryzen 7 7800X3D','Ryzen 7 9700X','Ryzen 7 7700','Ryzen 7 5700X','Ryzen 7 3700X','Ryzen 5 5500'];
    var cpu = cpus.find(function(candidate){ return text.toUpperCase().indexOf(candidate.toUpperCase()) >= 0; }) || fallbackCpu;
    var memoryMatch = text.toUpperCase().match(/(?:DDR[45]\s*)?(16|32|64)GB\b/);
    return { cpu: cpu, memory: memoryMatch ? memoryMatch[1] + 'GB' : fallbackMemory };
  }

  function displayPrice(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return '¥' + value.toLocaleString('ja-JP');
    return String(value || '価格は商品ページで確認');
  }

  /* 商品ページの構成表を正本に、同じGPU・標準CPUのケース商品を復元する。
     Liquidのコレクション抽出がメタフィールド表記差で空になった場合だけ使う。 */
  function configuratorCasesForProduct(product) {
    var data = window.__TG_CFG_DATA;
    if (!product || !data || !Array.isArray(data.gpus) || !Array.isArray(data.cases) || !data.handles || !data.matrix) return null;
    var gpu = data.gpus.find(function(entry){
      return normalizeGpuName(entry.id) === normalizeGpuName(product.key);
    });
    if (!gpu) return null;
    var specs = productTitleSpecs(product.title, '', '16GB');
    if (!specs.cpu) return null;
    var list = [];
    data.cases.forEach(function(group){
      (group.variants || []).forEach(function(variant){
        var configKey = gpu.id + '|' + variant.case_name + '|' + specs.cpu;
        var handle = data.handles[configKey];
        var price = Number(data.matrix[configKey]);
        if (!handle || !Number.isFinite(price) || price <= 0) return;
        list.push({
          h: handle,
          n: variant.case_name,
          p: price,
          i: variant.img || '',
          u: '/products/' + handle
        });
      });
    });
    return list.length >= 2 ? list : null;
  }

  function getCasesForProduct(productId) {
    var all = (CFG.cases || {})[productId];
    if (all && all.length >= 2) return all;
    var product = findCatalogProductById(productId);
    var configuredCases = configuratorCasesForProduct(product);
    if (configuredCases) return configuredCases;
    if (product) {
      var cpuTag = (product.title || '').match(/Ryzen\s*(\d+)\s*(\w+)/i);
      var cpuKey = cpuTag ? ('ryzen' + cpuTag[1] + '-' + cpuTag[2]).toLowerCase() : '';
      if (cpuKey) {
        var fallbackKey = Object.keys(CFG.cases || {}).find(function(k) {
          if (!k.includes(cpuKey) || !CFG.cases[k] || CFG.cases[k].length < 2) return false;
          var fallbackProduct = findCatalogProductById(k);
          if (!fallbackProduct || normalizeGpuName(fallbackProduct.key) !== normalizeGpuName(product.key)) return false;
          var minP = Math.min.apply(null, CFG.cases[k].map(function(c){ return c.p; }));
          return Math.abs(minP - product.price) < product.price * 0.15;
        });
        if (fallbackKey) return CFG.cases[fallbackKey];
      }
    }
    return null;
  }

  function caseBaseName(caseName) {
    return String(caseName || '').replace(/\s*(BK|WH|BLACK|WHITE|ブラック|ホワイト|POLAR|YOLK|CANARY|ZEBRA)\s*$/i, '').trim();
  }

  function caseNameFromTitle(title) {
    var cases = String(title || '').match(/【([^】]+)】/g) || [];
    var name = '';
    cases.forEach(function(b) {
      var v = b.replace(/[【】]/g, '');
      if (/^(ゲーミングPC|新品|整備済み|中古)$/.test(v)) return;
      if (!name) name = v;
    });
    return name;
  }

  function caseThumbPlaceholder() {
    var placeholder = document.createElement('span');
    placeholder.className = 'gs-rank__case-thumb gs-rank__case-thumb--none';
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.textContent = '—';
    return placeholder;
  }

  /* カードには現在のケース名と変更ボタンだけを置き、全候補は共有モーダルで選ぶ。 */
  function renderCaseControl(productId, selectedHandle) {
    var all = getCasesForProduct(productId) || [];
    var list = all.slice().sort(function(a,b){ return a.p - b.p; });
    var current = list.find(function(v){ return v.h === selectedHandle; }) || null;
    if (!current) {
      var currentProduct = findCatalogProductById(selectedHandle) || findCatalogProductById(productId);
      if (!currentProduct) return '';
      var currentName = caseNameFromTitle(currentProduct.title)
        || shortProductTitle(currentProduct.title).split('/')[0].trim()
        || '現在のケース';
      current = {
        h: selectedHandle || productId,
        n: currentName,
        i: currentProduct.image || ''
      };
    }
    var selectedProduct = findCatalogProductById(current.h) || findCatalogProductById(selectedHandle) || findCatalogProductById(productId);
    var fallbackImage = selectedProduct && selectedProduct.image ? selectedProduct.image : '';
    var thumbSrc = current.i || fallbackImage;
    var fallbackAttr = fallbackImage && fallbackImage !== thumbSrc
      ? ' data-fallback-src="' + esc(fallbackImage) + '"' : '';
    var thumb = thumbSrc
      ? '<img class="gs-rank__case-thumb" src="' + esc(thumbSrc) + '"' + fallbackAttr + ' alt="" loading="lazy" decoding="async" width="52" height="52">'
      : '<span class="gs-rank__case-thumb gs-rank__case-thumb--none" aria-hidden="true">—</span>';
    var action = list.length >= 2
      ? '<button type="button" class="gs-rank__case-trigger" aria-haspopup="dialog" aria-controls="gsCaseModal">'
        + 'ケースを変更 <span aria-hidden="true">' + list.length + '種</span></button>'
      : '<span class="gs-rank__case-fixed">このケースのみ</span>';
    return '<div class="gs-rank__case-summary">'
      + thumb
      + '<span class="gs-rank__case-copy"><small>選択中のケース</small><strong class="gs-rank__case-name">' + esc(current.n) + '</strong></span>'
      + action
      + '</div>';
  }

  /* ケース選択 (2026-07-24追加)
     診断結果の推奨モデルと同スペックで、ケース(見た目)だけ違う商品を横スクロールで提示。
     データは CFG.cases[基準handle] = [{h:handle, n:ケース名, p:価格, i:画像, u:URL}]
     クリックで価格とCTAリンクを差し替える (ページ遷移はCTA押下時) */
  var CASE_VISIBLE = 6; /* 初期表示件数。残りは「すべて見る」で展開 */

  /* addonTotal: AI推奨構成のオプション加算額。ケース価格に上乗せして表示する。 */
  function renderCasePicker(productId, productUrl, productPrice, addonTotal){
    var all = getCasesForProduct(productId);
    if (!all || all.length < 2) return '';
    /* 価格昇順。差額は最安ケースを基準にした相対表示 */
    var list = all.slice().sort(function(a,b){ return a.p - b.p; });
    var basePrice = list[0] ? list[0].p : 0;
    /* 選択中は必ず初期表示範囲に入れる (見えない位置で選択済みになるのを防ぐ) */
    var selIdx = -1;
    for (var i = 0; i < list.length; i++){ if (list[i].h === productId){ selIdx = i; break; } }
    if (selIdx >= CASE_VISIBLE){
      var picked = list.splice(selIdx, 1)[0];
      list.splice(CASE_VISIBLE - 1, 0, picked);
    }
    var hidden = Math.max(0, list.length - CASE_VISIBLE);

    var itemsHtml = list.map(function(v, idx){
      var on = v.h === productId;
      var diff = v.p - basePrice;
      var diffStr = diff === 0 ? '差額なし' : '+' + displayPrice(diff);
      var img = v.i
        ? '<img src="' + esc(v.i) + '" alt="" loading="lazy" decoding="async" width="88" height="88">'
        : '<span class="gs-case__noimg" aria-hidden="true">—</span>';
      return '<button type="button" class="gs-case__item' + (on ? ' is-on' : '') + (idx >= CASE_VISIBLE ? ' is-extra' : '') + '"'
        + ' role="radio" aria-checked="' + (on ? 'true' : 'false') + '"'
        + ' tabindex="' + (on ? '0' : '-1') + '"'
        + ' data-h="' + esc(v.h) + '" data-u="' + esc(v.u) + '" data-p="' + v.p + '"'
        + ' title="' + esc(v.n) + ' / ' + esc(diffStr) + '">'
        + '<span class="gs-case__img">' + img + '</span>'
        + '<span class="gs-case__name">' + esc(v.n) + '</span>'
        + '<span class="gs-case__diff">' + esc(diffStr) + '</span>'
        + '<span class="gs-case__mark">選択中</span>'
        + '</button>';
    }).join('');

    return '<div class="gs-case" data-base="' + esc(productId) + '" data-addon="' + (parseInt(addonTotal, 10) || 0) + '">'
      + '<div class="gs-case__head">'
      +   '<span class="gs-case__title">ケース（見た目）を選ぶ</span>'
      +   '<span class="gs-case__count">全' + list.length + '種</span>'
      + '</div>'
      + '<div class="gs-case__grid" role="radiogroup" aria-label="ケースを選ぶ">' + itemsHtml + '</div>'
      + (hidden > 0
          ? '<button type="button" class="gs-case__more" aria-expanded="false">すべてのケースを見る（全' + list.length + '種）</button>'
          : '')
      + '<div class="gs-case__foot">'
      +   '<div class="gs-case__price"><span>選択中の価格</span><strong id="gsCasePrice2" aria-live="polite">' + esc(displayPrice(productPrice)) + '</strong></div>'
      +   '<a href="' + esc(productUrl) + '" class="gs-result-product__cta" id="gsCaseCta">この構成の商品ページを見る</a>'
      + '</div>'
      + '</div>';
  }

  /* ケース選択 (結果は都度再描画されるので document 委譲で受ける) */
  function selectCase(btn){
    var wrap = btn.closest('.gs-case');
    if (!wrap) return;
    wrap.querySelectorAll('.gs-case__item').forEach(function(b){
      b.classList.remove('is-on');
      b.setAttribute('aria-checked', 'false');
      b.setAttribute('tabindex', '-1');
    });
    btn.classList.add('is-on');
    btn.setAttribute('aria-checked', 'true');
    btn.setAttribute('tabindex', '0');
    /* 2026-08-17: ケース変更で価格が落ちるバグの修正。
       data-p はそのケースの標準構成価格なので、AI推奨構成の
       オプション加算額(data-addon)を足さないと加算分が消える。 */
    var addon = parseInt(wrap.getAttribute('data-addon'), 10) || 0;
    var csBp = parseInt(btn.dataset.p, 10) || 0;
    if (__budCeil < Infinity) addon = Math.min(addon, Math.max(0, __budCeil - csBp));
    var price = displayPrice(csBp + addon);
    /* 2026-08-17: 右カードのPRICE(gsCasePrice)は価格の重複表示を避けるため撤去した。
       将来また上部に価格を出す場合に備え、配列で回す形は残す(存在しないIDは無視される)。 */
    ['gsCasePrice2'].forEach(function(id){
      var el = document.getElementById(id);
      if (el) el.textContent = price;
    });
    var cta = document.getElementById('gsCaseCta');
    /* 2026-08-17: ケースを変えてもAI推奨の構成(tgcpu/tgmem/tgssd)を落とさない。
       ケース違いは別商品URLなので、現CTAが持つ構成パラメータを引き継ぐ。 */
    if (cta && btn.dataset.u) {
      var carry = '';
      try {
        var cur = cta.getAttribute('href') || '';
        var qi = cur.indexOf('?');
        if (qi >= 0) {
          var keep = cur.slice(qi + 1).split('&').filter(function(kv){
            return /^tg(cpu|mem|ssd)=/.test(kv);
          });
          if (keep.length) carry = (btn.dataset.u.indexOf('?') >= 0 ? '&' : '?') + keep.join('&');
        }
      } catch(e){}
      cta.setAttribute('href', btn.dataset.u + carry);
    }
    if (typeof pushGA === 'function') pushGA('ai_diag_case_select', { handle: btn.dataset.h });
  }

  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var more = e.target.closest('.gs-case__more');
    if (more){
      var w = more.closest('.gs-case');
      if (w){
        w.classList.add('is-expanded');
        more.setAttribute('aria-expanded', 'true');
        more.remove();
      }
      return;
    }
    var btn = e.target.closest('.gs-case__item');
    if (btn) selectCase(btn);
  });

  /* 矢印キーでケースを移動 (radiogroup の慣習に合わせる) */
  document.addEventListener('keydown', function(e){
    if (['ArrowRight','ArrowLeft','ArrowUp','ArrowDown'].indexOf(e.key) < 0) return;
    if (!e.target.closest) return;
    var cur = e.target.closest('.gs-case__item');
    if (!cur) return;
    var wrap = cur.closest('.gs-case');
    if (!wrap) return;
    var expanded = wrap.classList.contains('is-expanded');
    var items = [].slice.call(wrap.querySelectorAll('.gs-case__item')).filter(function(b){
      return expanded || !b.classList.contains('is-extra');
    });
    var i = items.indexOf(cur);
    if (i < 0) return;
    var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? i + 1 : i - 1;
    if (next < 0) next = items.length - 1;
    if (next >= items.length) next = 0;
    e.preventDefault();
    items[next].focus();
    selectCase(items[next]);
  });

  var caseModalTargetCard = null;
  var caseModalTrigger = null;
  var caseModalPending = null;

  function resultRoleLabel(candidate, primary) {
    var price = parseInt(candidate.getAttribute('data-rank-total'), 10) || 0;
    var primaryPrice = parseInt(primary.getAttribute('data-rank-total'), 10) || 0;
    var score = parseInt(candidate.getAttribute('data-rank-score'), 10) || 0;
    var primaryScore = parseInt(primary.getAttribute('data-rank-score'), 10) || 0;
    var vendor = candidate.getAttribute('data-rank-vendor') || '';
    var primaryVendor = primary.getAttribute('data-rank-vendor') || '';
    var gpu = candidate.getAttribute('data-rank-gpu') || '';
    var isPremiumRtx = /^RTX(?:5080|5090)/i.test(normalizeGpuName(gpu));
    var isCheaper = price > 0 && primaryPrice > 0 && price < primaryPrice;
    var keepsPerformance = score > 0 && primaryScore > 0 && score >= primaryScore * 0.9;
    if (!isPremiumRtx && isCheaper && keepsPerformance) return 'コスパ重視';
    if (!isPremiumRtx && isCheaper) return '価格を抑える';
    if (score > 0 && primaryScore > 0 && score > primaryScore * 1.05) return '性能を上げる';
    if (vendor && primaryVendor && vendor !== primaryVendor) return '別メーカー';
    return '別の選択肢';
  }

  function removePremiumRtxPriceCopy(item) {
    if (!item || !/^RTX(?:5080|5090)/i.test(normalizeGpuName(item.gpu))) return item;
    if (!/(?:価格|予算).{0,8}(?:抑|重視)|コスパ/.test(String(item.why || ''))) return item;
    return Object.assign({}, item, { why: '高い設定や重い処理まで見据えた上位候補' });
  }

  function alignComparisonCardRows() {
    var wrap = $('wzResults');
    if (!wrap) return;
    var cards = [].slice.call(wrap.querySelectorAll('.gs-rank--compare'));
    var selectors = ['.gs-rank__name', '.gs-rank__why', '.gs-rank__deltas', '.gs-rank__spec, .gs-rank__same'];
    selectors.forEach(function(selector){
      cards.forEach(function(card){
        var el = card.querySelector(selector);
        if (el) el.style.minHeight = '';
      });
    });
    if (cards.length < 2 || (window.matchMedia && window.matchMedia('(max-width: 760px)').matches)) return;
    selectors.forEach(function(selector){
      var elements = cards.map(function(card){ return card.querySelector(selector); }).filter(Boolean);
      var maxHeight = elements.reduce(function(max, el){
        return Math.max(max, Math.ceil(el.getBoundingClientRect().height));
      }, 0);
      elements.forEach(function(el){ el.style.minHeight = maxHeight + 'px'; });
    });
  }

  var comparisonAlignmentFrame = 0;
  function scheduleComparisonCardAlignment() {
    if (comparisonAlignmentFrame) cancelAnimationFrame(comparisonAlignmentFrame);
    comparisonAlignmentFrame = requestAnimationFrame(function(){
      comparisonAlignmentFrame = 0;
      alignComparisonCardRows();
    });
  }
  window.addEventListener('resize', scheduleComparisonCardAlignment);

  function refreshResultRoles() {
    var wrap = $('wzResults');
    if (!wrap) return;
    var primary = wrap.querySelector('.gs-rank--primary');
    if (!primary) return;
    var usedRoles = [];
    wrap.querySelectorAll('.gs-rank--compare').forEach(function(card){
      var role = card.querySelector('.gs-rank__role');
      var roleLabel = resultRoleLabel(card, primary);
      var price = parseInt(card.getAttribute('data-rank-total'), 10) || 0;
      var primaryPrice = parseInt(primary.getAttribute('data-rank-total'), 10) || 0;
      var score = parseInt(card.getAttribute('data-rank-score'), 10) || 0;
      var primaryScore = parseInt(primary.getAttribute('data-rank-score'), 10) || 0;
      var vendor = card.getAttribute('data-rank-vendor') || '';
      var primaryVendor = primary.getAttribute('data-rank-vendor') || '';
      if (usedRoles.indexOf(roleLabel) >= 0) roleLabel = vendor && primaryVendor && vendor !== primaryVendor ? '別メーカー' : '別の選択肢';
      usedRoles.push(roleLabel);
      if (role) role.textContent = roleLabel;
      var deltas = [];
      if (price && primaryPrice && price !== primaryPrice) {
        deltas.push('本命より' + displayPrice(Math.abs(price - primaryPrice)) + (price < primaryPrice ? '安い' : '高い'));
      }
      if (score && primaryScore && score !== primaryScore) {
        var pct = Math.round(Math.abs(score - primaryScore) / primaryScore * 100);
        if (pct > 0) deltas.push('GPU性能目安が約' + pct + '%' + (score > primaryScore ? '高い' : '低い'));
      }
      if (vendor && primaryVendor && vendor !== primaryVendor) deltas.push('本命とは別のGPUメーカー');
      if (!deltas.length) deltas.push('価格と性能が本命に近い候補');
      var deltaEl = card.querySelector('.gs-rank__deltas');
      if (deltaEl) deltaEl.innerHTML = deltas.map(function(delta){ return '<li>' + esc(delta) + '</li>'; }).join('');
    });
    scheduleComparisonCardAlignment();
  }

  function applyRankCase(card, option) {
    if (!card || !option) return;
    var newImg = option.getAttribute('data-i');
    var selectedCaseProduct = findCatalogProductById(option.getAttribute('data-h'));
    var fallbackImg = selectedCaseProduct && selectedCaseProduct.image ? selectedCaseProduct.image : '';
    var displayImg = newImg || fallbackImg;
    var newName = option.getAttribute('data-n');
    var newUrl = option.getAttribute('data-u');
    var newBaseP = parseInt(option.getAttribute('data-p'), 10) || 0;
    var addon = parseInt(card.getAttribute('data-rank-addon'), 10) || 0;
    var newPrice = newBaseP + addon;
    var budget = parseInt(card.getAttribute('data-rank-budget'), 10) || 0;
    if (option.disabled || (budget > 0 && newPrice > budget)) return;
    var imgEl = card.querySelector('.gs-rank__img');
    if (imgEl) {
      if (displayImg && imgEl.tagName === 'IMG') {
        if (fallbackImg && fallbackImg !== displayImg) imgEl.setAttribute('data-fallback-src', fallbackImg);
        else imgEl.removeAttribute('data-fallback-src');
        imgEl.src = displayImg;
      }
      else if (displayImg) {
        var parent = imgEl.parentNode;
        var productFallbackAttr = fallbackImg && fallbackImg !== displayImg
          ? ' data-fallback-src="' + esc(fallbackImg) + '"' : '';
        if (parent) parent.innerHTML = '<img class="gs-rank__img" src="' + esc(displayImg) + '"' + productFallbackAttr + ' alt="" loading="lazy" width="420" height="420">';
      } else {
        imgEl.outerHTML = '<div class="gs-rank__img gs-rank__img--none" aria-hidden="true">TITAN</div>';
      }
    }
    var priceEl = card.querySelector('.gs-rank__price strong');
    if (priceEl) priceEl.textContent = displayPrice(newPrice);
    var tail = card.getAttribute('data-rank-tail') || '';
    var nextDisplayName = newName + (tail ? ' / ' + tail : '');
    var ctas = card.querySelectorAll('.gs-rank__cta, .gs-rank__quick');
    if (ctas.length && newUrl) {
      ctas.forEach(function(cta){
        cta.setAttribute('href', carryRankConfig(newUrl, cta.getAttribute('href') || ''));
        cta.setAttribute('data-ph-capture-attribute-product-handle', option.getAttribute('data-h') || '');
        cta.setAttribute('data-ph-capture-attribute-recommended-case-key', newName || '');
        cta.setAttribute('data-ph-capture-attribute-product-title', nextDisplayName);
      });
    }
    var nameEl = card.querySelector('.gs-rank__name');
    if (nameEl && newName) {
      nameEl.textContent = nextDisplayName;
    }
    card.setAttribute('data-rank-pid', option.getAttribute('data-h'));
    card.setAttribute('data-rank-total', String(newPrice));
    var caseName = card.querySelector('.gs-rank__case-name');
    if (caseName) caseName.textContent = newName;
    var caseThumb = card.querySelector('.gs-rank__case-thumb');
    if (caseThumb) {
      var fallbackAttr = fallbackImg && fallbackImg !== displayImg
        ? ' data-fallback-src="' + esc(fallbackImg) + '"' : '';
      if (displayImg && caseThumb.tagName === 'IMG') {
        if (fallbackAttr) caseThumb.setAttribute('data-fallback-src', fallbackImg);
        else caseThumb.removeAttribute('data-fallback-src');
        caseThumb.src = displayImg;
      }
      else if (displayImg) caseThumb.outerHTML = '<img class="gs-rank__case-thumb" src="' + esc(displayImg) + '"' + fallbackAttr + ' alt="" loading="lazy" decoding="async" width="52" height="52">';
      else caseThumb.outerHTML = '<span class="gs-rank__case-thumb gs-rank__case-thumb--none" aria-hidden="true">—</span>';
    }
    refreshResultRoles();
    if (typeof pushGA === 'function') pushGA('ai_diag_case_pick', { handle: option.getAttribute('data-h') });
  }

  function renderCaseModal() {
    return '<div class="gs-case-modal" id="gsCaseModal" role="dialog" aria-modal="true" aria-labelledby="gsCaseModalTitle" hidden>'
      + '<div class="gs-case-modal__backdrop" data-case-modal-close></div>'
      + '<section class="gs-case-modal__dialog" tabindex="-1">'
      +   '<header class="gs-case-modal__head"><div><span>CASE SELECT</span><h3 id="gsCaseModalTitle">ケースを選ぶ</h3></div>'
      +     '<button type="button" class="gs-case-modal__close" data-case-modal-close aria-label="ケース選択を閉じる">×</button></header>'
      +   '<p class="gs-case-modal__lead">性能構成はそのまま、見た目と価格が変わります。</p>'
      +   '<div class="gs-case-modal__options" id="gsCaseModalOptions" role="radiogroup" aria-label="ケース候補"></div>'
      +   '<footer class="gs-case-modal__foot"><button type="button" class="gs-case-modal__cancel" data-case-modal-close>キャンセル</button>'
      +     '<button type="button" class="gs-case-modal__confirm" id="gsCaseModalConfirm">このケースに変更</button></footer>'
      + '</section></div>';
  }

  function openCaseModal(trigger) {
    var modal = $('gsCaseModal');
    var card = trigger && trigger.closest ? trigger.closest('.gs-rank') : null;
    if (!modal || !card) return;
    var productId = card.getAttribute('data-rank-source-id');
    var list = getCasesForProduct(productId);
    if (!list || !list.length) return;
    caseModalTargetCard = card;
    caseModalTrigger = trigger;
    var currentHandle = card.getAttribute('data-rank-pid');
    var addon = parseInt(card.getAttribute('data-rank-addon'), 10) || 0;
    var budget = parseInt(card.getAttribute('data-rank-budget'), 10) || 0;
    var sorted = list.slice().sort(function(a,b){ return a.p - b.p; });
    var basePrice = sorted[0] ? sorted[0].p : 0;
    var options = $('gsCaseModalOptions');
    options.innerHTML = sorted.map(function(item){
      var checked = item.h === currentHandle;
      var total = item.p + addon;
      var disabled = budget > 0 && total > budget;
      var diff = item.p - basePrice;
      var diffLabel = disabled ? '予算を' + displayPrice(total - budget) + '超えます' : (diff === 0 ? '最安ケース' : '最安から +' + displayPrice(diff));
      var image = item.i
        ? '<img src="' + esc(item.i) + '" alt="" loading="lazy" decoding="async" width="112" height="112">'
        : '<span class="gs-case-modal__noimg" aria-hidden="true">TITAN</span>';
      return '<button type="button" class="gs-case-modal__option" role="radio" aria-checked="' + (checked && !disabled ? 'true' : 'false') + '" aria-disabled="' + (disabled ? 'true' : 'false') + '" tabindex="' + (checked && !disabled ? '0' : '-1') + '"' + (disabled ? ' disabled' : '')
        + ' data-h="' + esc(item.h) + '" data-u="' + esc(item.u) + '" data-p="' + item.p + '" data-i="' + esc(item.i || '') + '" data-n="' + esc(item.n) + '">'
        + image + '<span class="gs-case-modal__option-copy"><strong>' + esc(item.n) + '</strong><small>' + esc(diffLabel) + '</small><b>' + esc(displayPrice(total)) + '</b></span>'
        + '<span class="gs-case-modal__check">' + (disabled ? '予算超過' : (checked ? '選択中' : '選ぶ')) + '</span></button>';
    }).join('');
    caseModalPending = options.querySelector('[aria-checked="true"]') || options.querySelector('.gs-case-modal__option:not([disabled])');
    if (caseModalPending) {
      options.querySelectorAll('.gs-case-modal__option').forEach(function(option){
        var selected = option === caseModalPending;
        option.setAttribute('aria-checked', selected ? 'true' : 'false');
        option.setAttribute('tabindex', selected ? '0' : '-1');
        var check = option.querySelector('.gs-case-modal__check'); if (check) check.textContent = option.disabled ? '予算超過' : (selected ? '選択中' : '選ぶ');
      });
    }
    var confirm = $('gsCaseModalConfirm');
    if (confirm) confirm.disabled = !caseModalPending;
    modal.hidden = false;
    document.body.classList.add('gs-case-modal-open');
    requestAnimationFrame(function(){ if (caseModalPending) caseModalPending.focus(); else modal.querySelector('.gs-case-modal__close').focus(); });
  }

  function closeCaseModal() {
    var modal = $('gsCaseModal');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('gs-case-modal-open');
    caseModalTargetCard = null;
    caseModalPending = null;
    if (caseModalTrigger) caseModalTrigger.focus();
    caseModalTrigger = null;
  }

  function resetCaseModalForRender() {
    var modal = $('gsCaseModal');
    if (modal && !modal.hidden) {
      closeCaseModal();
      return;
    }
    document.body.classList.remove('gs-case-modal-open');
    caseModalTargetCard = null;
    caseModalPending = null;
    caseModalTrigger = null;
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.gs-rank__case-trigger');
    if (trigger) { openCaseModal(trigger); return; }
    var close = e.target.closest('[data-case-modal-close]');
    if (close) { closeCaseModal(); return; }
    var option = e.target.closest('.gs-case-modal__option');
    if (option) {
      if (option.disabled) return;
      var group = option.closest('[role="radiogroup"]');
      group.querySelectorAll('.gs-case-modal__option').forEach(function(item){
        var selected = item === option;
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
        item.setAttribute('tabindex', selected ? '0' : '-1');
        var check = item.querySelector('.gs-case-modal__check'); if (check) check.textContent = item.disabled ? '予算超過' : (selected ? '選択中' : '選ぶ');
      });
      caseModalPending = option;
      return;
    }
    if (e.target.closest('#gsCaseModalConfirm')) {
      applyRankCase(caseModalTargetCard, caseModalPending);
      closeCaseModal();
    }
  });

  document.addEventListener('keydown', function(e){
    var modal = $('gsCaseModal');
    if (!modal || modal.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); closeCaseModal(); return; }
    var currentOption = e.target.closest && e.target.closest('.gs-case-modal__option');
    if (currentOption && ['ArrowRight','ArrowLeft','ArrowUp','ArrowDown'].indexOf(e.key) >= 0) {
      var options = [].slice.call(modal.querySelectorAll('.gs-case-modal__option')).filter(function(option){ return !option.disabled; });
      var index = options.indexOf(currentOption);
      var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? index + 1 : index - 1;
      if (next < 0) next = options.length - 1;
      if (next >= options.length) next = 0;
      e.preventDefault(); options[next].click(); options[next].focus(); return;
    }
    if (e.key !== 'Tab') return;
    var focusable = [].slice.call(modal.querySelectorAll('button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* 2026-08-17: 右カードは「掲載モデルの標準構成」、左は「AI推奨の最終構成」。
     同じ価格が並ぶと「なぜ違うスペックが同額?」と誤読されるため、
     標準構成 → 最終構成 の差分として見せる。変更がない項目は出さない。 */
  /* 2026-08-17: 診断結果のリンクは「変更してください」ではなく
     最初から構成が適用された状態で開く。
     商品ページ側(tg-preset-links)が tgcpu/tgmem/tgssd を読んで自動適用する。
     AIの表記(例 "32GB")を Globo の実オプション値(例 "DDR5 32GB 4800Mhz")へ解決する。 */
  function memoryGenerationForCpu(cpu){
    var m = String(cpu || '').toUpperCase().match(/RYZEN\s+\d\s+([0-9]{4})/);
    if(!m) return '';
    return parseInt(m[1], 10) >= 7000 ? 'DDR5' : 'DDR4';
  }

  function resolveOptionValue(addonMap, wanted, kind, memoryGeneration){
    if(!addonMap || !wanted) return '';
    var keys = Object.keys(addonMap);
    if(!keys.length) return '';
    if(kind === 'mem' && memoryGeneration){
      var compatible = keys.filter(function(key){
        return key.toUpperCase().indexOf(memoryGeneration) >= 0;
      });
      if(compatible.length) keys = compatible;
    }
    var w = String(wanted).toUpperCase().replace(/\s+/g, '');
    /* 完全一致 */
    for(var i=0;i<keys.length;i++){
      if(keys[i].toUpperCase().replace(/\s+/g,'') === w) return keys[i];
    }
    if(kind === 'cpu'){
      /* 型番(5700X/9800X3D等)で照合する。
         空白を潰すと "RYZEN 7" + "9800X3D" が繋がって型番を誤検出するため、
         ここでは元の文字列(空白あり)から拾う。 */
      function model(s){
        var m = String(s).toUpperCase().match(/\b([0-9]{4}[A-Z0-9]*)\b/);
        return m ? m[1] : '';
      }
      var wm = model(wanted);
      if(wm){
        for(var j=0;j<keys.length;j++){
          if(model(keys[j]) === wm) return keys[j];
        }
      }
      return '';
    }
    /* メモリ/SSD は容量(GB換算)で照合する */
    function gb(s){
      var m = String(s).toUpperCase().match(/([0-9]+)\s*(TB|GB)/);
      if(!m) return 0;
      var n = parseInt(m[1], 10);
      return /TB/.test(m[2]) ? n * 1024 : n;
    }
    var want = gb(wanted);
    if(!want) return '';
    for(var k=0;k<keys.length;k++){ if(gb(keys[k]) === want) return keys[k]; }
    return '';
  }

  /* 商品URLに構成パラメータを付ける。解決できた項目だけ付与する。 */
  function configuredUrl(baseUrl, product, item){
    if(!baseUrl || !product || !item) return baseUrl;
    var a = product.addons || {};
    var cpu = resolveOptionValue(a.cpu, item.cpu, 'cpu');
    var memoryGeneration = memoryGenerationForCpu(cpu || item.cpu);
    var mem = resolveOptionValue(a.mem, item.mem, 'mem', memoryGeneration);
    var ssd = resolveOptionValue(a.ssd, item.ssd, 'ssd');
    if(!cpu && !mem && !ssd) return baseUrl;   /* 標準構成のまま = 付けない */
    var sep = baseUrl.indexOf('?') >= 0 ? '&' : '?';
    var qs = [];
    if(cpu) qs.push('tgcpu=' + encodeURIComponent(cpu));
    if(mem) qs.push('tgmem=' + encodeURIComponent(mem));
    if(ssd) qs.push('tgssd=' + encodeURIComponent(ssd));
    return baseUrl + sep + qs.join('&');
  }

  /* 表示価格と商品ページの構成価格を、実オプション加算額から同じ値に揃える。 */
  function configuredItemTotal(item, product){
    if(!item) return 0;
    if(!product) return Number(item.total || item.price) || 0;
    var a = product.addons || {};
    var cpu = resolveOptionValue(a.cpu, item.cpu, 'cpu');
    var generation = memoryGenerationForCpu(cpu || item.cpu);
    var mem = resolveOptionValue(a.mem, item.mem, 'mem', generation);
    var ssd = resolveOptionValue(a.ssd, item.ssd, 'ssd');
    function addon(map, key){
      var value = key && map ? Number(map[key]) : 0;
      return Number.isFinite(value) ? value : 0;
    }
    return (Number(product.price) || 0) + addon(a.cpu, cpu) + addon(a.mem, mem) + addon(a.ssd, ssd);
  }

  function carryRankConfig(baseUrl, configuredBaseUrl){
    if (!baseUrl || !configuredBaseUrl) return baseUrl;
    var qi = configuredBaseUrl.indexOf('?');
    if (qi < 0) return baseUrl;
    var keep = configuredBaseUrl.slice(qi + 1).split('&').filter(function(kv){
      return /^tg(cpu|mem|ssd)=/.test(kv);
    });
    if (!keep.length) return baseUrl;
    return baseUrl + (baseUrl.indexOf('?') >= 0 ? '&' : '?') + keep.join('&');
  }

  function specDiffHtml(stdCpu, stdMem, stdSsd, finalCpu, finalMem, finalSsd) {
    function norm(v){ return String(v == null ? '' : v).replace(/\s+/g, ' ').trim(); }
    function digits(v){ var m = norm(v).match(/(\d+)\s*(TB|GB)/i); if(!m) return norm(v).toUpperCase();
      var n = parseInt(m[1], 10); return (/TB/i.test(m[2]) ? n * 1024 : n) + 'GB'; }
    var rows = [];
    function push(label, from, to, cmp){
      var f = norm(from), t = norm(to);
      if (!f || !t) return;
      if (cmp ? (cmp(f) === cmp(t)) : (f.toUpperCase() === t.toUpperCase())) return;
      rows.push('<div><dt>' + label + '</dt><dd><span class="gs-diff__from">' + esc(f) + '</span>'
        + '<span class="gs-diff__arrow" aria-hidden="true">→</span>'
        + '<span class="gs-diff__to">' + esc(t) + '</span></dd></div>');
    }
    push('CPU', stdCpu, finalCpu);
    push('MEMORY', stdMem, finalMem, digits);
    push('SSD', stdSsd, finalSsd, digits);
    if (!rows.length) {
      return '<p class="gs-result-product__same">この掲載モデルの標準構成が、そのまま推奨構成です。</p>';
    }
    return '<div class="gs-result-product__diff">'
      + '<p class="gs-result-product__diff-lead">この内容は下のボタンから適用済みで開きます。</p>'
      + '<dl class="gs-diff">' + rows.join('') + '</dl>'
      + '</div>';
  }

  /* 商品タイトルの【】ブロックを畳んで読みやすい表示名にする。
     metafield運用にすると44商品の手入力が必要になるため、表示側で処理する。 */
  function shortProductTitle(title) {
    var t = String(title || '');
    var cases = t.match(/【([^】]+)】/g) || [];
    var caseName = '';
    cases.forEach(function(b){
      var v = b.replace(/[【】]/g, '');
      if (/^(ゲーミングPC|新品|整備済み|中古)$/.test(v)) return;
      if (!caseName) caseName = v;
    });
    var head = t.replace(/【[^】]*】/g, '').trim();
    var gpu = (head.match(/(RTX\s?\d{4}\s?(?:Ti)?(?:\s?SUPER)?|RX\s?\d{4}\s?(?:XT)?)/i) || [])[0] || '';
    if (gpu) {
      gpu = gpu.toUpperCase().replace(/\s+/g, ' ')
        .replace(/^RTX(\d)/, 'RTX $1').replace(/^RX(\d)/, 'RX $1')
        .replace(/(\d)(TI|XT|SUPER)\b/, '$1 $2')
        .replace(/\bTI\b/, 'Ti').replace(/\bSUPER\b/, 'SUPER')
        .replace(/\s+/g, ' ').trim();
    }
    if (caseName && gpu) return caseName + ' / ' + gpu + ' 搭載モデル';
    if (gpu) return gpu + ' 搭載モデル';
    return head || t;
  }

  function renderPrimaryResult(item, reason) {
    var product = findCatalogProductById(item.productId) || findCatalogProduct(item.gpu);
    var searchGpu = encodeURIComponent('"' + (item.gpu || '') + '"');
    var productUrl = product ? product.url : 'https://www.titan-pc.net/search?q=' + searchGpu;
    /* 2026-08-16: AI が返した最終構成の合計(total)を優先して表示する。 標準構成の価格を出すと、AIが勧めた構成と金額が食い違うため。 */
    var finalTotal = (item && typeof item.total === 'number' && item.total > 0) ? item.total : null;
    var productPrice = finalTotal ? displayPrice(finalTotal)
      : (product && product.price ? displayPrice(product.price) : displayPrice(item.price));
    var rawTitle = product ? product.title : (item.gpu || 'おすすめ構成');
    var productTitle = shortProductTitle(rawTitle);
    /* 標準構成(掲載モデル)をタイトルから読み、最終構成との差分を出す */
    var stdSsdMatch = String(rawTitle).toUpperCase().match(/(\d+)\s*(TB|GB)(?=\s|$|【)/g) || [];
    var stdSsd = stdSsdMatch.length ? stdSsdMatch[stdSsdMatch.length - 1] : '';
    /* 2026-08-17: AIがssdを返さずフォールバックした場合でもSSD行を出す。
       掲載モデルの標準容量(タイトル由来)で補完する。 */
    var shownSsd = item.ssd || (stdSsd ? 'NVMe SSD ' + stdSsd : '');
    var currentSpecs = productTitleSpecs(rawTitle, item.cpu || '—', item.mem || '16GB');
    var diffHtml = specDiffHtml(currentSpecs.cpu, currentSpecs.memory, stdSsd,
      item.cpu, item.mem, shownSsd);
    var imageHtml = product && product.image
      ? '<img class="gs-result-product__image" src="' + esc(product.image) + '" alt="' + esc(productTitle) + '" width="900" height="900" loading="lazy">'
      : '<div class="gs-result-product__fallback" aria-hidden="true">TITAN GAMING PC</div>';
    var status = product
      ? (product.available ? '在庫あり' : '在庫状況は商品ページで確認')
      : '該当構成を商品一覧から表示';
    /* 2026-08-16: 最終構成(total)を表示している場合、tip に構成変更の案内が入っていると
       「もう含まれているのに、さらに変更を勧めている」ように見えるため抑制する。
       CPU/メモリ/SSD の変更を示す語を含む tip は、最終構成に反映済みとみなして出さない。 */
    var tipText = (item.tip || '').trim();
    if (finalTotal && /へ変更|に変更|アップグレード|\+¥|\+約/.test(tipText)) tipText = '';
    var adjustment = tipText
      ? '<section class="gs-result-adjustment" aria-label="おすすめの構成変更">'
        + '<span>OPTION ADJUSTMENT</span><h4>おすすめの構成変更</h4>'
        + '<p>' + esc(tipText) + '</p>'
        + '<small>商品ページのオプションから変更できます。</small>'
        + '</section>'
      : '';

    /* 構成を適用した状態で開くURL(解決できない場合は素のURLに戻る) */
    var applyUrl = configuredUrl(productUrl, product, item);
    /* オプション加算額 = 最終構成の合計 - 掲載モデルの標準構成価格。
       ケースを変えてもこの加算分を維持するため、加算額として渡す。 */
    var baseListPrice = (product && product.price) || item.price || 0;
    var caseBase = finalTotal || baseListPrice;
    var addonTotal = (finalTotal && baseListPrice && finalTotal > baseListPrice)
      ? (finalTotal - baseListPrice) : 0;
    var caseHtml = renderCasePicker(item.productId, applyUrl, caseBase, addonTotal);

    /* 2026-08-17: 商品名/理由/スペック表/価格は上の3台カードに出ているため、
       ここでは繰り返さない(同じ内容が縦に2度並んでいた)。
       下に残すのは「掲載モデルとの差分」「ケース選択」「オプション案内」だけ。 */
    return ''
      + '<section class="gs-result-primary gs-result-primary--detail">'
      +   (adjustment ? '<div class="gs-result-primary__note">' + adjustment + '</div>' : '')
      +   '<article class="gs-result-product">'
      +     '<span class="gs-result-product__label">カスタマイズ元の掲載モデル</span>'
      +     '<h4>' + esc(productTitle) + '</h4>'
      +     '<p>' + esc(status) + '</p>'
      +     imageHtml
      + diffHtml
      +     (caseHtml ? '' : '<a href="' + esc(applyUrl) + '" class="gs-result-product__cta" id="gsCaseCta">この構成で商品ページを開く</a>')
      +   '</article>'
      +   caseHtml
      + '</section>';
  }

  function resultGpuVendor(gpu) {
    var value = String(gpu || '').toUpperCase();
    if (/\bRX\s*\d/.test(value)) return 'AMD';
    if (/\bRTX?\s*\d/.test(value)) return 'NVIDIA';
    return 'OTHER';
  }

  function resultItemSsd(item) {
    if (item && item.ssd) return item.ssd;
    var product = item ? (findCatalogProductById(item.productId) || findCatalogProduct(item.gpu)) : null;
    var title = product ? product.title : '';
    var stdSsd = (String(title).toUpperCase().match(/(\d+)\s*(TB|GB)(?=\s|$|【)/g) || []).slice(-1)[0] || '';
    return stdSsd ? 'NVMe SSD ' + stdSsd : '—';
  }

  function normalizedStorageSpec(value) {
    var text = String(value || '').toUpperCase();
    var capacityMatch = text.match(/(\d+(?:\.\d+)?)\s*(TB|GB)/);
    var generationMatch = text.match(/\bGEN(?:ERATION)?\s*([345])\b/);
    var capacityGb = '';
    if (capacityMatch) {
      capacityGb = parseFloat(capacityMatch[1]) * (capacityMatch[2] === 'TB' ? 1024 : 1);
    }
    return {
      capacityGb: capacityGb,
      generation: generationMatch ? generationMatch[1] : ''
    };
  }

  function resultSpecDiffers(label, leftValue, rightValue) {
    if (label === 'SSD') {
      var leftStorage = normalizedStorageSpec(leftValue);
      var rightStorage = normalizedStorageSpec(rightValue);
      if (leftStorage.capacityGb !== '' && rightStorage.capacityGb !== '') {
        if (leftStorage.capacityGb !== rightStorage.capacityGb) return true;
        return !!(leftStorage.generation && rightStorage.generation && leftStorage.generation !== rightStorage.generation);
      }
    }
    return String(leftValue).replace(/\s+/g, '').toUpperCase() !== String(rightValue).replace(/\s+/g, '').toUpperCase();
  }

  function renderResultSpecs(item, primaryItem, isPrimary) {
    var values = [
      ['CPU', item.cpu || '—', primaryItem && primaryItem.cpu || '—'],
      ['GPU', item.gpu || '—', primaryItem && primaryItem.gpu || '—'],
      ['RAM', item.mem || '16GB', primaryItem && (primaryItem.mem || '16GB') || '16GB'],
      ['SSD', resultItemSsd(item), primaryItem ? resultItemSsd(primaryItem) : '—']
    ];
    if (!isPrimary) {
      values = values.filter(function(row){
        return resultSpecDiffers(row[0], row[1], row[2]);
      });
      if (!values.length) return '<p class="gs-rank__same">主要スペックは本命と同等です</p>';
    }
    return '<dl class="gs-rank__spec' + (isPrimary ? '' : ' gs-rank__spec--diff') + '">' + values.map(function(row){
      return '<div><dt>' + esc(row[0]) + '</dt><dd>' + esc(row[1]) + '</dd></div>';
    }).join('') + '</dl>';
  }

  /* 本命を大きな決断面、残り最大2台を差分中心の比較面として描画する。 */
  function renderRankCard(item, rank, hintCaseHandle, primaryItem) {
    var isPrimary = rank === 1;
    var product = findCatalogProductById(item.productId) || findCatalogProduct(item.gpu);
    var searchGpu = encodeURIComponent('"' + (item.gpu || '') + '"');
    var baseUrl = product ? product.url : 'https://www.titan-pc.net/search?q=' + searchGpu;
    var url = configuredUrl(baseUrl, product, item);
    var price = (item && typeof item.total === 'number' && item.total > 0)
      ? item.total : (product && product.price ? product.price : item.price);
    var rawTitle = product ? product.title : (item.gpu || 'おすすめ構成');
    var name = shortProductTitle(rawTitle);
    var imgSrc = product && product.image ? product.image : '';
    var why = (item.why || '').trim();
    var addonTotal = (item.total && product && product.price && item.total > product.price)
      ? (item.total - product.price) : 0;
    var effectivePid = item.productId;
    var caseList = getCasesForProduct(item.productId);
    if (hintCaseHandle && hintCaseHandle !== item.productId) {
      if (caseList) {
        for (var ci = 0; ci < caseList.length; ci++) {
          if (caseList[ci].h === hintCaseHandle) {
            if (Number.isFinite(__budCeil) && __budCeil > 0 && caseList[ci].p + addonTotal > __budCeil) break;
            if (caseList[ci].i) imgSrc = caseList[ci].i;
            if (caseList[ci].u) url = carryRankConfig(caseList[ci].u, url);
            price = caseList[ci].p + addonTotal;
            effectivePid = hintCaseHandle;
            var hp = name.split('/');
            if (hp.length >= 2 && caseList[ci].n) {
              name = caseList[ci].n + ' /' + hp.slice(1).join('/');
            }
            break;
          }
        }
      }
    } else if (!hintCaseHandle && caseList) {
      var pidInList = caseList.some(function(v){ return v.h === item.productId; });
      if (!pidInList) {
        var titleCase2 = product ? caseNameFromTitle(product.title) : '';
        var titleBase2 = titleCase2 ? caseBaseName(titleCase2) : '';
        var matched2 = titleBase2 ? caseList.find(function(v){ return caseBaseName(v.n) === titleBase2; }) : null;
        var defCase = matched2 || caseList.slice().sort(function(a,b){ return a.p - b.p; })[0];
        if (defCase) {
          if (defCase.i) imgSrc = defCase.i;
          if (defCase.u) url = carryRankConfig(defCase.u, url);
          price = defCase.p + addonTotal;
          effectivePid = defCase.h;
          var nameParts = name.split('/');
          if (nameParts.length >= 2 && defCase.n) {
            name = defCase.n + ' /' + nameParts.slice(1).join('/');
          }
        }
      }
    }
    var effectiveProduct = findCatalogProductById(effectivePid) || product;
    var effectiveCase = name.split('/')[0].trim();
    var imageFallback = effectiveProduct && effectiveProduct.image ? effectiveProduct.image : '';
    var imageFallbackAttr = imageFallback && imageFallback !== imgSrc
      ? ' data-fallback-src="' + esc(imageFallback) + '"' : '';
    var img = imgSrc
      ? '<img class="gs-rank__img" src="' + esc(imgSrc) + '"' + imageFallbackAttr + ' alt="" loading="lazy" width="420" height="420">'
      : '<div class="gs-rank__img gs-rank__img--none" aria-hidden="true">TITAN</div>';
    var caseHtml = renderCaseControl(item.productId, effectivePid);
    /* 性能余裕バー: GPUのTime Spy実スコア ÷ 選択条件の必要スコア。
       必要ライン(目盛り)を固定位置に置き、超過分が視覚的な「余裕」になる。 */
    var fitHtml = '';
    var __eng = window.TitanRecommendationEngine;
    var __gd = (__eng && __eng.gpuDetails) ? __eng.gpuDetails(item.gpu) : null;
    if (__gd && __gd.score && __minS > 0) {
      var fitRatio = __gd.score / __minS;
      var fitLabel = fitRatio >= 1.5 ? '性能に大きな余裕'
        : fitRatio >= 1.15 ? '性能に余裕あり'
        : fitRatio >= 1.0 ? '必要条件を満たす'
        : '設定調整で快適';
      var fitPct = Math.max(6, Math.min(100, Math.round(fitRatio / 1.6 * 100)));
      var tickPct = Math.round(100 / 1.6);
      /* 凡例(縦線=必要ライン)はカードごとに繰り返すと冗長なのでヘッダーに1回だけ出す */
      fitHtml = '<div class="gs-rank__fit">'
        + '<div class="gs-rank__fit-head"><span>性能余裕</span><strong>' + fitLabel + '</strong></div>'
        + '<div class="gs-rank__fit-track"><span class="gs-rank__fit-bar" style="width:' + fitPct + '%"></span><i class="gs-rank__fit-tick" style="left:' + tickPct + '%" aria-hidden="true"></i></div>'
        + '</div>';
    }
    var score = __gd && __gd.score ? __gd.score : 0;
    var tailParts = name.split('/');
    var nameTail = tailParts.length >= 2 ? tailParts.slice(1).join('/').trim() : '';
    var specs = renderResultSpecs(item, primaryItem || item, isPrimary);
    var quickPosition = isPrimary ? 'best_quick' : 'compare_' + rank + '_quick';
    var quickRank = isPrimary ? 'best' : String(rank);
    var quickName = isPrimary
      ? 'AI診断結果の本命をすぐ見る'
      : 'AI診断結果の比較候補をすぐ見る';
    var quickLink = '<a class="gs-rank__quick" href="' + esc(url) + '"'
      + ' data-ph-capture-attribute-titan-group="product_card"'
      + ' data-ph-capture-attribute-titan-name="' + quickName + '"'
      + ' data-ph-capture-attribute-titan-position="' + quickPosition + '"'
      + ' data-ph-capture-attribute-product-title="' + esc(name) + '"'
      + ' data-ph-capture-attribute-product-handle="' + esc(effectivePid || '') + '"'
      + ' data-ph-capture-attribute-result-rank="' + quickRank + '"'
      + ' data-ph-capture-attribute-recommended-gpu-key="' + esc(item.gpu || '') + '"'
      + ' data-ph-capture-attribute-recommended-case-key="' + esc(effectiveCase) + '">'
      + '商品を見る <span aria-hidden="true">→</span></a>';
    var status = isPrimary
      ? '<div class="gs-rank__status"><span class="gs-rank__eyebrow">本命</span><strong>これを選べばOK</strong>'
        + quickLink + '</div>'
      : '<div class="gs-rank__status"><span class="gs-rank__eyebrow">比較候補</span><strong class="gs-rank__role">別の選択肢</strong>'
        + quickLink + '</div>';
    return ''
      + '<article class="gs-rank ' + (isPrimary ? 'gs-rank--primary is-top' : 'gs-rank--compare') + '"'
      +   ' data-rank-source-id="' + esc(item.productId) + '" data-rank-pid="' + esc(effectivePid) + '"'
      +   ' data-rank-addon="' + addonTotal + '" data-rank-total="' + price + '" data-rank-budget="' + (Number.isFinite(__budCeil) ? __budCeil : 0) + '" data-rank-score="' + score + '"'
      +   ' data-rank-vendor="' + esc(resultGpuVendor(item.gpu)) + '" data-rank-gpu="' + esc(item.gpu || '') + '" data-rank-tail="' + esc(nameTail) + '">'
      +   status
      +   '<div class="gs-rank__thumb">' + img + '</div>'
      +   '<div class="gs-rank__body">'
      +     '<h4 class="gs-rank__name">' + esc(name) + '</h4>'
      +     '<p class="gs-rank__why">' + esc(why) + '</p>'
      +     (isPrimary ? '' : '<ul class="gs-rank__deltas" aria-label="本命との違い"></ul>')
      +     specs
      +     fitHtml
      +     caseHtml
      +   '</div>'
      +   '<div class="gs-rank__foot">'
      +     '<div class="gs-rank__price" aria-live="polite"><span>この構成の合計</span><strong>' + esc(displayPrice(price)) + '</strong></div>'
      +     '<a class="gs-rank__cta" href="' + esc(url) + '"'
      +       ' data-ph-capture-attribute-titan-group="product_card"'
      +       ' data-ph-capture-attribute-titan-name="AI診断結果の商品詳細を見る"'
      +       ' data-ph-capture-attribute-titan-position="' + rank + '"'
      +       ' data-ph-capture-attribute-product-title="' + esc(name) + '"'
      +       ' data-ph-capture-attribute-product-handle="' + esc(effectivePid || '') + '"'
      +       ' data-ph-capture-attribute-result-rank="' + rank + '"'
      +       ' data-ph-capture-attribute-recommended-gpu-key="' + esc(item.gpu || '') + '"'
      +       ' data-ph-capture-attribute-recommended-case-key="' + esc(effectiveCase) + '">'
      +       (isPrimary ? 'この構成を選ぶ' : '商品詳細を見る') + '</a>'
      +   '</div>'
      + '</article>';
  }

  function renderAlternativeResult(item, label) {
    var product = findCatalogProductById(item.productId) || findCatalogProduct(item.gpu);
    var searchGpu = encodeURIComponent('"' + (item.gpu || '') + '"');
    var productUrl = product ? product.url : 'https://www.titan-pc.net/search?q=' + searchGpu;
    var productPrice = (item && typeof item.total === 'number' && item.total > 0)
      ? item.total
      : (product && product.price ? product.price : item.price);
    var detail = item.budgetDelta > 0
      ? '選択予算より' + displayPrice(item.budgetDelta) + '上。性能条件を下げない候補です。'
      : item.why;
    return ''
      + '<article class="gs-result-alt">'
      +   '<span>' + esc(label) + '</span>'
      +   '<h4>' + esc(item.gpu || '—') + '</h4>'
      +   '<p class="gs-result-alt__spec">' + esc(item.cpu || '') + ' / ' + esc(item.mem || '16GB') + '</p>'
      +   (detail ? '<p>' + esc(detail) + '</p>' : '')
      +   '<div><strong>' + esc(displayPrice(productPrice)) + '</strong><a href="' + esc(productUrl) + '">商品ページを見る</a></div>'
      + '</article>';
  }

  function preferredCaseHandle(item) {
    var look = sel.look || {};
    if (!look.rgb && !look.size) return null;
    var list = getCasesForProduct(item.productId);
    if (!list || !list.length) return null;
    var current = list.find(function(entry){ return entry.h === item.productId; }) || null;
    var currentName = current ? current.n : '';
    var match = null;
    if (look.rgb === 'no') match = list.find(function(entry){ return /^H17/i.test(entry.n); }) || null;
    else if (look.rgb === 'yes') match = !/^H17/i.test(currentName) && current
      ? current : (list.find(function(entry){ return !/^H17/i.test(entry.n); }) || null);
    else if (look.size === 'big') match = /^(DS900|NeoPrism|Neo Prism)/i.test(currentName) && current
      ? current : (list.find(function(entry){ return /^(DS900|NeoPrism|Neo Prism)/i.test(entry.n); }) || null);
    else if (look.size === 'small') match = /^(H17|AQUA UNO)/i.test(currentName) && current
      ? current : (list.find(function(entry){ return /^(H17|AQUA UNO)/i.test(entry.n); }) || null);
    return match ? match.h : null;
  }

  function projectedPrimaryTotal(item, caseHandle) {
    var product = findCatalogProductById(item.productId) || findCatalogProduct(item.gpu);
    var basePrice = (product && product.price) || item.price || 0;
    var configured = (typeof item.total === 'number' && item.total > 0) ? item.total : basePrice;
    if (!caseHandle) return configured;
    var list = getCasesForProduct(item.productId) || [];
    var picked = list.find(function(entry){ return entry.h === caseHandle; });
    if (!picked) return configured;
    var addon = configured > basePrice ? configured - basePrice : 0;
    return picked.p + addon;
  }

  function selectedGamesFavorGpu() {
    var usages = sel.usages || [];
    if (usages.indexOf('streaming') >= 0 || usages.indexOf('creation') >= 0 || usages.indexOf('work_study') >= 0) return false;
    var games = legacy().games || [];
    if (!games.length) return true;
    return games.some(function(game){
      var profile = GAME_MIN_SCORES[game] || GAME_MIN_SCORES[gameName(game)];
      if (!profile) return true;
      var wqhd = typeof profile === 'object' ? Number(profile.WQHD) : Number(profile);
      return !Number.isFinite(wqhd) || wqhd >= 13900;
    });
  }

  /* PIT LANE 用 結果カード: 旧wz-rcardを全廃、gs-card で再生成 */
  function renderResults(items, metaReason) {
    resetCaseModalForRender();
    var _Lr = legacy();
    var resultEngine = window.TitanRecommendationEngine;
    if (resultEngine && resultEngine.preferBalancedCpu) {
      var gpuPriority = selectedGamesFavorGpu();
      items = items.map(function(item){
        var product = findCatalogProductById(item.productId) || findCatalogProduct(item.gpu);
        return resultEngine.preferBalancedCpu(item, product, {
          budgetCeiling: __budCeil,
          projectedTotal: projectedPrimaryTotal(item, preferredCaseHandle(item)),
          gpuPriority: gpuPriority
        });
      });
    }
    var aiPrimary = items.find(function(item){ return item.rank === 'best'; }) || items[0];
    var projectedItems = items.map(function(item, index){
      return Object.assign({}, item, {
        total: projectedPrimaryTotal(item, preferredCaseHandle(item)),
        __sourceIndex: index
      });
    });
    var projectedPrimary = isAiUnlimitedHeavy(_Lr)
      ? projectedItems.find(function(item){ return item.rank === 'best'; })
      : resultEngine && resultEngine.choosePrimaryResult
      ? resultEngine.choosePrimaryResult(projectedItems, __budCeil)
      : null;
    var primary = projectedPrimary ? items[projectedPrimary.__sourceIndex] : aiPrimary;
    var primaryWasPromoted = !!(primary && aiPrimary && primary !== aiPrimary);
    var comparisons = [];
    ['value', 'alt'].forEach(function(rank){
      var item = items.find(function(candidate){ return candidate !== primary && candidate.rank === rank; });
      if (item) comparisons.push(item);
    });
    items.forEach(function(item){
      if (item !== primary && comparisons.indexOf(item) < 0) comparisons.push(item);
    });
    comparisons = comparisons.slice(0, 2);
    var ordered = primary ? [primary].concat(comparisons).map(function(item, index){
      var normalized = Object.assign({}, item, { rank: index === 0 ? 'best' : index === 1 ? 'value' : 'alt' });
      if (primaryWasPromoted && index === 0) normalized.why = '予算内で、CPU・メモリを落とさず性能を優先';
      else if (primaryWasPromoted && item === aiPrimary) normalized.why = '価格を抑えたい場合の候補';
      return removePremiumRtxPriceCopy(normalized);
    }) : [];
    try{window.__wzLastItems=ordered;window.__wzLastReason=metaReason||'';}catch(e){}

    var names = _Lr.games.map(gameName).join('・');
    var comfortL = LABELS[sel.comfort]||sel.comfort;
    var usageL = (sel.usages && sel.usages.length)
      ? sel.usages.map(function(u){ return LABELS[u]||u; }).join(' / ')
      : (LABELS[sel.usage]||sel.usage||'ゲーム');
    /* 候補数を正しく伝えつつ、判断の軸を「本命 + 比較候補」に置く。 */
    (function(){
      var head = document.querySelector('.gs-out__head');
      var n = ordered.length || 0;
      if (head) head.setAttribute('data-gs-count', n > 0 ? String(n) : '');
      var titleEl = $('wzResultTitle');
      if (titleEl && n > 0) {
        var compareCount = Math.max(0, n - 1);
        titleEl.textContent = compareCount
          ? '本命1台と比較候補' + compareCount + '台を選びました'
          : 'あなたの本命を選びました';
      }
    })();
    if (metaReason) { $('wzReason').textContent = metaReason; }
    else {
      /* casual は通常の「◯◯を設定名で遊ぶ」文型だと不自然になるため、用途中心の文型へ分ける。 */
      $('wzReason').textContent = (sel.comfort === 'casual'
        ? names + ' が動けば十分という前提で、用途中心に選んだ構成です。'
        : names + ' を ' + comfortL + ' で遊ぶための構成です。')
        + (usageL !== 'ゲーム' ? ' ('+usageL+')' : '');
    }
    /* 回答条件チップ: 診断に使った条件をヘッダー内に一覧化する。
       metaReason(AIの選定理由)には入力条件が全部は出ないため、ここで補完する。 */
    (function(){
      var chipsEl = $('wzChips');
      if (!chipsEl) return;
      var chips = [];
      _Lr.games.forEach(function(g){ chips.push(gameName(g)); });
      if (comfortL) chips.push(comfortL);
      if (usageL) chips.push(usageL);
      if (sel.budgetAnswered && _Lr.bud && _Lr.bud !== 'unlimited' && _Lr.bud !== '999999') {
        chips.push('予算 ¥' + parseInt(_Lr.bud, 10).toLocaleString('ja-JP') + ' 以下');
      }
      var lk = sel.look || {};
      if (lk.rgb === 'yes') chips.push('光るケース');
      if (lk.rgb === 'no') chips.push('光らないケース');
      if (lk.size === 'big') chips.push('大きめ');
      if (lk.size === 'small') chips.push('小さめ');
      chipsEl.innerHTML = chips.map(function(c){
        return '<span class="gs-out__chip">' + esc(c) + '</span>';
      }).join('');
    })();

    /* リード文(wzReason)と重複するため metaReason は使わない。
       カードには候補固有の why を出す(無ければ理由行そのものを省く)。 */
    var primaryReason = '';
    /* 2026-08-17: 上に3台を対等に並べ、下は1位の詳細だけにする。
       旧「ほかの候補」は3台に含まれるため出さない(同一商品の二重表示を防ぐ)。 */
    /* 同じケースモデル(色違いはOK)が3台並ぶのを避ける。
       重複があれば2台目以降を別ケースモデルにずらす。 */
    var caseHints = [];
    var usedBases = [];
    ordered.forEach(function(it, idx) {
      var caseList = getCasesForProduct(it.productId);
      var currentCase = null;
      if (caseList) {
        for (var j = 0; j < caseList.length; j++) {
          if (caseList[j].h === it.productId) { currentCase = caseList[j]; break; }
        }
      }
      var currentBase = currentCase ? caseBaseName(currentCase.n) : '';
      if (!currentBase) {
        var prod = findCatalogProductById(it.productId);
        var titleCase = prod ? caseNameFromTitle(prod.title) : '';
        if (titleCase) currentBase = caseBaseName(titleCase);
      }
      if (currentBase && usedBases.indexOf(currentBase) >= 0 && caseList) {
        var alt = null;
        for (var k = 0; k < caseList.length; k++) {
          var altBase = caseBaseName(caseList[k].n);
          if (altBase && usedBases.indexOf(altBase) < 0) { alt = caseList[k]; break; }
        }
        if (alt) {
          caseHints.push(alt.h);
          usedBases.push(caseBaseName(alt.n));
        } else {
          caseHints.push(null);
          usedBases.push(currentBase);
        }
      } else {
        caseHints.push(null);
        if (currentBase) usedBases.push(currentBase);
      }
    });
    /* 明示された見た目条件は重複回避より優先し、本命判定と同じケースを表示する。 */
    ordered.forEach(function(it, idx) {
      var preferred = preferredCaseHandle(it);
      if (preferred) caseHints[idx] = preferred;
    });
    var primaryHtml = ordered[0] ? renderRankCard(ordered[0], 1, caseHints[0], ordered[0]) : '';
    var compareHtml = ordered.slice(1).map(function(it, i){
      return renderRankCard(it, i + 2, caseHints[i + 1], ordered[0]);
    }).join('');
    $('wzResults').innerHTML = '<div class="gs-rank__grid">'
      + primaryHtml
      + (compareHtml ? '<section class="gs-rank__comparisons" aria-labelledby="gsCompareTitle">'
        + '<div class="gs-rank__compare-head"><span>COMPARE</span><h3 id="gsCompareTitle">比較候補</h3><p>本命と違う点だけを表示しています</p></div>'
        + '<div class="gs-rank__compare-grid">' + compareHtml + '</div></section>' : '')
      + '</div>'
      + renderCaseModal();
    refreshResultRoles();
    /* 性能余裕バーが1枚でも出ていれば凡例を出す(カードごとの繰り返しをやめた分) */
    (function(){
      var lg = $('wzFitLegend');
      if (!lg) return;
      var hasBar = !!$('wzResults').querySelector('.gs-rank__fit-track');
      lg.style.display = hasBar ? '' : 'none';
    })();

    showShareSection();

    /* minS も保存する。復元時に無いと性能余裕バーが出せない */
    try { localStorage.setItem('wz_prev', JSON.stringify({ items: ordered, sel: sel, ts: Date.now(), metaReason: metaReason || '', minS: __minS })); } catch(e){}

    /* AI-015: 結果表示イベント GA4 */
    pushGA('ai_diag_result_view', {
      games: sel.games.length,
      comfort: sel.comfort || null,
      usages: (sel.usages || []).join('|'),
      budget: sel.budget || null,
      buyMode: sel.buyMode || null,
      result_gpus: ordered.map(function(it){return it.gpu;}).join('|')
    });
  }

  /* AI-015: GA4 dataLayer push helper */
  function pushGA(name, params){
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch(e){}
  }

  function alignCardRows() {
    var container = $('wzResults'); if (!container) return;
    if (container.offsetWidth < 500) { container.querySelectorAll('[data-row]').forEach(function(el){ el.style.minHeight = ''; }); return; }
    var rows = ['badge','gpu','perf','price','specs','why','tags','tip'];
    rows.forEach(function(r) { var els = container.querySelectorAll('[data-row="'+r+'"]'); if (els.length < 2) return; els.forEach(function(el){ el.style.minHeight = ''; }); });
    void container.offsetHeight;
    rows.forEach(function(r) {
      var els = container.querySelectorAll('[data-row="'+r+'"]'); if (els.length < 2) return;
      var max = 0; els.forEach(function(el){ var h = el.offsetHeight; if (h > max) max = h; });
      if (max > 0) { els.forEach(function(el){ el.style.minHeight = max + 'px'; }); }
    });
  }

  function showFallback(text, hideRetry) {
    $('wzReason').textContent = '';
    hideShareSection();
    var html = '<div class="wz-fallback">' + esc(text) + '</div>';
    if (!hideRetry) { html += '<button class="wz-btn-cta" id="wzFRetry" style="margin-top:16px">もう一度試す</button>'; }
    $('wzResults').innerHTML = html; go(7);
    if (!hideRetry) {
      setTimeout(function(){
        var btn = $('wzFRetry');
        if (btn) btn.addEventListener('click', function(){
          if (!checkDiagLimit()) { showFallback('1時間あたりの診断回数（' + DIAG_HOUR_LIMIT + '回）に達しました。\nしばらく時間をおいてから再度お試しください。', true); return; }
          go(6); startLoad(); callAI();
        });
      }, 50);
    }
  }

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  $('wzChat').addEventListener('click', function(){
    var _Lc = legacy();
    var names = _Lc.games.map(gameName).join('・');
    var comfortL = LABELS[sel.comfort]||sel.comfort, budL = formatBudget(sel.budget);
    var usageL = (sel.usages && sel.usages.length)
      ? sel.usages.map(function(u){ return LABELS[u]||u; }).join(' / ')
      : (LABELS[sel.usage]||sel.usage||'');
    var buyL = LABELS[sel.buyMode]||sel.buyMode||'';
    var rankLabel = {
      best:'本命', value:'コスパ重視', pro:'さらに快適', amd:'AMD Radeon', alt:'別の選択肢',
      new_alt:'新品ならこれ', new_pick:'新品枠'
    };
    var items = (window.__wzLastItems || []).slice(0, 3);
    var reason = window.__wzLastReason || '';
    var lines = [];
    lines.push('【診断条件】');
    lines.push('・遊ぶゲーム: ' + (names || '—'));
    lines.push('・画質目標: ' + (comfortL || '—'));
    if (usageL) lines.push('・主な用途: ' + usageL);
    lines.push('・予算: ' + (budL || '—'));
    if (items.length){
      lines.push('');
      lines.push('【提案された候補 ' + items.length + '台】');
      items.forEach(function(it, i){
        var label = it.label || rankLabel[it.rank] || ('候補' + (i+1));
        if (/^RTX(?:5080|5090)/i.test(normalizeGpuName(it.gpu)) && /(?:コスパ|価格)/.test(label)) {
          label = '上位候補';
        }
        var price = it.price;
        if (typeof price === 'number') price = '¥' + price.toLocaleString();
        var spec = [it.cpu, it.mem || '16GB'].filter(Boolean).join(' / ');
        var why = (it.why || '').replace(/\s+/g, ' ').trim();
        var tip = (it.tip || '').replace(/\s+/g, ' ').trim();
        var tags = (it.tags || []).join(', ');
        var line = (i+1) + '. [' + label + '] ' + (it.gpu || '—');
        if (price) line += ' / ' + price + '〜';
        if (spec) line += ' / ' + spec;
        if (it.cond) line += ' / ' + it.cond;
        lines.push(line);
        if (why) lines.push('   理由: ' + why);
        if (tags) lines.push('   タグ: ' + tags);
        if (tip) lines.push('   補足: ' + tip);
      });
    }
    if (reason){
      lines.push('');
      lines.push('【AIの選定理由】');
      lines.push(reason);
    }
    lines.push('');
    lines.push('【質問】');
    var context = lines.join('\n');
    var bubble = document.getElementById('ai-bubble'), panel = document.getElementById('ai-panel'), input = document.getElementById('ai-input');
    if (bubble && panel) {
      bubble.click();
      setTimeout(function(){ if(!input)return; input.value=context; input.placeholder='質問を入力 (Shift+Enterで送信)'; input.focus(); try{input.setSelectionRange(context.length,context.length);}catch(e){} if(window.titanAIAutosizeInput)window.titanAIAutosizeInput(); }, 300);
    } else { window.location.href = 'https://www.titan-pc.net/pages/contact'; }
  });

  /* 条件を変えて再診断: 選択は維持したまま入力画面 (PIT LANE) に戻す */
  $('wzRetry').addEventListener('click', function(){
    $('wzResults').innerHTML = ''; $('wzReason').textContent = '';
    hideShareSection();
    go(1); /* 1〜5 のどれでもPIT LANE表示で同じ動作。1で代表 */
    if (typeof window.__gsWizGo === 'function') window.__gsWizGo(0);
    if (typeof updateStationStates === 'function') updateStationStates();
    if (typeof updateLiveMeter === 'function') updateLiveMeter();
    if (typeof updateCtaState === 'function') updateCtaState();
  });

  /* すべてリセット: 任意項目を含む選択を全消去してPIT LANE 初期状態へ戻す */
  $('wzReset').addEventListener('click', function(){
    sel = {games:[], comfort:null, usage:null, usages:[], usageDetails:{}, budget:null, budgetMin:'0', budgetAnswered:false, buyMode:'new', look:{rgb:null, size:null}};
    var _bRange = $('gsBudgetRange');
    var _bMin = $('gsBudgetMin');
    if (_bRange) _bRange.value = BUDGET_MAX;
    if (_bMin) _bMin.value = BUDGET_MIN;
    if (typeof window.__gsSyncBudgetUI === 'function') window.__gsSyncBudgetUI();
    root.querySelectorAll('.gs-tile.on, .wz-tile.on, .gs-opt.on, .wz-opt.on').forEach(function(x){ x.classList.remove('on'); x.setAttribute('aria-pressed','false'); });
    root.querySelectorAll('.gs-look__opt.is-on').forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-pressed','false'); });
    $('wzGameChips').innerHTML = ''; $('wzResults').innerHTML = ''; $('wzReason').textContent = '';
    $('wzRequest').value = ''; $('wzReqCount').textContent = '0';
    hideShareSection();
    go(1);
    if (typeof window.__gsWizGo === 'function') window.__gsWizGo(0);
    if (typeof updateStationStates === 'function') updateStationStates();
    if (typeof updateLiveMeter === 'function') updateLiveMeter();
    if (typeof updateCtaState === 'function') updateCtaState();
  });

  (function(){
    try {
      var raw = localStorage.getItem('wz_prev'); if (!raw) return;
      var prev = JSON.parse(raw);
      if (!prev || !prev.items || !prev.sel || Date.now() - prev.ts > 7*24*60*60*1000) { localStorage.removeItem('wz_prev'); return; }
      var btn = $('wzPrev'); if (btn) btn.style.display = '';
    } catch(e){}
  })();

  $('wzPrev').addEventListener('click', function(){
    try {
      var raw = localStorage.getItem('wz_prev'); if (!raw) return;
      var prev = JSON.parse(raw);
      if (!prev || !prev.items || !prev.sel) return;
      sel = prev.sel;
      sel.games = Array.isArray(sel.games) ? sel.games : [];
      sel.usages = Array.isArray(sel.usages) ? sel.usages : (sel.usage ? [sel.usage] : []);
      sel.usageDetails = Object.assign({}, sel.usageDetails || {});
      sel.look = Object.assign({rgb:null, size:null}, sel.look || {});
      if (!sel.buyMode) sel.buyMode = 'new';
      /* 旧データ互換: budgetAnswered が無い / 旧離散値(999999等)を正規化 */
      var nb = normalizeBudget(sel.budget);
      sel.budget = nb.budget;
      sel.budgetAnswered = nb.answered;
      var _pRange = $('gsBudgetRange');
      var restoredMax = (nb.budget == null || nb.budget === '0') ? BUDGET_MAX : parseInt(nb.budget, 10);
      if (!isFinite(restoredMax)) restoredMax = BUDGET_MAX;
      restoredMax = Math.max(BUDGET_MIN, Math.min(BUDGET_MAX, restoredMax));
      var restoredMin = parseInt(sel.budgetMin, 10);
      if (!isFinite(restoredMin)) restoredMin = BUDGET_MIN;
      restoredMin = Math.max(BUDGET_MIN, Math.min(restoredMax, restoredMin));
      sel.budgetMin = String(restoredMin);
      var _pMin = $('gsBudgetMin');
      if (_pRange) _pRange.value = restoredMax;
      if (_pMin) _pMin.value = restoredMin;
      if (typeof window.__gsSyncBudgetUI === 'function') window.__gsSyncBudgetUI();
      syncChoiceControls();
      syncGames();
      __minS = prev.minS || 0;
      renderResults(prev.items, prev.metaReason || ''); go(7);
    } catch(e){}
  });

})();

(function(){
  var root = document.getElementById('WzApp');
  if (!root) return;
  var $ = function(id){ return document.getElementById(id); };

  /* --- Tab switching --- */
  var diagPanel = root.querySelector('.wz-win-body');
  var scorePanel = $('wzScorePanel');
  var diagChildren = []; /* preserve existing content references */

  var currentScStep = 0;
  var diagPanel = $('wzDiagPanel');
  root.querySelectorAll('.wz-tab').forEach(function(tab){
    tab.addEventListener('click', function(){
      root.querySelectorAll('.wz-tab').forEach(function(t){ t.classList.remove('active'); });
      tab.classList.add('active');
      if (tab.dataset.tab === 'score') {
        diagPanel.style.display = 'none';
        scorePanel.style.display = '';
        if (!scorePanel.querySelector('.wz-sc.active')) {
          var target = scorePanel.querySelector('[data-sc="' + currentScStep + '"]');
          if (target) target.classList.add('active');
        }
      } else {
        scorePanel.style.display = 'none';
        diagPanel.style.display = '';
      }
    });
  });

  /* --- GPU data with scores --- */
  var GPU_LIST = [
    {n:'RTX 5090', s:48500},{n:'RTX 5080', s:33000},{n:'RTX 5070 Ti', s:27700},
    {n:'RTX 5070', s:22500},{n:'RTX 5060 Ti 16GB', s:15200},{n:'RTX 5060 Ti 8GB', s:15200},
    {n:'RTX 5060 Ti', s:15200},{n:'RTX 5060', s:13900},{n:'RTX 5050', s:10259},
    {n:'RX 9070 XT', s:29900},{n:'RX 9070', s:26300},{n:'RX 9060 XT 16GB', s:16200},
    {n:'RX 9060 XT 8GB', s:16200},{n:'RX 9060 XT', s:16200},
    {n:'RTX 4090', s:36000},{n:'RTX 4080 Super', s:28500},{n:'RTX 4080', s:27000},
    {n:'RTX 4070 Ti Super', s:24000},{n:'RTX 4070 Ti', s:22600},
    {n:'RTX 4070 Super', s:20500},{n:'RTX 4070', s:18500},
    {n:'RTX 4060 Ti 16GB', s:13800},{n:'RTX 4060 Ti 8GB', s:13500},{n:'RTX 4060 Ti', s:13500},
    {n:'RTX 4060', s:11000},{n:'RTX 4050', s:8500},
    {n:'RTX 3090 Ti', s:21500},{n:'RTX 3090', s:19800},
    {n:'RTX 3080 Ti', s:19500},{n:'RTX 3080 12GB', s:18200},{n:'RTX 3080', s:17500},
    {n:'RTX 3070 Ti', s:14800},{n:'RTX 3070', s:13700},
    {n:'RTX 3060 Ti', s:11800},{n:'RTX 3060 12GB', s:8865},{n:'RTX 3060', s:8865},
    {n:'RTX 3050 6GB', s:6278},{n:'RTX 3050', s:6278},
    {n:'RTX 2080 Ti', s:14000},{n:'RTX 2080 Super', s:12200},{n:'RTX 2080', s:11118},
    {n:'RTX 2070 Super', s:10200},{n:'RTX 2070', s:9500},
    {n:'RTX 2060 Super', s:8800},{n:'RTX 2060 12GB', s:8600},{n:'RTX 2060', s:7900},
    {n:'TITAN RTX', s:13200},{n:'TITAN V', s:10500},{n:'TITAN Xp', s:8800},{n:'TITAN X (Pascal)', s:8200},
    {n:'GTX 1080 Ti', s:9500},{n:'GTX 1080', s:7600},{n:'GTX 1070 Ti', s:6800},
    {n:'GTX 1070', s:6000},{n:'GTX 1660 Super', s:5800},{n:'GTX 1660 Ti', s:5700},
    {n:'GTX 1660', s:5200},{n:'GTX 1650 Super', s:4600},{n:'GTX 1650', s:3500},
    {n:'GTX 1060 6GB', s:4100},{n:'GTX 1060 3GB', s:3500},{n:'GTX 1050 Ti', s:2500},
    {n:'GTX 1050', s:1900},{n:'GTX 970', s:3200},{n:'GTX 960', s:2000},
    {n:'RX 7900 XTX', s:26500},{n:'RX 7900 XT', s:23500},{n:'RX 7900 GRE', s:19500},
    {n:'RX 7800 XT', s:17800},{n:'RX 7700 XT', s:15500},{n:'RX 7600 XT', s:11500},
    {n:'RX 7600', s:10836},{n:'RX 6950 XT', s:21000},
    {n:'RX 6900 XT', s:20200},{n:'RX 6800 XT', s:18200},{n:'RX 6800', s:16500},
    {n:'RX 6750 XT', s:12500},{n:'RX 6700 XT', s:11500},{n:'RX 6700', s:10000},
    {n:'RX 6650 XT', s:10000},{n:'RX 6600 XT', s:9400},{n:'RX 6600', s:8400},
    {n:'RX 6500 XT', s:4500},{n:'RX 5700 XT', s:9000},{n:'RX 5700', s:8200},
    {n:'RX 5600 XT', s:7500},{n:'RX 5500 XT', s:4500},
    {n:'RX 580 8GB', s:3700},{n:'RX 580', s:3700},{n:'RX 570', s:3200},{n:'RX 480', s:3600},
    {n:'Intel Arc A770', s:10000},{n:'Intel Arc A750', s:8500},{n:'Intel Arc A580', s:6500},
    {n:'Intel Arc A380', s:3000}
  ].sort(function(a,b){ return b.s - a.s; });

  var CPU_LIST = [
    {n:'Ryzen 9 9950X', s:95},{n:'Ryzen 9 9900X', s:90},{n:'Ryzen 9 7950X', s:92},
    {n:'Ryzen 9 7900X', s:88},{n:'Ryzen 9 5950X', s:82},{n:'Ryzen 9 5900X', s:80},
    {n:'Ryzen 9 3900X', s:65},{n:'Ryzen 7 9800X3D', s:98},{n:'Ryzen 7 9700X', s:85},
    {n:'Ryzen 7 7800X3D', s:95},{n:'Ryzen 7 7700X', s:82},{n:'Ryzen 7 7700', s:80},
    {n:'Ryzen 7 5800X3D', s:88},{n:'Ryzen 7 5800X', s:75},{n:'Ryzen 7 5700X3D', s:85},
    {n:'Ryzen 7 5700X', s:72},{n:'Ryzen 7 5700G', s:65},{n:'Ryzen 7 3700X', s:58},
    {n:'Ryzen 7 3800X', s:60},{n:'Ryzen 7 2700X', s:45},{n:'Ryzen 7 1700X', s:35},
    {n:'Ryzen 5 9600X', s:80},{n:'Ryzen 5 7600X', s:78},{n:'Ryzen 5 7600', s:76},
    {n:'Ryzen 5 7500F', s:74},{n:'Ryzen 5 5600X', s:70},{n:'Ryzen 5 5600', s:68},
    {n:'Ryzen 5 5600G', s:60},{n:'Ryzen 5 5500', s:62},{n:'Ryzen 5 3600', s:52},
    {n:'Ryzen 5 3600X', s:54},{n:'Ryzen 5 2600', s:42},{n:'Ryzen 5 1600', s:30},
    {n:'Ryzen 3 3300X', s:48},{n:'Ryzen 3 3100', s:40},
    {n:'Core Ultra 9 285K', s:88},{n:'Core Ultra 7 265K', s:82},{n:'Core Ultra 5 245K', s:78},
    {n:'Core i9-14900KS', s:94},{n:'Core i9-14900K', s:92},{n:'Core i9-14900KF', s:92},
    {n:'Core i9-14900', s:86},{n:'Core i9-14900F', s:86},
    {n:'Core i9-13900KS', s:92},{n:'Core i9-13900K', s:90},{n:'Core i9-13900KF', s:90},
    {n:'Core i9-13900', s:84},{n:'Core i9-13900F', s:84},
    {n:'Core i9-12900KS', s:86},{n:'Core i9-12900K', s:85},{n:'Core i9-12900KF', s:85},
    {n:'Core i9-12900', s:78},{n:'Core i9-12900F', s:78},
    {n:'Core i9-11900K', s:68},{n:'Core i9-10900K', s:62},{n:'Core i9-9900K', s:55},
    {n:'Core i7-14700K', s:88},{n:'Core i7-14700KF', s:88},
    {n:'Core i7-14700', s:82},{n:'Core i7-14700F', s:82},
    {n:'Core i7-13700K', s:85},{n:'Core i7-13700KF', s:85},
    {n:'Core i7-13700', s:78},{n:'Core i7-13700F', s:78},
    {n:'Core i7-12700K', s:80},{n:'Core i7-12700KF', s:80},
    {n:'Core i7-12700', s:78},{n:'Core i7-12700F', s:76},
    {n:'Core i7-11700K', s:68},{n:'Core i7-11700', s:64},{n:'Core i7-11700F', s:64},
    {n:'Core i7-10700K', s:62},{n:'Core i7-10700', s:58},{n:'Core i7-10700F', s:58},
    {n:'Core i7-9700K', s:55},{n:'Core i7-9700', s:50},{n:'Core i7-9700F', s:50},
    {n:'Core i7-8700K', s:50},{n:'Core i7-8700', s:46},
    {n:'Core i7-7700K', s:38},{n:'Core i7-7700', s:35},
    {n:'Core i7-6700K', s:32},{n:'Core i7-6700', s:30},
    {n:'Core i5-14600K', s:82},{n:'Core i5-14600KF', s:82},
    {n:'Core i5-14600', s:74},{n:'Core i5-14500', s:72},{n:'Core i5-14400', s:70},
    {n:'Core i5-14400F', s:70},
    {n:'Core i5-13600K', s:80},{n:'Core i5-13600KF', s:80},
    {n:'Core i5-13500', s:72},{n:'Core i5-13400', s:68},{n:'Core i5-13400F', s:68},
    {n:'Core i5-12600K', s:75},{n:'Core i5-12600KF', s:75},
    {n:'Core i5-12500', s:68},{n:'Core i5-12400', s:68},{n:'Core i5-12400F', s:66},
    {n:'Core i5-11600K', s:60},{n:'Core i5-11400', s:58},{n:'Core i5-11400F', s:56},
    {n:'Core i5-10600K', s:52},{n:'Core i5-10400', s:50},{n:'Core i5-10400F', s:48},
    {n:'Core i5-9600K', s:42},{n:'Core i5-9400F', s:38},
    {n:'Core i5-8600K', s:40},{n:'Core i5-8400', s:36},
    {n:'Core i3-14100', s:55},{n:'Core i3-14100F', s:55},
    {n:'Core i3-13100', s:52},{n:'Core i3-13100F', s:52},
    {n:'Core i3-12100', s:52},{n:'Core i3-12100F', s:50},
    {n:'Core i3-10100', s:38},{n:'Core i3-10100F', s:36}
  ].sort(function(a,b){ return b.s - a.s; });

  /* Game requirements (Time Spy scores needed) */
  var GAME_REQS = {
    fortnite:   { FHD:6000, WQHD:10000, '4K':18000, n:'Fortnite' },
    apex:       { FHD:7000, WQHD:12000, '4K':20000, n:'Apex Legends' },
    valorant:   { FHD:3000, WQHD:5000,  '4K':10000, n:'VALORANT' },
    minecraft:  { FHD:3000, WQHD:6000,  '4K':12000, n:'Minecraft' },
    genshin:    { FHD:5000, WQHD:9000,  '4K':16000, n:'原神' },
    starrail:   { FHD:6000, WQHD:10000, '4K':18000, n:'崩壊：スターレイル' },
    zzz:        { FHD:6000, WQHD:10000, '4K':18000, n:'ゼンレスゾーンゼロ' },
    wuwa:       { FHD:6000, WQHD:10000, '4K':18000, n:'鳴潮' },
    ff14:       { FHD:7000, WQHD:12000, '4K':20000, n:'FF14' },
    ff16:       { FHD:9000, WQHD:15000, '4K':24000, n:'FF16' },
    mhwilds:    { FHD:10000,WQHD:16000, '4K':24000, n:'モンハンワイルズ' },
    eldenring:  { FHD:8000, WQHD:14000, '4K':22000, n:'ELDEN RING' },
    gtav:       { FHD:5000, WQHD:9000,  '4K':16000, n:'GTA V' },
    gta6:       { FHD:12000,WQHD:20000, '4K':30000, n:'GTA VI' },
    cod:        { FHD:7000, WQHD:12000, '4K':20000, n:'CoD: BO6' },
    r6s:        { FHD:4000, WQHD:7000,  '4K':14000, n:'R6S' },
    sf6:        { FHD:7000, WQHD:12000, '4K':20000, n:'ストリートファイター6' },
    tekken8:    { FHD:8000, WQHD:13000, '4K':22000, n:'鉄拳8' },
    lol:        { FHD:2000, WQHD:4000,  '4K':8000,  n:'LoL' },
    overwatch:  { FHD:5000, WQHD:9000,  '4K':16000, n:'オーバーウォッチ2' },
    pubg:       { FHD:6000, WQHD:10000, '4K':18000, n:'PUBG' },
    rust:       { FHD:7000, WQHD:12000, '4K':20000, n:'Rust' },
    palworld:   { FHD:7000, WQHD:12000, '4K':20000, n:'パルワールド' },
    ark:        { FHD:8000, WQHD:14000, '4K':22000, n:'ARK: SA' },
    cyberpunk:  { FHD:9000, WQHD:16000, '4K':26000, n:'サイバーパンク2077' },
    hogwarts:   { FHD:8000, WQHD:14000, '4K':22000, n:'ホグワーツレガシー' },
    deadspace:  { FHD:7000, WQHD:12000, '4K':20000, n:'Dead Space' },
    tarkov:     { FHD:7000, WQHD:12000, '4K':20000, n:'タルコフ' },
    dbd:        { FHD:4000, WQHD:7000,  '4K':14000, n:'Dead by Daylight' },
    roblox:     { FHD:2000, WQHD:4000,  '4K':8000,  n:'Roblox' },
    amongus:    { FHD:1000, WQHD:2000,  '4K':4000,  n:'Among Us' },
    forza6:     { FHD:11690,WQHD:15650, '4K':22500, n:'Forza Horizon 6' },
    meccha_chameleon: { FHD:3000, WQHD:4500, '4K':7000, n:'めっちゃカメレオン' },
    beast_reincarnation: { FHD:11690, WQHD:15650, '4K':22500, n:'Beast of Reincarnation' },
    marvel_tokon: { FHD:8800, WQHD:10500, '4K':13900, n:'MARVEL TŌKON: Fighting Souls' }
  };

  var scSel = { gpu:null, gpuScore:0, cpu:null, cpuScore:0, mem:0, games:[], res:null };

  /* --- Searchable dropdown --- */
  function setupSearch(inputId, dropId, selId, list, type) {
    var input = $(inputId), drop = $(dropId), selEl = $(selId);

    function renderDrop(filter) {
      var f = (filter||'').toLowerCase();
      var items = list.filter(function(it){ return !f || it.n.toLowerCase().indexOf(f) >= 0; }).slice(0, 20);
      drop.innerHTML = items.map(function(it){
        return '<div class="wz-sc-drop-item" data-n="'+it.n+'" data-s="'+it.s+'">'
          + it.n + '<span class="wz-sc-drop-score">' + it.s.toLocaleString() + ' pt</span></div>';
      }).join('');
      drop.classList.toggle('open', items.length > 0 && document.activeElement === input);
    }

    input.addEventListener('focus', function(){ renderDrop(input.value); });
    input.addEventListener('input', function(){ renderDrop(input.value); });
    input.addEventListener('blur', function(){ setTimeout(function(){ drop.classList.remove('open'); }, 200); });

    drop.addEventListener('click', function(e){
      var item = e.target.closest('.wz-sc-drop-item'); if (!item) return;
      var name = item.dataset.n, score = parseInt(item.dataset.s);
      if (type === 'gpu') { scSel.gpu = name; scSel.gpuScore = score; }
      else { scSel.cpu = name; scSel.cpuScore = score; }
      input.value = '';
      drop.classList.remove('open');
      selEl.innerHTML = '<span class="wz-sc-sel-chip">' + name + ' <span class="wz-sc-sel-pts">' + score.toLocaleString() + ' pt</span></span>';
      checkScN1();
    });
  }

  setupSearch('wzScGpuSearch', 'wzScGpuDrop', 'wzScGpuSelected', GPU_LIST, 'gpu');
  setupSearch('wzScCpuSearch', 'wzScCpuDrop', 'wzScCpuSelected', CPU_LIST, 'cpu');

  /* --- Auto-detect GPU via WebGL --- */
  (function(){
    try {
      var canvas = document.createElement('canvas');
      var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl) return;
      var ext = gl.getExtension('WEBGL_debug_renderer_info');
      if (!ext) return;
      var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) || '';
      if (!renderer) return;

      /* Clean up renderer string: "ANGLE (NVIDIA, NVIDIA GeForce RTX 3060 Direct3D11...)" → "RTX 3060" */
      var clean = renderer
        .replace(/ANGLE\s*\(/i, '')
        .replace(/Direct3D.*$/i, '')
        .replace(/OpenGL.*$/i, '')
        .replace(/Vulkan.*$/i, '')
        .replace(/,\s*$/, '')
        .replace(/\)$/, '')
        .trim();

      /* Try to match against GPU_LIST */
      var matched = null;
      var cleanLower = clean.toLowerCase();
      /* Sort by name length desc for best match */
      var sorted = GPU_LIST.slice().sort(function(a,b){ return b.n.length - a.n.length; });
      for (var i = 0; i < sorted.length; i++) {
        if (cleanLower.indexOf(sorted[i].n.toLowerCase()) >= 0) {
          matched = sorted[i]; break;
        }
      }
      /* Also try without spaces */
      if (!matched) {
        var nosp = cleanLower.replace(/\s/g, '');
        for (var i = 0; i < sorted.length; i++) {
          if (nosp.indexOf(sorted[i].n.toLowerCase().replace(/\s/g, '')) >= 0) {
            matched = sorted[i]; break;
          }
        }
      }

      if (matched) {
        scSel.gpu = matched.n; scSel.gpuScore = matched.s;
        $('wzScGpuSearch').value = '';
        $('wzScGpuSelected').innerHTML = '<span class="wz-sc-sel-chip">🔍 ' + matched.n + ' (自動検出) <span class="wz-sc-sel-pts">' + matched.s.toLocaleString() + ' pt</span></span>';
        checkScN1();
      } else if (clean.length > 3) {
        /* Show detected string as hint */
        $('wzScGpuSearch').placeholder = '検出: ' + clean.substring(0, 40) + '（リストから選択してください）';
      }
    } catch(e) { /* WebGL not available */ }
  })();

  /* --- Smart CPU detection --- */
  (function(){
    var cores = navigator.hardwareConcurrency || 0;
    var isIntelPlatform = false;
    var isAmdPlatform = false;

    /* Check WebGL for GPU vendor → platform hint */
    try {
      var c = document.createElement('canvas');
      var g = c.getContext('webgl') || c.getContext('experimental-webgl');
      if (g) {
        var ext = g.getExtension('WEBGL_debug_renderer_info');
        if (ext) {
          var vendor = (g.getParameter(ext.UNMASKED_VENDOR_WEBGL) || '').toLowerCase();
          var renderer = (g.getParameter(ext.UNMASKED_RENDERER_WEBGL) || '').toLowerCase();
          /* If using Intel integrated GPU, user likely has Intel CPU */
          if (vendor.indexOf('intel') >= 0 || renderer.indexOf('intel') >= 0) {
            if (renderer.indexOf('uhd') >= 0 || renderer.indexOf('iris') >= 0 || renderer.indexOf('hd graphics') >= 0) {
              isIntelPlatform = true;
            }
          }
          /* AMD integrated (Vega, RDNA iGPU) = AMD CPU */
          if (renderer.indexOf('vega') >= 0 || renderer.indexOf('radeon(tm) graphics') >= 0 || renderer.indexOf('radeon graphics') >= 0) {
            isAmdPlatform = true;
          }
        }
      }
    } catch(e){}

    /* Thread count → likely CPU mapping */
    var THREAD_MAP = {
      4:  [{n:'Core i3-10100',p:'intel'},{n:'Core i3-10100F',p:'intel'},{n:'Ryzen 3 3100',p:'amd'},{n:'Core i7-7700K',p:'intel'},{n:'Core i7-7700',p:'intel'},{n:'Core i7-6700K',p:'intel'}],
      6:  [{n:'Core i5-9400F',p:'intel'},{n:'Core i5-9600K',p:'intel'},{n:'Ryzen 5 1600',p:'amd'}],
      8:  [{n:'Core i7-9700K',p:'intel'},{n:'Core i7-9700',p:'intel'},{n:'Core i3-12100',p:'intel'},{n:'Core i3-12100F',p:'intel'},{n:'Core i3-13100',p:'intel'},{n:'Core i3-14100',p:'intel'},{n:'Ryzen 7 1700X',p:'amd'},{n:'Ryzen 3 3300X',p:'amd'}],
      12: [{n:'Ryzen 5 5600X',p:'amd'},{n:'Ryzen 5 5600',p:'amd'},{n:'Ryzen 5 5500',p:'amd'},{n:'Ryzen 5 3600',p:'amd'},{n:'Ryzen 5 7600X',p:'amd'},{n:'Ryzen 5 7600',p:'amd'},{n:'Ryzen 5 9600X',p:'amd'},{n:'Core i5-12400',p:'intel'},{n:'Core i5-12400F',p:'intel'},{n:'Core i5-11400',p:'intel'}],
      16: [{n:'Ryzen 7 5700X',p:'amd'},{n:'Ryzen 7 5800X',p:'amd'},{n:'Ryzen 7 5800X3D',p:'amd'},{n:'Ryzen 7 7700X',p:'amd'},{n:'Ryzen 7 7700',p:'amd'},{n:'Ryzen 7 7800X3D',p:'amd'},{n:'Ryzen 7 9800X3D',p:'amd'},{n:'Ryzen 7 9700X',p:'amd'},{n:'Ryzen 7 3700X',p:'amd'},{n:'Core i7-11700K',p:'intel'},{n:'Core i7-11700',p:'intel'},{n:'Core i7-10700K',p:'intel'},{n:'Core i9-9900K',p:'intel'},{n:'Core i7-8700K',p:'intel'}],
      20: [{n:'Core i7-12700K',p:'intel'},{n:'Core i7-12700',p:'intel'},{n:'Core i7-12700F',p:'intel'},{n:'Core i5-13600K',p:'intel'},{n:'Core i5-14600K',p:'intel'},{n:'Core i7-13700',p:'intel'},{n:'Core i7-14700',p:'intel'},{n:'Core i7-14700F',p:'intel'}],
      24: [{n:'Ryzen 9 5900X',p:'amd'},{n:'Ryzen 9 7900X',p:'amd'},{n:'Core i7-13700K',p:'intel'},{n:'Core i7-14700K',p:'intel'},{n:'Core i9-12900K',p:'intel'},{n:'Core i9-13900',p:'intel'},{n:'Core i9-14900',p:'intel'}],
      28: [{n:'Core i5-14500',p:'intel'}],
      32: [{n:'Ryzen 9 5950X',p:'amd'},{n:'Ryzen 9 7950X',p:'amd'},{n:'Ryzen 9 9950X',p:'amd'},{n:'Core i9-13900K',p:'intel'},{n:'Core i9-14900K',p:'intel'}]
    };

    if (!cores) return;

    /* Find candidates */
    var candidates = THREAD_MAP[cores] || [];
    /* Filter by platform if detected */
    if (isIntelPlatform) {
      candidates = candidates.filter(function(c){ return c.p === 'intel'; });
    } else if (isAmdPlatform) {
      candidates = candidates.filter(function(c){ return c.p === 'amd'; });
    }

    if (candidates.length === 0) {
      $('wzScCpuSearch').placeholder = 'CPUを検索（' + cores + 'スレッド検出）';
      return;
    }

    /* If only 1-2 candidates, auto-suggest first one */
    if (candidates.length <= 2) {
      /* Auto-select first match */
      var match = null;
      for (var i = 0; i < CPU_LIST.length; i++) {
        if (CPU_LIST[i].n === candidates[0].n) { match = CPU_LIST[i]; break; }
      }
      if (match) {
        scSel.cpu = match.n; scSel.cpuScore = match.s;
        $('wzScCpuSearch').value = '';
        $('wzScCpuSelected').innerHTML = '<span class="wz-sc-sel-chip">🔍 ' + match.n + ' (自動検出) <span class="wz-sc-sel-pts">' + match.s + ' pt</span></span>';
        checkScN1();
        return;
      }
    }

    /* Multiple candidates: show as suggestions in placeholder + pre-populate dropdown */
    var platformLabel = isIntelPlatform ? 'Intel' : (isAmdPlatform ? 'AMD' : '');
    $('wzScCpuSearch').placeholder = cores + 'スレッド' + (platformLabel ? '/' + platformLabel : '') + '検出 — タップで候補表示';

    /* Override the dropdown to show candidates first */
    var cpuDrop = $('wzScCpuDrop');
    var cpuInput = $('wzScCpuSearch');
    cpuInput.addEventListener('focus', function onFirstFocus(){
      if (cpuInput.value === '' && !scSel.cpu) {
        /* Show candidates at top */
        var html = '<div style="padding:6px 14px;font-size:11px;font-weight:700;color:#C026D3;background:#f8fafc;border-bottom:1px solid #e2e8f0">🔍 ' + cores + 'スレッドのCPU候補</div>';
        candidates.forEach(function(c){
          var cpuData = CPU_LIST.find(function(x){ return x.n === c.n; });
          if (cpuData) {
            html += '<div class="wz-sc-drop-item" data-n="' + cpuData.n + '" data-s="' + cpuData.s + '" style="background:rgba(255,31,117,.02)">' + cpuData.n + '<span class="wz-sc-drop-score">' + cpuData.s + ' pt</span></div>';
          }
        });
        html += '<div style="padding:6px 14px;font-size:11px;color:#94a3b8;border-top:1px solid #e2e8f0;border-bottom:1px solid #e2e8f0">その他のCPU</div>';
        /* Add remaining CPUs */
        var shown = candidates.map(function(c){ return c.n; });
        CPU_LIST.filter(function(x){ return shown.indexOf(x.n) < 0; }).slice(0,15).forEach(function(x){
          html += '<div class="wz-sc-drop-item" data-n="' + x.n + '" data-s="' + x.s + '">' + x.n + '<span class="wz-sc-drop-score">' + x.s + ' pt</span></div>';
        });
        cpuDrop.innerHTML = html;
        cpuDrop.classList.add('open');
      }
    }, {once: false});
  })();

  /* --- Memory buttons --- */
  root.querySelectorAll('.wz-sc-mem').forEach(function(btn){
    btn.addEventListener('click', function(){
      root.querySelectorAll('.wz-sc-mem').forEach(function(b){ b.classList.remove('on'); });
      btn.classList.add('on');
      scSel.mem = parseInt(btn.dataset.mem);
      checkScN1();
    });
  });

  function checkScN1() {
    $('wzScN1').disabled = !(scSel.gpu && scSel.cpu && scSel.mem > 0);
  }

  /* --- Game grid (score tab) --- */
  var SC_GAMES = [
    {k:'fortnite',n:'Fortnite'},{k:'apex',n:'Apex Legends'},{k:'valorant',n:'VALORANT'},
    {k:'cod',n:'CoD: BO6'},{k:'overwatch',n:'OW2'},{k:'pubg',n:'PUBG'},
    {k:'genshin',n:'原神'},{k:'starrail',n:'崩スタ'},{k:'zzz',n:'ゼンゼロ'},
    {k:'wuwa',n:'鳴潮'},{k:'mhwilds',n:'モンハンワイルズ'},{k:'eldenring',n:'ELDEN RING'},
    {k:'ff14',n:'FF14'},{k:'ff16',n:'FF16'},{k:'cyberpunk',n:'サイバーパンク'},
    {k:'palworld',n:'パルワールド'},{k:'tarkov',n:'タルコフ'},{k:'rust',n:'Rust'},
    {k:'tekken8',n:'鉄拳8'},{k:'sf6',n:'スト6'},{k:'lol',n:'LoL'},
    {k:'roblox',n:'Roblox'},{k:'minecraft',n:'マイクラ'},{k:'dbd',n:'DbD'},
    {k:'hogwarts',n:'ホグワーツ'},{k:'ark',n:'ARK: SA'},{k:'gta6',n:'GTA VI'},
    {k:'gtav',n:'GTA V'},{k:'r6s',n:'R6S'},{k:'amongus',n:'Among Us'},
    {k:'forza6',n:'Forza Horizon 6'},{k:'meccha_chameleon',n:'めっちゃカメレオン'},
    {k:'beast_reincarnation',n:'Beast of Reincarnation'},
    {k:'marvel_tokon',n:'MARVEL TŌKON: Fighting Souls'}
  ];
  var scGGrid = $('wzScGames');
  scGGrid.innerHTML = SC_GAMES.map(function(g){ return '<button class="wz-tile" data-sgk="'+g.k+'">'+g.n+'</button>'; }).join('');
  scGGrid.addEventListener('click', function(e){
    var t = e.target.closest('[data-sgk]'); if (!t) return;
    var k = t.dataset.sgk, i = scSel.games.indexOf(k);
    if (i >= 0) scSel.games.splice(i, 1); else scSel.games.push(k);
    scGGrid.querySelectorAll('.wz-tile').forEach(function(t2){ t2.classList.toggle('on', scSel.games.indexOf(t2.dataset.sgk) >= 0); });
    checkScDiag();
  });

  /* --- Resolution (score tab) --- */
  root.querySelectorAll('[data-field="sc_res"] .wz-opt').forEach(function(opt){
    opt.addEventListener('click', function(){
      root.querySelectorAll('[data-field="sc_res"] .wz-opt').forEach(function(o){ o.classList.remove('on'); });
      opt.classList.add('on');
      scSel.res = opt.dataset.v;
      checkScDiag();
    });
  });

  function checkScDiag() {
    $('wzScDiag').disabled = !(scSel.games.length > 0 && scSel.res);
  }

  /* --- Step navigation --- */
  function scGo(n) {
    currentScStep = n;
    root.querySelectorAll('.wz-sc').forEach(function(s){ s.classList.remove('active'); });
    var target = root.querySelector('[data-sc="'+n+'"]');
    if (target) target.classList.add('active');
    var winEl = document.getElementById('wzWin');
    if (winEl) {
      var rect = winEl.getBoundingClientRect();
      if (rect.top < -10 || rect.top > window.innerHeight * 0.4) {
        window.scrollTo({top: rect.top + window.scrollY - 20, behavior:'smooth'});
      }
    }
  }

  $('wzScStart').addEventListener('click', function(){ scGo(1); });
  $('wzScBack1').addEventListener('click', function(){ scGo(0); });
  $('wzScN1').addEventListener('click', function(){ scGo(2); });
  $('wzScBack2').addEventListener('click', function(){ scGo(1); });
  $('wzScToDiag').addEventListener('click', function(){
    /* Switch to diag tab */
    root.querySelectorAll('.wz-tab').forEach(function(t){ t.classList.remove('active'); });
    root.querySelector('[data-tab="diag"]').classList.add('active');
    scorePanel.style.display = 'none';
    diagPanel.style.display = '';
  });

  $('wzScRetry').addEventListener('click', function(){
    scSel.games = []; scSel.res = null;
    scGGrid.querySelectorAll('.wz-tile').forEach(function(t){ t.classList.remove('on'); });
    root.querySelectorAll('[data-field="sc_res"] .wz-opt').forEach(function(o){ o.classList.remove('on'); });
    $('wzScDiag').disabled = true;
    scGo(1);
  });

  /* --- Scoring logic --- */
  $('wzScDiag').addEventListener('click', function(){ runScore(); });

  function runScore() {
    var gpuS = scSel.gpuScore;
    var cpuS = scSel.cpuScore;
    var memS = scSel.mem;

    /* Overall score: GPU 60%, CPU 25%, RAM 15% */
    var gpuNorm = Math.min(gpuS / 33000 * 100, 100);
    var cpuNorm = cpuS; /* already 0-100 */
    var memNorm = memS >= 32 ? 100 : (memS >= 16 ? 75 : (memS >= 8 ? 40 : 20));
    var total = Math.round(gpuNorm * 0.6 + cpuNorm * 0.25 + memNorm * 0.15);

    var grade, gradeCls;
    if (total >= 85) { grade = 'S'; gradeCls = 'wz-sc-grade-s'; }
    else if (total >= 70) { grade = 'A'; gradeCls = 'wz-sc-grade-a'; }
    else if (total >= 50) { grade = 'B'; gradeCls = 'wz-sc-grade-b'; }
    else if (total >= 30) { grade = 'C'; gradeCls = 'wz-sc-grade-c'; }
    else { grade = 'D'; gradeCls = 'wz-sc-grade-d'; }

    /* Game-by-game scoring */
    var gameHtml = '';
    scSel.games.forEach(function(gk){
      var req = GAME_REQS[gk]; if (!req) return;
      var needed = req[scSel.res] || req.FHD;
      var pct = Math.min(Math.round(gpuS / needed * 100), 150);
      var barW = Math.min(pct, 100);
      var verdict, vCls, barCls;
      if (pct >= 120) { verdict = '快適'; vCls = 'v-great'; barCls = 'bar-great'; }
      else if (pct >= 80) { verdict = 'OK'; vCls = 'v-good'; barCls = 'bar-good'; }
      else if (pct >= 50) { verdict = 'ギリギリ'; vCls = 'v-ok'; barCls = 'bar-ok'; }
      else { verdict = '厳しい'; vCls = 'v-bad'; barCls = 'bar-bad'; }

      gameHtml += '<div class="wz-sc-game-row">'
        + '<span class="wz-sc-game-name">' + req.n + '</span>'
        + '<div style="flex:1!important;height:20px!important;background:#e2e8f0!important;border-radius:10px!important;overflow:hidden!important;position:relative!important;display:block!important"><div style="height:20px!important;border-radius:10px!important;position:absolute!important;left:0!important;top:0!important;display:block!important;width:' + barW + '%!important;transition:width .8s ease!important;background:' + ({great:'linear-gradient(90deg,#22c55e,#16a34a)',good:'linear-gradient(90deg,#C026D3,#22c55e)',ok:'linear-gradient(90deg,#f59e0b,#eab308)',bad:'linear-gradient(90deg,#ef4444,#f59e0b)'}[barCls.replace('bar-','')]) + '!important"></div></div>'
        + '<span class="wz-sc-game-verdict ' + vCls + '">' + verdict + '</span>'
        + '</div>';
    });

    /* Find recommended TITAN GPU */
    var TITAN_GPUS = [
      {n:'RTX 5050', s:10259, p:155000},
      {n:'RTX 5060', s:13900, p:166000},
      {n:'RX 9060 XT', s:16200, p:161000},
      {n:'RTX 5060 Ti', s:15200, p:188000},
      {n:'RTX 5070', s:22500, p:260000},
      {n:'RX 9070', s:26300, p:254000},
      {n:'RTX 5070 Ti', s:27700, p:351000},
      {n:'RX 9070 XT', s:29900, p:291000},
      {n:'RTX 5080', s:33000, p:416000}
    ];
    /* Find a GPU that's at least 30% better */
    var recGpu = null;
    for (var i = 0; i < TITAN_GPUS.length; i++) {
      if (TITAN_GPUS[i].s > gpuS * 1.3) { recGpu = TITAN_GPUS[i]; break; }
    }
    /* Don't recommend if user's GPU is already stronger than our best */
    if (!recGpu) recGpu = null;

    var resultHtml = '<div class="wz-sc-score-hero">'
      + '<div class="wz-sc-score-num">' + total + '</div>'
      + '<div class="wz-sc-score-max">/ 100</div>'
      + '<div class="wz-sc-score-grade ' + gradeCls + '">ランク ' + grade + '</div>'
      + '</div>'
      + '<div class="wz-sc-breakdown">'
      + '<div class="wz-sc-bk-item"><span class="wz-sc-bk-label">GPU</span><span class="wz-sc-bk-val">' + Math.round(gpuNorm) + '</span><div style="width:100%!important;height:10px!important;background:#e2e8f0!important;border-radius:5px!important;overflow:hidden!important;margin:8px 0 6px!important;display:block!important"><div style="width:' + Math.round(gpuNorm) + '%!important;height:10px!important;background:linear-gradient(90deg,#C026D3,#6366f1)!important;border-radius:5px!important;display:block!important;transition:width .8s ease!important"></div></div><span class="wz-sc-bk-name">' + scSel.gpu + '</span></div>'
      + '<div class="wz-sc-bk-item"><span class="wz-sc-bk-label">CPU</span><span class="wz-sc-bk-val">' + cpuS + '</span><div style="width:100%!important;height:10px!important;background:#e2e8f0!important;border-radius:5px!important;overflow:hidden!important;margin:8px 0 6px!important;display:block!important"><div style="width:' + cpuS + '%!important;height:10px!important;background:linear-gradient(90deg,#059669,#34d399)!important;border-radius:5px!important;display:block!important;transition:width .8s ease!important"></div></div><span class="wz-sc-bk-name">' + scSel.cpu + '</span></div>'
      + '<div class="wz-sc-bk-item"><span class="wz-sc-bk-label">RAM</span><span class="wz-sc-bk-val">' + memNorm + '</span><div style="width:100%!important;height:10px!important;background:#e2e8f0!important;border-radius:5px!important;overflow:hidden!important;margin:8px 0 6px!important;display:block!important"><div style="width:' + memNorm + '%!important;height:10px!important;background:linear-gradient(90deg,#d97706,#fbbf24)!important;border-radius:5px!important;display:block!important;transition:width .8s ease!important"></div></div><span class="wz-sc-bk-name">' + memS + 'GB</span></div>'
      + '</div>';

    if (gameHtml) {
      resultHtml += '<div class="wz-sc-game-scores"><h3>🎮 ゲーム別 快適度（' + (scSel.res === 'FHD' ? 'フルHD' : scSel.res) + '）</h3>' + gameHtml + '</div>';
    }

    $('wzScResult').innerHTML = resultHtml;

    /* Compare section */
    var compareHtml = '';
    if (!recGpu || recGpu.s <= gpuS) {
      /* User's GPU is already top-tier */
      compareHtml = '<h3>💪 すでにハイスペック！</h3>'
        + '<div style="padding:20px;border:2px solid #22c55e;border-radius:12px;background:rgba(34,197,94,.04);text-align:center">'
        + '<div style="font-size:32px;margin-bottom:8px">👑</div>'
        + '<div style="font-size:16px;font-weight:800;color:#16a34a;margin-bottom:6px">あなたのGPUは十分高性能です</div>'
        + '<div style="font-size:13px;color:#475569">' + scSel.gpu + '（' + gpuS.toLocaleString() + ' pt）は当店の最上位構成と同等以上の性能です。</div>'
        + '</div>';
    } else if (recGpu) {
      var uplift = Math.round((recGpu.s / gpuS - 1) * 100);
      var recScore = Math.min(Math.round(recGpu.s / 33000 * 100), 100);
      var searchQ = encodeURIComponent('"' + recGpu.n + '"');
      compareHtml = '<h3>⚡ TITAN GamingのPCなら</h3>'
        + '<div class="wz-sc-vs">'
        + '<div class="wz-sc-vs-card wz-sc-vs-yours">'
        + '<div class="wz-sc-vs-label">今のPC</div>'
        + '<div class="wz-sc-vs-gpu">' + scSel.gpu + '</div>'
        + '<div class="wz-sc-vs-score">' + gpuS.toLocaleString() + ' pt</div>'
        + '</div>'
        + '<div class="wz-sc-vs-arrow">→</div>'
        + '<div class="wz-sc-vs-card wz-sc-vs-titan">'
        + '<div class="wz-sc-vs-label">TITAN Gaming</div>'
        + '<div class="wz-sc-vs-gpu">' + recGpu.n + '</div>'
        + '<div class="wz-sc-vs-score">' + recGpu.s.toLocaleString() + ' pt</div>'
        + '<div class="wz-sc-vs-diff">+' + uplift + '% 性能アップ / ¥' + recGpu.p.toLocaleString() + '〜</div>'
        + '<a href="https://www.titan-pc.net/search?q=' + searchQ + '" class="wz-sc-vs-btn">この構成を見る →</a>'
        + '</div>'
        + '</div>';
    }
    $('wzScCompare').innerHTML = compareHtml;

    /* Capture for sharing */
    lastScoreResult = {
      gpu: scSel.gpu, gpuScore: gpuS, cpu: scSel.cpu, cpuScore: scSel.cpuScore,
      mem: memS, games: scSel.games.slice(), res: scSel.res,
      total: total, grade: grade,
      recGpu: (recGpu && recGpu.s > gpuS) ? recGpu.n : null,
      recGpuPrice: (recGpu && recGpu.s > gpuS) ? recGpu.p : 0,
      uplift: (recGpu && recGpu.s > gpuS) ? Math.round((recGpu.s / gpuS - 1) * 100) : 0,
      ts: Date.now()
    };
    try { localStorage.setItem('wz_sc_prev', JSON.stringify(lastScoreResult)); } catch(e){}

    scGo(3);

    /* Show share section */
    var scShare = $('wzScShareSection');
    if (scShare) scShare.style.display = '';
  }

  /* --- Score tab SNS share --- */
  var SC_SHARE_URL = 'https://www.titan-pc.net/pages/%E3%82%B2%E3%83%BC%E3%83%A0%E3%81%8B%E3%82%89%E9%81%B8%E3%81%B6';
  var lastScoreResult = {};

  function buildScShareText() {
    var r = lastScoreResult;
    var text = '📊 TITAN Gaming PC採点の結果\n';
    text += '自分のPC（' + (r.gpu || '?') + '）のスコア: ' + (r.total || 0) + '点（ランク' + (r.grade || '?') + '）\n';
    if (r.recGpu && r.uplift > 0) {
      text += 'おすすめ: ' + r.recGpu + ' なら+' + r.uplift + '%性能UP！\n';
    } else if (r.total >= 85) {
      text += '十分ハイスペック！💪\n';
    }
    text += '\n#TITANGaming #PC採点';
    return text;
  }

  /* Store result for sharing */
  var origRunScore = runScore;
  /* We'll capture data inside runScore instead - add to the end of runScore */

  $('wzScShareX').addEventListener('click', function(){
    var text = buildScShareText();
    window.open('https://x.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(SC_SHARE_URL), '_blank');
  });
  $('wzScShareLine').addEventListener('click', function(){
    var text = buildScShareText() + '\n' + SC_SHARE_URL;
    window.open('https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(SC_SHARE_URL) + '&text=' + encodeURIComponent(text), '_blank');
  });
  $('wzScShareCopy').addEventListener('click', function(){
    var text = buildScShareText() + '\n' + SC_SHARE_URL;
    var btn = this;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function(){
        btn.classList.add('wz-copied'); btn.querySelector('span').textContent = 'コピー済み';
        var toast = document.getElementById('wzToast');
        if (toast) { toast.textContent = 'クリップボードにコピーしました'; toast.classList.add('wz-toast-show'); setTimeout(function(){ toast.classList.remove('wz-toast-show'); }, 2500); }
        setTimeout(function(){ btn.classList.remove('wz-copied'); btn.querySelector('span').textContent = '内容コピー'; }, 3000);
      });
    }
  });

  /* Hide share on retry */
  var origRetryHandler = $('wzScRetry').onclick;
  $('wzScRetry').addEventListener('click', function(){
    var scShare = $('wzScShareSection');
    if (scShare) scShare.style.display = 'none';
  });

  /* --- Save/Restore previous score --- */
  (function(){
    try {
      var raw = localStorage.getItem('wz_sc_prev');
      if (!raw) return;
      var prev = JSON.parse(raw);
      if (!prev || !prev.gpu || !prev.total) { localStorage.removeItem('wz_sc_prev'); return; }
      if (Date.now() - prev.ts > 30 * 24 * 60 * 60 * 1000) { localStorage.removeItem('wz_sc_prev'); return; }
      var btn = $('wzScPrev');
      if (btn) btn.style.display = '';
    } catch(e){}
  })();

  $('wzScPrev').addEventListener('click', function(){
    try {
      var raw = localStorage.getItem('wz_sc_prev');
      if (!raw) return;
      var prev = JSON.parse(raw);
      if (!prev || !prev.gpu) return;
      /* Restore selections */
      scSel.gpu = prev.gpu; scSel.gpuScore = prev.gpuScore;
      scSel.cpu = prev.cpu; scSel.cpuScore = prev.cpuScore;
      scSel.mem = prev.mem; scSel.games = prev.games || []; scSel.res = prev.res;
      /* Re-run score calculation */
      runScore();
    } catch(e){}
  });

})();
})();
/* rev: 2026-08-16 final-total */
